/*************************************
 *
 * MX Spanish Strings
 *
 **************************************/

const es_mx = {
    Schedule_document_has_warning_validations: "El documento de programación tiene validaciones de advertencia",
    View_Campaign_Analytics: "Ver análisis de campañas",
    Create_Campaigns: "Crear campañas",
    Edit_Campaigns: "Editar campañas",
    Delete_Campaigns: "Eliminar campañas",
    View_File: "Ver archivo",
    Add_File: "Agregar archivo",
    Delete_File: "Eliminar archivo",
    View_Mobilize: "Ver Movilizar",
    Delete_Message: "Eliminar mensaje",
    Enable_user_effective_Doc: "Habilitar el uso efectivo de Doc",
    Approved_by_on: "Aprobado por: {0} el {1}",
    Rejected_by_on: "Rechazada por: {0} en {1}",
    Export_Payroll_is_requested_already_Are_you_sure_you_want_to_ignore_previous_request_and_export: "Ya se solicitó la exportación de nómina. ¿Está seguro de que desea ignorar la solicitud anterior y exportar?",
    select_a_job: "Seleccione un trabajo",
    Enable_Probation_Date: "Habilitar fecha de prueba",
    Are_you_sure_you_want_to_update_payroll_settings: "¿Está seguro de que desea actualizar la configuración de la nómina?",
    Edit_Payroll_Settings: "Editar configuración de nómina",
    Allow_Access_To_All_Job_Postings: "Permitir acceso a todas las ofertas de trabajo",
    View_Job_Postings: "Ver ofertas de trabajo",
    Add_Job_Postings: "Agregar anuncios de trabajo",
    Edit_Job_Postings: "Editar ofertas de trabajo",
    Delete_Job_Postings: "Eliminar ofertas de trabajo",
    Delete_Extra_Day: "Eliminar día extra",
    Day_cannot_be_deleted_because_shifts_are_scheduled: "No se puede eliminar el día porque hay turnos programados.",
    Are_you_sure_you_want_to_delete_empty_extra_day: "¿Estás segura de que quieres eliminar el día extra vacío?",
    Manual_Entries_Report: "Informe de entradas manuales",
    Allow_for_deletion_of_File_Versions: "Permitir la eliminación de versiones de archivos",
    Employee_Record_Report: "Informe de registro de empleados",
    Time_Expenses: "Gastos de tiempo",
    Monetary_Expenses: "Gastos Monetarios $",
    Report_cannot_include_more_than_1_month_Please_change_your_selected_dates: "El informe no puede incluir más de un mes. Cambie las fechas seleccionadas.",
    Expense_is_not_allowed_at_this_location: "No se permiten gastos en esta ubicación.",
    Disable_Expense: "Desactivar Gastos",
    IVR_Call: "Llamada IVR",
    Adjusted: "Equilibrado",
    Phone_number_is_not_valid: "El número de teléfono no es válido",
    Number_is_required: "El número es obligatorio.",
    Invalid_characters_Please_enter_numbers_only: "Caracteres no válidos. Introduzca únicamente números.",
    Number_is_duplicated: "El número está duplicado.",
    PayrollPPAExport: "Payroll PPA Export",
    Assigned_employee_not_exist: "El empleado asignado no existe",
    Cannot_unlock_selected_employees_because_payroll_hierarchy_locked: "No se pueden desbloquear los empleados seleccionados), porque la jerarquía de nómina está bloqueada",
    Cannot_lock_selected_employees_because_payroll_hirarchy_locked: "No se pueden bloquear los empleados seleccionados), porque la jerarquía de nómina está bloqueada",
    Cannot_unlock_selected_employees_because_exported_employee_exist: "No se pueden desbloquear los empleados seleccionados porque ya existen empleados exportados",
    Cannot_Unlock_Payroll_Employees: "No se pueden desbloquear los empleados de nómina",
    Cannot_lock_selected_employees_because_employee_unapproved_expenses_exist: "No se pueden bloquear los empleados seleccionados porque existen gastos no aprobados del empleado",
    Cannot_lock_selected_employees_because_employee_unapproved_punchset_exist: "No se pueden bloquear los empleados seleccionados porque existen registros no aprobados del empleado",
    Cannot_lock_selected_employees_because_supervisor_unapproved_expenses_exist: "No se pueden bloquear los empleados seleccionados porque existen gastos no aprobados por el supervisor",
    Cannot_lock_selected_employees_because_supervisor_unapproved_punchset_exist: "No se pueden bloquear los empleados seleccionados porque existen registros no aprobados por el supervisor",
    Cannot_lock_selected_employees_because_Missing_punch_exist: "No se pueden bloquear los empleados seleccionados porque faltan registros",
    Cannot_Lock_Selected_Employees: "No se puede bloquear a las empleadas seleccionadas",
    Cannot_Approve_PunchSet: "No se puede aprobar el conjunto de perforaciones",
    Unlock_Payroll_Employees: "Desbloquear empleados de nómina",
    Are_you_sure_you_want_to_unlock_payroll_employees: "¿Está seguro de que desea desbloquear los empleados de nómina?",
    Lock_Payroll_Employees: "Bloquear nómina de empleados",
    Are_you_sure_you_want_to_lock_payroll_employees: "¿Está seguro de que desea bloquear los empleados de nómina?",
    Add_Expense: "Agregar gasto",
    Add_PPA_Expense: "Añadir gasto de PPA",
    Update_Expense: "Actualizar Gastos",
    Update_PPA_Expense: "Actualizar gastos de PPA",
    Delete_PPA_Expense: "Eliminar gasto de PPA",
    Expense_Audit_Records: "Registros de auditoría de gastos",
    You_have_not_permission: "No tienes permiso",
    Allow_Supervisor_To_Approve_Deny_Own_Leave_Requests: "Permitir que el supervisor apruebe o rechace sus propias solicitudes de licencia",
    Are_you_sure_you_want_to_clear_all_notifications: "¿Estás seguro de que deseas borrar todas las notificaciones?",
    Notifications: "Notificaciones",
    Not_match_days: "Días sin partido",
    Specify_Days: "Especificar días",
    Sort_By_Seniority_Date: "Ordenar por fecha de antigüedad",
    Hide_PunchSet: "Ocultar conjunto de punzones",
    Show_Day_Data: "Mostrar datos del día",
    Show_Week_Data: "Mostrar datos de la semana",
    Show_Employee_Data: "Mostrar datos de empleados",
    Group_PunchSet_Data_By: "Datos de conjunto de punzonado de grupo por",
    TimeoffExport: "Exportación de tiempo libre",
    Edit_Payroll_After_Lock: "Editar nómina después del bloqueo",
    Default: "Por defecto",
    Exceptions_Reports: "Informes de excepciones",
    Include_Punch_Photo: "Incluir foto de perforación",
    Verify_Files_Missing_Prerequisites: "Verificar archivos que faltan requisitos previos",
    Filter_By_Exception: "Filter By Exception",
    Account_Scheduled_Job: "Trabajo programado de cuenta",
    Account_Feature_Setting: "Configuración de funciones de cuenta",
    Create_New_Timeoff_Filter: "Crear nuevo filtro de tiempo libre",
    Edit_Timeoff_Filter: "Editar filtro de tiempo libre",
    Job_Timezone: "Zona horaria del trabajo",
    Enable_Job_Timezone: "Enable Job Timezone",
    Attendance_and_Emergency: "Asistencia y Emergencia",
    only_letters_hyphens_periods_and_spaces_are_allowed: "sólo se permiten letras, guiones, puntos y espacios",
    Exclude_PayTypes: "Excluir tipos de pago",
    this_paytype_not_allowed_by_role: "este tipo de pago no está permitido por rol",
    Allowed_Expense_Paytypes: "Tipos de pago de gastos permitidos",
    EmployeeTimecardTab: "Employee Timecard Tab",
    Advertise_Shift_To_Mobile_Users: "Anuncie Shift para usuarios de dispositivos móviles",
    Invalid_timeframe: "Plazo no válido",
    after_punch_in: "después de pinchar",
    and: "y",
    greater_than: "mas grande que",
    less_than: "menos que",
    This_question_will_only_be_asked_after_a_duration_of: "Esta pregunta sólo se hará después de una duración de",
    Time_duration_to_trigger_question: "Duración del tiempo para activar la pregunta",
    View_Salary_Pay_Compensation: "Ver compensación salarial",
    View_Hourly_Pay_Compensation: "Ver compensación salarial por hora",
    Select_Position: "Seleccionar posición",
    contact_support: "Contactar con soporte técnico",
    warning_change_pay_group_context: "Cambiar los grupos de pago con diferentes calendarios de pago a mitad del ciclo puede generar cálculos de pago incorrectos y errores en los informes. Para garantizar la integridad de los datos, comuníquese con el soporte de Findd para analizar este cambio antes de continuar.",
    warning_change_pay_group_context_as_global_admin: "Está cambiando el grupo de pago de '{0}' a '{1}', lo que cambiará el calendario de pago de estos empleados. Si esto es para un trabajo que se encuentra en la mitad del ciclo de nómina y hay conjuntos de puntos que cruzarán los calendarios de pago, revise cuidadosamente las tarjetas de tiempo antes y después de continuar para garantizar la precisión de la nómina. Comuníquese con el soporte de Findd si tiene alguna pregunta.",
    Apply_Auto_Breaks: "Aplicar pausas automáticas",
    Allow_GeoFence_Notifications: "Notificaciones de límites de geocerca (solo dispositivo personal)",
    Employee_Locked: "Empleada bloqueada",
    Cannot_Employee_Lock_Payroll: "El empleado no puede bloquear la nómina",
    Payroll_Time_Employee_Lock_Warning: "Esta jerarquía contiene {0} tarjetas de tiempo que se están modificando actualmente y que pueden excluir esos tiempos. La nómina no se puede bloquear para los empleados mientras se cambian estos empleados.",
    Cannot_employee_unlock_for_locked_hierarchy: "No se puede desbloquear el empleado para la jerarquía bloqueada",
    Are_you_sure_you_want_to_employee_unlock_payroll_hierarchy: "¿Está seguro de que desea desbloquear la jerarquía de nómina de los empleados?",
    Are_you_sure_you_want_to_employee_unlock_payroll_hierarchies: "¿Está seguro de que desea desbloquear {0} jerarquías de nómina para los empleados?",
    Employee_Unlock_Payroll_Hierarchy: "Jerarquía de nómina de desbloqueo de empleados",
    Are_you_sure_you_want_to_employee_lock_payroll_hierarchy: "¿Está seguro de que desea bloquear la jerarquía de nómina de los empleados?",
    Are_you_sure_you_want_to_employee_lock_payroll_hierarchies: "¿Está seguro de que desea bloquear {0} jerarquías de nómina de empleados?",
    Employee_Lock_Payroll_Hierarchy: "Jerarquía de nómina de bloqueo de empleados",
    Payroll_employee_locked_successfully: "¡La nómina se bloqueó exitosamente por empleado!",
    Payroll_employee_unlocked_successfully: "¡La nómina se desbloqueó exitosamente!",
    Failed_to_employee_lock_payroll_Please_try_again_later: "No se pudo bloquear la nómina del empleado. Por favor, inténtelo de nuevo más tarde",
    Failed_to_employee_unlock_payroll_Please_try_again_later: "No se pudo desbloquear la nómina del empleado. Por favor, inténtelo de nuevo más tarde",
    Employee_Lock: "Bloqueo de empleado",
    Employee_Unlock: "Desbloqueo de empleados",
    EMP_Locked: "E.bloqueado",
    Enable_Employee_Lock: "Habilitar bloqueo de empleados",
    View_Employee_Attributes: "Ver atributos de empleados",
    Punch_Question_Response_Report: "Informe de respuesta a la pregunta perforadora",
    REJECT_REMOVE: "RECHAZAR Y ELIMINAR",
    HR_Profile: "Perfil de Recursos Humanos",
    Please_review_the_suspense_punches_before_locking_timecards: "Tienes Suspsene Punches pendientes para este período de pago. Revise los golpes de suspenso antes de bloquear las tarjetas de tiempo.",
    inherited: "heredada",
    inheritance_override: "anulación de herencia",
    Set_OT_Policy_Manually: "Establecer la política de OT manualmente",
    None_OT_Policy: "None OT Policy",
    Edit_Budget: "Editar presupuesto",
    Hide_On_ESS: "Hide On ESS",
    Use_Employee_Base_Pay_Rate: "Utilice la tarifa de pago base",
    Base_Pay_Rate_Addition: "Adición de la tasa de pago base",
    Use_Pay_Rate_Addition_Percentage: "Utilice el porcentaje de adición de tasa de pago",
    Base_Pay_Rate_Addition_Percentage: "Porcentaje adicional de tasa de pago",
    Using_Base_Pay_Rate: "Utilice la tarifa de pago base",
    Pay_Rate_Add: "Agregar tasa de pago",
    Pay_Rate_Percent: "Tarifa de pago %",
    No_match_position_date: "No match position date",
    Default_OT_Pay_Type: "Tipo de pago OT predeterminado",
    Default_OT2_Pay_Type: "Tipo de pago OT2 predeterminado",
    Edit_Profile_Pic: "Editar foto de perfil",
    Edit_Face_Spaces: "Editar espacios faciales",
    View_Attributes: "Ver atributos",
    View_Worker_Pool: "Ver grupo de trabajadores",
    View_Assigned_Employee: "Ver empleado asignado",
    View_Job_Devices: "Ver dispositivos de trabajo",
    Add_Job_Devices: "Agregar dispositivos de trabajo",
    Edit_Job_Devices: "Editar dispositivos de trabajo",
    Delete_Job_Devices: "Eliminar dispositivos de trabajo",
    View_Job_Location: "Ver ubicación del trabajo",
    View_Phases: "Ver Fases",
    View_Positions: "Ver posiciones",
    View_Expenses: "Ver Gastos",
    View_Photos: "Ver fotos",
    View_Settings: "Ver configuraciones",
    View_Bank_Info: "Ver información bancaria",
    Add_Bank_Info: "Agregar información bancaria",
    Edit_Bank_Info: "Editar información bancaria",
    Delete_Bank_Info: "Eliminar información bancaria",
    View_Pay_Compensation: "Ver compensación salarial",
    Add_Pay_Compensation: "Agregar compensación salarial",
    Edit_Pay_Compensation: "Editar compensación salarial",
    Delete_Pay_Compensation: "Eliminar compensación de pago",
    Edit_Termination_Notes: "Editar notas de terminación",
    Delete_Hire_Termination_Audits: "Eliminar auditorías de contratación/despido",
    Allow_Rehire: "Permitir recontratar",
    Post_as_Posted_Schedule: "Publicar según el horario publicado",
    Present_Timecard_on_Punch_Out: "Present Timecard on Punch Out",
    Action_By_Name: "Action By Name",
    Previous_Pay_Period: "Período de pago anterior",
    Last_Day_Worked: "Último día trabajado",
    Float_Employee_Info:
        "Los empleados flotantes son empleados que han trabajado en este trabajo dentro de los últimos 30 días pero no están asignados a este trabajo ni tienen este trabajo como predeterminado.",
    Show_Default_Job_Employees: "Mostrar empleados de trabajo predeterminados",
    Show_Assigned_Employees: "Mostrar empleados asignados",
    Show_Float_Employees: "Mostrar empleados de flotación",
    No_Hierarchy_Job_Variations: "Sin jerarquías/variaciones de trabajo",
    Hierarchy_Job_Variations: "Jerarquía/Variaciones de Trabajo",
    Exclude_Inactive_Employees: "Excluir empleados inactivos",
    Accrual_Used: "Acumulación utilizada",
    Accrual_Earned: "Acumulación obtenida",
    x_pay_type_is_used_for_the_leave_punch_set_are_you_sure_you_want_to_also_have_it_contribute_to_the_accrual:
        "El tipo de pago '{0}' se utiliza para el conjunto de fichajes de licencia. ¿Está seguro de que desea que también contribuya a la acumulación?",
    Failed_Exports_Only: "Sólo exportaciones fallidas",
    Failed_Export: "Exportación fallida",
    Export_Note: "Nota de exportación",
    Employee_Count_Attempted: "Conteo de empleados intentado",
    Successful_Exports: "Exportaciones exitosas",
    Failed_Exports: "Exportaciones fallidas",
    Export_Report: "Reporte de exportacion",
    No_Payroll_Export_History: "Sin historial de exportación de nómina",
    Payroll_Export_History: "Historial de exportación de nómina",
    Select_Payroll_Hierarchy: "Seleccionar jerarquía de nómina",
    Are_you_sure_you_want_to_recache_timecards_at_x: "¿Estás segura de que quieres volver a almacenar las tarjetas de tiempo en {0}?",
    Are_you_sure_you_want_to_recalculate_timecards_at_x: "¿Estás segura de que quieres volver a calcular las tarjetas de tiempo en {0}?",
    Recalculate_Timecards: "Recalcular tarjetas de tiempo",
    Recache_Timecards: "Recuperar tarjetas de tiempo",
    External: "Externa",
    External_Approved: "Aprobado externo",
    Enable_External_Supervisor_Approve_Timecard: "Enable External Supervisor Approve Timecard",
    Disable_Location_Exception: "Deshabilitar excepción de ubicación",
    Disable_Biometrics_Exception: "Deshabilitar excepción biométrica",
    Select_Additional_Days: "Seleccionar Días Adicionales",
    Copy_Schedule_Template: "Copiar plantilla de horario",
    Schedule_template_copied_successfully: "Plantilla(s) de horario copiadas correctamente",
    Are_you_sure_you_want_to_un_assign_employee_x_for_selected_days: "Are you sure you want to un assign employee '{0}' for selected days?",
    Un_Assign_Employee: "Desasignar empleada",
    Productive_Time: "Tiempo productivo",
    Non_Productive_Time: "Tiempo no productivo",
    Show_Productive_Non_Productive_Time: "Mostrar tiempo productivo/no productivo",
    MULT: "MÚLTIPLE",
    Empty_PayType: "Tipo de pago vacío",
    Invalid_PayType: "Tipo de pago no válido",
    EmployeePage: "Página del empleado",
    Delete_Question_Answer: "Eliminar pregunta respuesta",
    Are_you_sure_you_want_to_delete_this_question_answer: "¿Está seguro de que desea eliminar la respuesta de esta pregunta?",
    Import_as_Posted_Schedule: "Importar como programación publicada",
    Are_you_sure_you_want_to_import_schedule_This_cannot_be_undone: "¿Está seguro de que desea importar {0} programaciones? Esto no se puede deshacer.",
    Import_Schedule_Data: "Importar datos de programación",
    Added_an_additional_day_successfully: "Se agregó un día adicional con éxito",
    Are_you_sure_you_want_to_add_an_additional_day_to_the_end_of_the_schedule: "¿Está seguro de que desea agregar un día adicional al final del horario?",
    Master_Schedule_posted_successfully: "Horario maestro publicado con éxito",
    Are_you_sure_you_want_to_post_this_master_schedule_for_current_week: "¿Está seguro de que desea publicar este horario maestro para la semana actual?",
    Immediately_Post: "Publicar inmediatamente",
    Failed: "Fallida",
    Exported_Date: "Fecha exportada",
    Exported_By: "Exportado por",
    Unexported: "no exportado",
    Empty: "Vacía",
    failure_export_payroll_hierarchy: "Error: la jerarquía de nómina '{0}' contenía errores y no se exportó.",
    success_export_payroll_hierarchy: "Éxito: se exportó el tiempo de la jerarquía de nómina '{0}'.",
    Execution_Result: "Resultado de la ejecución",
    export_failed_comment:
        "La exportación de nómina no tuvo éxito. Se revirtió la exportación de nómina y no se realizaron cambios. Descargue el resultado de la exportación para ver los errores, realizar las correcciones y volver a intentar la exportación.",
    Download_Export_Result: "Descargar resultado de exportación",
    Confirm_Export: "Confirmar y Exportar",
    Upon_confirmation_employee_time_will_be_exported: "Tras la confirmación, se exportará el tiempo del empleado.",
    Unapproved_employees: "Empleadas no aprobadas",
    Exported_employees: "Empleados exportadas",
    You_have_selected_payroll_hierarchies_for_export_This_export_contains_the_following: "Ha seleccionado jerarquías de nómina para exportar. Esta exportación contiene lo siguiente:",
    No_payroll_export_scheduled_job: "No hay trabajo programado de exportación de nómina",
    Payroll_Export: "Exportación de nómina",
    ScheduleReport: "Informe de programación",
    Select_Pay_Group: "Seleccionar grupo de pago",
    Manual_Override: "Accionamiento manual",
    Inherited: "Heredada",
    Job_Settings_PayGroup_Note:
        "El grupo de pago establecido aquí se aplicará a todos los empleados con este trabajo como Trabajo predeterminado, a menos que un empleado tenga una anulación manual del grupo de pago.",
    Hierarchy_Settings_PayGroup_Note:
        "El grupo de pago establecido aquí será heredado por todos los empleados con una jerarquía predeterminada en su nivel o por debajo de él, a menos que una jerarquía, trabajo o empleado tenga una configuración de grupo de pago anulada.",
    Are_you_sure_you_want_to_delete_this_language_agreement: "¿Está seguro de que desea eliminar este acuerdo de idioma?",
    English_agreement_is_required_by_default: "Se requiere acuerdo en inglés por defecto",
    Agreement: "Acuerdo",
    Agreement_is_empty: "El acuerdo está vacío",
    Cannot_approve_leave_request_because_paytype_invalid: "No se puede aprobar la solicitud de licencia porque el tipo de pago no es válido",
    The_PayType_of_leave_request_invalid_for_employee: "El tipo de pago de la solicitud de licencia no es válido para el empleado",
    Payroll_Expenses_Summary: "Resumen de gastos de nómina",
    Payroll_Expenses_Combined_with_Time_Data: "Gastos de nómina combinados con datos de tiempo",
    Device_Field: "Campo de dispositivo",
    Positions_Field: "Campo de Posiciones",
    Require_biometrics: "Requerir datos biométricos",
    Control_biometric_settings_per_employee: "Control de configuraciones biométricas por empleada",
    Default_PayGroup_of_Payroll_Hierarchy: "Grupo de pago predeterminado de la jerarquía de nómina",
    Enable_PayGroup_Assign_Employee_Level: "Habilitar nivel de empleado de asignación de grupo de pago",
    Pay_Group_Selection: "Selección de grupo de pago",
    Set_Pay_Group_Manually: "Establecer grupo de pago manualmente",
    Loading_Note_Types: "Cargando tipos de notas",
    Profile: "Perfil",
    Logout: "Cerrar sesión",
    CA_Meal_Break_Exception: "Excepción de descanso para comer de CA",
    Enable_CA_Meal_Break_Notification: "Habilitar la notificación de descanso para comer de CA",
    On_x_x_added_a_1_day_schedule_delay: "En {0}, {1} agregó un retraso de horario de 1 día",
    On_x_x_added_X_days_schedule_delay: "En {0}, {1} agregado {2} días de programación",
    Schedule_delayed_successfully: "Schedule delayed successfully",
    Enter_the_number_of_days_to_delay_the_schedule: "Ingrese el número de días para retrasar el horario",
    x_Schedule_Delay: "{0} Programar retraso",
    Clone_Shifts: "Turnos de clones",
    Schedule_Delay: "Programar retraso",
    Exclude_Weekends: "Excluir fines de semana",
    Shift_is_on_weekends: "El turno es los fines de semana",
    Schedule_dates_are_not_match_with_job_dates: "Schedule's dates are not match with job dates",
    Enable_Breadcrumb: "Habilitar pan de pan",
    Speed: "Velocidad",
    Accuracy: "Exactitud",
    No_Breadcrumb: "No Breadcrumb",
    Breadcrumb: "Migaja de pan",
    You_have_changed_the_client_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_client:
        "Ha cambiado el cliente de este horario para que ya no sea visible. Para ver el horario, vaya a cliente cambiado",
    You_have_changed_the_job_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_job:
        "Ha cambiado el trabajo de este horario para que ya no sea visible. Para ver el horario, vaya a trabajo cambiado",
    You_have_changed_the_hierarchy_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_change_your_hierarchy_filter_to_x:
        "Ha cambiado la jerarquía de este horario para que ya no sea visible. Para ver la programación, cambie su filtro de jerarquía a '{0}'",
    Schedule_document_has_not_passed_validations: "El documento de horario no ha pasado las validaciones",
    Shift_hierarchy_is_not_match_with_the_hierarchy_of_schedule_document: "La jerarquía del turno no coincide con la jerarquía del documento de programación",
    Shift_job_is_not_match_with_the_job_of_schedule_document: "El trabajo del turno no coincide con el trabajo del documento de programación",
    Shift_client_is_not_match_with_the_client_of_schedule_document: "El cliente del turno no coincide con el cliente del documento de programación",
    You_have_changed_the_hierarchy_of_this_shift_template_so_that_it_is_no_longer_visible_To_see_the_shift_template_change_your_hierarchy_filter_to_X:
        "Ha cambiado la jerarquía de esta plantilla de turno para que ya no sea visible. Para ver la plantilla de turnos, cambie su filtro de jerarquía a '{0}'",
    Precise_Location_permission_granted: "Permiso de ubicación precisa concedido",
    This_device_not_uploaded_permission_data: "Este dispositivo no cargó datos de permisos",
    Enable_Punch_to_Assigned_Jobs_Only: 'Habilite "Perforar solo para trabajos asignados"',
    Budget_Status: "Estado del presupuesto",
    Budget_By_Job: "Presupuesto por trabajo",
    Filter_Only_Favorites: "Filtrar solo favoritos",
    Please_select_start_end_dates: "Seleccione las fechas de inicio/finalización",
    Calculate_Budget: "Calcular presupuesto",
    Cannot_calculate_budget_for_more_than_100_Jobs: "No se puede calcular el presupuesto para más de 100 trabajos",
    Please_narrow_your_search_criteria_to_fewer_than_100_jobs_to_see_the_calculated_real_time_budget_data:
        "Limite sus criterios de búsqueda a menos de 100 trabajos para ver los datos del presupuesto calculado en tiempo real",
    Multiple_Jobs_Budget_Data: "Datos de presupuesto de múltiples trabajos",
    View_Budget: "View Budget",
    Filter_By_Clients: "Filtrar por clientes",
    Current_Job: "Trabajo actual",
    Filter_by_Job_Start_End_Dates: "Filtrar por fechas de inicio/finalización del trabajo",
    Create_New_Job_Filter: "Crear nuevo filtro de trabajo",
    Edit_Job_Filter: "Editar filtro de trabajo",
    Type_here: "Escribe aquí...",
    inherited_from_Account_x: "heredado de Cuenta: {0}",
    inherited_from_x: "heredado de {0}",
    All_Employees: "Todas las empleadas",
    Qualifications: "Calificaciones",
    Gig_Pool_Rules: "Reglas del grupo de conciertos",
    Gig_Pool: "GigPool",
    Gig_Pool_Empty: "Ready to add your first GigPool? Click the add button.",
    Gig_Pool_Members: "members",
    Employee_Type: "Tipo de empleado",
    Available_Jobs: "Empleos disponibles",
    DELETE_FACESPACE: "ELIMINAR ESPACIO FACIAL",
    Are_you_sure_you_want_to_delete_this_Face_Space: "¿Está seguro de que desea eliminar este 'Espacio facial'?",
    Create_New_Filter: "Crear nuevo filtro",
    Employee_does_not_have_matched_position_with_shift: "El empleado no tiene un puesto coincidente con el turno",
    LOCATION_exception_description:
        "Excepción de marcación de ubicación. Se produjo un golpe {0} de {1}. Consulte el mapa para ver dónde marcó el empleado en comparación con el lugar donde se encuentra el {2}.",
    No_Device_Location_exception_description:
        "El golpe no capturó la ubicación del GPS en el momento del golpe. En el dispositivo, verifique los permisos de la aplicación móvil para asegurarse de que los Permisos de ubicación estén permitidos.",
    Punch_Outside_Geofence: "Perforar fuera de la geocerca",
    Connection_Type: "Tipo de conección",
    Device_Mode: "Modo de dispositivo",
    Employee_Timecard_Report: "Informe de tarjeta de tiempo del empleado",
    Rate: "Tasa",
    Accrual_Rate_Per_Day: "Tasa de acumulación por día",
    Per_Hour_Worked: "Por Hora Trabajada",
    Per_Day: "Por día",
    Unit: "Unidad",
    There_is_no_Budget_Unit_Position_Definition_item: "No hay elemento de definición de puesto de unidad de presupuesto",
    There_is_no_Budget_Unit_item: "No hay partida de unidad de presupuesto",
    Unit_Factor: "Factor unitario",
    Add_Budget_Unit_Position_Definition: "Agregar definición de puesto de unidad de presupuesto",
    Budget_Units: "Unidades de presupuesto",
    Use_Schedule_Budget_Units: "Usar unidades de presupuesto de programación",
    Budget_Unit_Position_Definitions: "Definiciones de puesto de la unidad de presupuesto",
    Schedule_Budget_Units: "Programar unidades de presupuesto",
    Unit_Name: "Nombre de unidad",
    Add_Unit: "Agregar unidad",
    Shift_time_is_out_of_schedule: "El tiempo de turno está fuera de horario",
    Enable_Mobile_Location_Fraud_Prevention_to_GPS_accuracy: "Habilite la prevención de fraude de ubicación móvil con precisión de GPS",
    Application_Language: "Idioma de la aplicación",
    Job_Hierarchy_Move_Warning:
        "Los siguientes empleados actualmente tienen '{0}' como su trabajo predeterminado, pero no tienen permiso para la jerarquía a la que se está moviendo este trabajo. ¿Desea eliminarlos para que no tengan '{0}' como trabajo predeterminado?",
    Proceed: "Proceder",
    Job_Hierarchy_Move: "Movimiento de jerarquía de trabajo",
    The_punch_level_of_shift_invalid: "El nivel de golpe de cambio inválida",
    Limit_To_Shift_Position: "Límite para cambiar de posición",
    Require_Matching_Employee_Shift_Position: "Requerir puesto de turno de empleado coincidente",
    RequirePhase: "Requerir Fase",
    One_Hour_Timeoff_Increment: "Incremento de tiempo libre de 1 hora",
    Punch_is_in_suspense_due_to_pairing_error_Please_approve_or_reject: "Punch está en suspenso por error de emparejamiento. Por favor, apruebe o rechace.",
    Punch_hierarchy_is_not_valid_by_employee_permission: "La jerarquía de perforaciones no es válida con el permiso del empleado",
    Duplicated_occupation_exist: "Existe ocupación duplicada",
    Duplicated_badge_exist: "Existe una credencial duplicada",
    Duplicated_specialty_exist: "Existe especialidad duplicada",
    Employee_already_assigned_to_this_job: "Empleada ya asignada a este trabajo",
    Are_you_sure_you_want_to_delete_this_filter: "¿Está seguro de que desea eliminar este filtro?",
    Punch_to_assigned_Jobs_only: "Perforar solo trabajos asignados",
    Work_Instructions: "Instrucciones de trabajo",
    Resource_Planner_Schedule: "Calendario del planificador de recursos",
    Daily_Schedule_Budget: "Presupuesto de programación diaria",
    Create_New_Resource_Planner_Filter: "Crear nuevo filtro del planificador de recursos",
    Edit_Resource_Planner_Filter: "Editar filtro del planificador de recursos",
    Filter_by_Selected_Positions: "Filtrar por posiciones seleccionadas",
    Filter_by_Selected_Clients: "Filtrar por clientes seleccionadas",
    Filter_by_Selected_Jobs: "Filtrar por trabajos seleccionados",
    Select_Positions: "Seleccionar posiciones",
    Hide_Core_Staff: "Ocultar bastón central",
    Hide_Float_Staff: "Ocultar bastón flotante",
    Hide_Per_Diem_Staff: "Ocultar personal de viáticos",
    Hide_Agency_Staff: "Ocultar personal de la agencia",
    View_Only_Productive_Shifts: "Ver solo turnos productivos",
    View_Unscheduled_Staff: "Ver personal no programado",
    View_Only_Filled_Shifts: "Ver solo turnos completos",
    View_Only_Unfilled_Shifts: "Ver solo turnos sin completar",
    Removed: "Remota",
    Inactivated: "inactivado",
    Shift_time_is_not_match_with_job_dates: "La hora del turno no coincide con las fechas del trabajo",
    Cannot_auto_assign_in_here_Schedule_has_the_shift_which_is_not_shown_here: "No se puede asignar automáticamente aquí. El horario tiene el turno que no se muestra aquí",
    Validation_Error: "Error de validacion",
    Cannot_copy_in_here_Schedule_has_the_shift_which_is_not_shown_here: "No se puede copiar aquí. El horario tiene el turno que no se muestra aquí",
    Cannot_delete_in_here_Schedule_has_the_shift_which_is_not_shown_here: "No se puede eliminar aquí. El horario tiene el turno que no se muestra aquí",
    Cannot_post_in_here_Schedule_has_the_shift_which_is_not_shown_here: "No se puede publicar aquí. El horario tiene el turno que no se muestra aquí",
    Resource_Planner_View: "Vista del planificador de recursos",
    Punch_Comment: "Comentario de punzón",
    Minimum_Break_Override: "Anulación de descanso mínimo",
    Failed_to_download_payroll_report_Please_try_again_later: "No se pudo descargar el informe de nómina. Por favor, inténtelo de nuevo más tarde",
    Failed_to_download_payroll_Please_try_again_later: "No se pudo descargar la nómina. Por favor, inténtelo de nuevo más tarde",
    View_Hierarchy_Tab: "Ver pestaña de jerarquía",
    Can_add_non_direct_report_employees: "Se pueden agregar empleados subordinados no directos",
    Allow_Honor_Based_Time_Entry: "Permitir el registro de tiempo basado en la sinceridad",
    Pay_Calendars: "Calendarios de pago",
    Bi_Weekly_OT: "OT quincenal",
    Bi_Weekly_OT2: "OT2 quincenal",
    Bi_Weekly_rule_should_be_not_exist: "La regla quincenal no debería existir",
    Cannot_choose_Bi_Weekly: "No se puede elegir quincenal",
    Cannot_choose_Bi_Weekly_OT_policy: "No se puede elegir la política de OT quincenal",
    OT_Policy: "Política de OT",
    Are_you_sure_you_want_to_delete_OT_policy: "¿Está seguro que desea eliminar la política de OT?",
    OT_Policy_created_successfully: "La política de OT se creó correctamente",
    OT_Policy_updated_successfully: "La política de OT se actualizó correctamente",
    OT_Policy_Type: "Tipo de política de OT",
    New_OT_Policy: "Nueva política de OT",
    Edit_OT_Policy: "Editar política de OT",
    Daily_OT: "OT diario",
    Daily_OT2: "OT2 diario",
    Weekly_OT: "OT semanal",
    Weekly_OT2: "OT2 semanal",
    ConsecutiveRule_OT: "Regla consecutiva de OT",
    ConsecutiveRule_OT2: "Regla consecutiva de OT2",
    ConsecutiveRule_Days: "Regla consecutiva de días",
    OT_Policy_Selected: "Política de OT seleccionada",
    No_OT_Policy: "Política sin OT",
    OT_Policies: "Políticas de OT",
    Enable_OT_Policy: "Habilitar política de OT",
    Use_Rounding_Rules: "Utilizar reglas de redondeo",
    Limit_Employees_on_Device_to_Hierarchy: "Limitar a los empleados en el dispositivo según la jerarquía",
    Rewards: "Recompensas",
    View_Rewards: "Ver recompensas",
    Add_Rewards: "Agregar recompensas",
    Edit_Rewards: "Editar recompensas",
    Delete_Rewards: "Eliminar recompensas",
    Are_you_sure_you_want_to_delete_photo: "¿Está seguro de que desea eliminar esta(s) foto(s)?",
    Drag_and_Drop_or_click_to_choose_a_picture_files: "Arrastre y suelte o haga clic para elegir un archivo de fotos",
    Add_Photo: "Agregar foto",
    Photos: "Fotos",
    No_Photo: "Sin foto",
    Photo_Selected: "Foto seleccionada",
    x_Photos_Selected: "{0} fotos seleccionadas",
    Are_you_sure_you_want_to_download: "¿Está seguro de que desea descargar?",
    NoSelection: "Sin selección",
    SingleDate: "Fecha única",
    DateRange: "Fechas de inicio y finalización",
    Date_Selection_Type: "Tipo de selección de fecha",
    Please_select_location: "Seleccione la ubicación",
    TimecardTab: "Pestaña de la tarjeta de control de tiempo",
    Report_Location: "Informar ubicación",
    NewCustomReportType: "Agregar nuevo tipo de informe personalizado",
    TimecardValidationScript: "Timecard Validation Script",
    Limit_By_Job_Shortlist: "Limitar por preselección de trabajo",
    No_Job_location: "Sin ubicación del trabajo",
    No_Employee_location: "Sin ubicación del empleado",
    Unknown: "Desconocido",
    Include_all_Audit_data: "Incluir todos los datos de auditoría",
    Job_Consolidate_Pay_Category_Tooltip: "Representa la categoría general a la que pertenecen las horas: Regular (REG), Sobretiempo (OT) y Sobretiempo doble (OT2).",
    Job_Consolidate_PayType_Tooltip:
        "Representa el tipo de horas al que se asigna el tiempo trabajado por el empleado. Las formas de pago pueden incluirse en las categorías de pago de horas Regulares, Sobretiempo y Sobretiempo doble.",
    Pay_Category: "Categoría de pago",
    Failed_Calculate_Accural_Employees_For_Close_Payroll: "No se pudo calcular los empleados exactos para cerrar la nómina",
    Cannot_Delete_Job: "No se puede eliminar el trabajo",
    Cannot_Delete_Job_because_it_is_already_use: "No se puede eliminar el trabajo porque ya hay al menos un trabajo en uso.",
    Cannot_Inactive_Job: "No se puede desactivar el trabajo",
    Cannot_Inactive_Job_because_it_is_already_use: "No se puede desactivar el trabajo porque ya está en uso.",
    Cannot_Inactive_Phase: "No se puede desactivar la etapa",
    Cannot_Inactive_Phase_because_it_is_already_use: "No se puede desactivar la etapa porque ya está en uso.",
    Phase_Removed: "Etapa eliminada",
    Cannot_Delete_Phase: "No se puede eliminar la etapa",
    Cannot_Delete_Phase_because_it_is_already_use: "No se puede eliminar la etapa porque ya hay al menos una etapa en uso.",
    Location_permission_granted: "Se otorgó permiso de ubicación",
    Camera_permission_granted: "Se otorgó permiso de cámara",
    Storage_permission_granted: "Se otorgó permiso de almacenamiento",
    Phone_call_permissions_granted: "Se otorgaron permisos de llamadas telefónicas",
    NFC_permission_granted: "Se otorgó permiso de comunicación de campo cercano (NFC)",
    Photo_Library_permission_granted: "Se otorgó permiso de fototeca",
    Device_Permissions: "Permisos del dispositivo",
    Only_Lock_Supervisor_Approved: "Solo se aprobó el bloqueo por el supervisor",
    Only_Lock_Employee_Approved: "Solo se aprobó el bloqueo por el empleado",
    Beginning: "Inicio",
    Time_Fraud_Alert: "Alerta de fraude de tiempo",
    No_time_fraud_punch_found: "No se encontró ninguna marcación de tiempo fraudulenta",
    Fraud: "Fraude",
    Time_Fraud: "Fraude de tiempo",
    Based_On_Actual_Time: "Basado en el tiempo real",
    Based_On_Rounded_Time: "Basado en el tiempo redondeado",
    Time_Duration_Rule: "Regla de duración del tiempo",
    Bill_Rate_$: "Tasa de facturación $",
    Pay_Rate_$: "Tasa de pago $",
    Reg_Total_$: "Tiempo total Reg $",
    OT_Total_$: "Tiempo total de OT $",
    OT2_Total_$: "Tiempo total de OT2 $",
    Total_$: "Total $",
    PunchSet_Data: "Datos de marcación",
    Custom_Range: "Rango personalizado",
    Timeframe: "Período",
    Save_to_Timecard_Reports: "Guardar en informes de tarjeta de tiempo",
    Report_with_this_name_already_Exists: "Informe con este nombre ya existe",
    Report_updated_successfully: "Informe actualizado exitosamente",
    Report_saved_successfully: "Informe guardado exitosamente",
    Report_deleted_successfully: "Informe eliminado con éxito",
    report_Name: "Nombre del informe",
    Employee_Data: "Datos del empleado",
    Select_the_data_you_want_to_export_as_unique_columns_in_your_report: "Seleccione los datos que desea exportar como columnas únicas en su informe",
    Adhoc_Report: "Informe ad hoc",
    Are_you_sure_you_want_to_delete_selected_file: "¿Está seguro de que desea eliminar el archivo seleccionado?",
    Added_By: "Agregado por",
    No_Job: "Sin trabajo",
    File_Name: "Nombre del archivo",
    Upload_New_File_Version: "Cargue una nueva versión del archivo. \nArrastre y suelte o haga clic para elegir un archivo de su computadora.",
    No_File: "Sin archivo",
    New_File: "Archivo nuevo",
    File_Selected: "Archivo seleccionado",
    x_Files_Selected: "{0} Archivos seleccionados",
    Files: "Archivos",
    Hide_OT2: "Ocultar OT2",
    Exclude_Agency_Employees: "Excluir empleados de la agencia",
    Exclude_Exempt_Employees: "Excluir empleados exentos",
    Payroll_by_Job: "Nómina por puesto de trabajo",
    Cannot_approve_by_a_explicit_job_permission: "No se puede aprobar con un permiso de trabajo explícito.",
    Cannot_unapprove_by_a_explicit_job_permission: "No se puede desaprobar con un permiso de trabajo explícito.",
    Are_you_sure_you_want_to_approve_punchSet: "¿Está seguro de que desea aprobar la marcación?",
    Are_you_sure_you_want_to_unapprove_punchSet: "¿Está seguro de que desea desaprobar la marcación?",
    Unapprove_PunchSet: "Desaprobar la marcación",
    View_Payroll_By_Job: "Ver nómina por puesto de trabajo",
    Account_Level_Clock_Device_Warning_Msg: "Agregar este dispositivo al nivel de cuenta no funcionará para versiones de la aplicación móvil anteriores al 1 de mayo de 2022.",
    Account_Level_Clock_Device_Job_Limit_Error_Msg:
        "Hay demasiados trabajos para registrar en este nivel de jerarquía. Elija una jerarquía diferente para el registro. Comuníquese con el equipo de asistencia de Findd para obtener ayuda si tiene preguntas sobre el registro de su dispositivo.",
    Are_you_sure_you_want_to_reinitialize_the_selected_devices: "¿Está seguro de que desea reiniciar los dispositivos seleccionados?",
    Warning_This_will_act_as_a_fresh_install_and_mobile_data_will_be_deleted: "Advertencia: Esto actuará como una nueva instalación y se eliminarán los datos del dispositivo móvil.",
    Init_Devices: "Inicializar dispositivos",
    Week_Totals: "Totales de la semana",
    Please_input_the_Billing_Contact_before_add_payment_method: "Ingrese el contacto de facturación antes de agregar el método de pago.",
    Data: "Datos",
    Cannot_add_over_10_clients_for_free_account_Please_upgrade_your_account_plan_to_add_more:
        "No se pueden agregar más de 10 clientes a una cuenta gratuita. Actualice su plan de cuenta para agregar más.",
    Cannot_add_over_10_jobs_for_free_account_Please_upgrade_your_account_plan_to_add_more:
        "No se pueden agregar más de 10 trabajos a una cuenta gratuita. Actualice su plan de cuenta para agregar más.",
    Cannot_add_over_100_employees_for_free_account_Please_upgrade_your_account_plan_to_add_more:
        "No se pueden agregar más de 100 empleados a una cuenta gratuita. Actualice su plan de cuenta para agregar más.",
    The_punch_count_reached_to_1000_limit_for_free_account_This_punch_was_in_suspense_state_and_not_added_to_timecard_Please_upgrade_your_account_plan_to_add_this_punch_to_timecard:
        "El contador de marcación alcanzó el límite de 1000 para la cuenta gratuita. Esta marcación estaba en espera y no se agregó a la tarjeta de control de tiempo. Actualice su plan de cuenta para agregar esta marcación a la tarjeta de control de tiempo.",
    The_punch_count_reached_to_limit_for_free_account: `El contador de marcación alcanzó el límite de 1000 para la cuenta gratuita. Seleccione "{2}" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación.`,
    Hide_Paywall: "Ocultar el muro de pago",
    Please_select_a_job: "Seleccione un trabajo",
    Missing_Punch_workflow: "Falta el flujo de trabajo de la marcación",
    No_pending_workflows: "No hay flujos de trabajo pendientes",
    No_pending_trainings: "No hay capacitaciones pendientes",
    Allow_STRIPE_Payment_Method: "Permita el método de pago STRIPE",
    invalid: "inválido",
    Pay_Type_is_not_valid: "La forma de pago no es válida",
    View_Rates: "Ver tasas",
    Edit_Rates: "Editar tasas",
    Reg_OT_OT2_are_0: "Las horas Reg, OT y OT2 son 0",
    Reg_OT_are_0: "Las horas Reg y OT son 0",
    Not_allowed_0_hour: "No se permite 0 horas",
    Owner: "Titular",
    Try_it_for_free_today: "¡Pruébelo gratis hoy mismo!",
    No_cost_to_sign_up_and_get_started: "No hay costo para registrarse y comenzar.",
    Use_Leave_Tracking_Description: "Puede chatear con Ventas ahora o cambiar al plan Findd Professional. ¡Empiece a utilizar Findd Leave Tracking hoy mismo!",
    Use_Schedule_Description: "Puede chatear con Ventas ahora o cambiar al plan Findd Professional. Deje que Findd elimine las suposiciones de su proceso de planificación.",
    Ready_to_start_using_leave_tracking: "¿Listo para empezar a utilizar el seguimiento de licencias?",
    Ready_to_start_using_Scheduling: "¿Listo para comenzar a utilizar la planificación?",
    Employee_Leave_Tracking: "Seguimiento de las licencias de los empleados",
    Enhanced_Scheduling: "Planificación mejorada",
    Talk_to_Sales: "Hablar con Ventas",
    Enable_IN_OUT_on_Mobile: "Habilitar ENTRADA/SALIDA en el dispositivo móvil",
    Trigger_Duration: "Duración del activador",
    Rule: "Regla",
    Apply: "Aplicar",
    Duplicate_Budget_Item_Message_Text: "Ya existe una partida presupuestaria creada de este tipo.",
    Are_you_sure_you_want_to_accept_suspense_punches: "¿Está seguro de que desea aceptar las marcaciones en espera?",
    Accept_Suspense_Punches: "Aceptar marcaciones en espera",
    Add_missing_punch_from_mobile: "Agregar la marcación faltante desde el dispositivo móvil",
    Edit_punch_time_from_mobile: "Editar la hora de marcación desde el dispositivo móvil",
    Apply_Once_Per_PunchSet: "Aplicar una vez por marcación",
    Apply_Once_Per_Day_to_the_1st_Qualified_PunchSet: "Aplicar una vez al día al primer PunchSet calificado",
    Apply_Once_Per_Day_based_on_Total_Working_Hours: "Aplicar una vez al día según el total de horas de trabajo",
    Cannot_close_current_or_future_period: "No se puede cerrar el período actual o futuro.",
    Select_Jobs: "Seleccionar trabajos",
    All_Jobs: "Todos los trabajos",
    Include_Only_Selected: "Incluir solo los seleccionados",
    Exclude_Only_Selected: "Excluir solo los seleccionados",
    Job_Explicit_Assignment: "Asignación explícita de trabajo",
    User_Details: "Información del usuario",
    User_Settings: "Configuración del usuario",
    QA: "Preguntas y respuestas",
    Cannot_export_because_there_is_no_any_difference: "No se puede exportar, porque no hay ninguna diferencia.",
    You_have_not_a_permission_to_approve_punchSet: "No tiene permiso para aprobar la marcación",
    You_have_not_a_permission_to_approve_expenses: "No tiene permiso para aprobar gastos",
    approve_only_punchset:
        "Esta tarjeta de control de tiempo contiene valores de registro de tiempo y gastos. No tiene permiso para aprobar gastos. Si continúa, solo se aprobarán los valores de la tarjeta de control de tiempo",
    approve_only_expenses:
        "Esta tarjeta de control de tiempo contiene valores de registro de tiempo y gastos. No tiene permiso para aprobar los valores de la tarjeta de control de tiempo. Si continúa, solo se aprobarán los gastos",
    Punch_has_not_phase: "La marcación no tiene etapas.",
    Are_you_sure_you_want_to_modify_this_timecard: "¿Está seguro de que desea modificar esta tarjeta de control de tiempo?",
    Type_Name: "Escriba un nombre",
    Parent_question_not_exist_in_Punch_In: "La pregunta principal no existe en la marcación de entrada",
    Parent_question_not_exist_in_Punch_Out: "La pregunta principal no existe en la marcación de salida",
    Enable_Timecard_Amount_Expenses: "Habilitar el monto de gastos de la tarjeta de control de tiempo",
    Are_you_sure_you_want_to_delete_the_selected_Client_Type: "¿Está seguro de que desea eliminar el tipo de cliente seleccionado?",
    Client_Type_Selected: "Tipo de cliente seleccionado",
    Abbreviation: "Abreviatura",
    Add_Client_Type: "Agregar nuevo tipo de cliente",
    Edit_Client_Type: "Editar tipo de cliente",
    Abbreviation_is_duplicated: "La abreviatura está duplicada",
    Client_Types: "Tipos de cliente",
    Client_Settings: "Configuración de clientes",
    Based_On_Punch: "A partir de la marcación",
    Based_On_Employee_Default_Hierarchy: "A partir de la jerarquía predeterminada del empleado",
    Are_you_sure_you_want_to_delete_the_selected_auto_break: "¿Está seguro de que desea eliminar el descanso automático seleccionado?",
    Use_Auto_Breaks: "Utilizar descansos automáticos",
    No_Answer: "Sin respuesta",
    Cannot_web_punch_The_IP_Address_is_invalid: "No se puede marcar por la web. La dirección IP ({0}) no es válida.",
    Suspense_Time: "Tiempo en espera",
    Reject_Suspense: "Rechazar tiempo en espera",
    Reject: "Rechazar",
    Attestation_Text: "Texto de certificación",
    Enable_Timecard_Approval_Attestation: "Habilitar la certificación de aprobación de la tarjeta de control de tiempo",
    Time_Approvals: "Aprobaciones de tiempo",
    required: "requerido",
    Prevent_Warning: "Prevenir advertencia",
    Language: "Idioma",
    Child_Question_Only: "Solo preguntas secundarias",
    Once_per_day: "Una vez al día",
    On_every_punch: "En cada marcación",
    Create_Exception: "Crear excepción",
    Exception_Prevent_Punch: "Excepción y prevención de marcación",
    Workflow: "Flujo de trabajo",
    Workflows: "Flujos de trabajo",
    User_Modified: "Usuario modificado",
    Cannot_choose_invalid_job: "No se puede seleccionar un trabajo no válido",
    mobile_update_punch_time_suspense_message:
        "Este marcaje tiene una hora de cambio actualizada manualmente por {0} {1} desde un dispositivo móvil {2}. Esta vez está en suspenso para su aprobación.",
    add_missing_punch_suspense_message: "Esta marcación se agregó manualmente por {0} {1} desde un dispositivo móvil {2}. Esta marcación está en espera para su aprobación.",
    JobDashboardWorkingEmployeeTooltip: "Los empleados que actualmente marcaron para este trabajo. \nSi el empleado olvida marcar, el empleado será eliminado de esta lista después de 24 horas.",
    JobDashboardWorkedEmployeeTooltip: "Cualquier empleado que tenga tiempo registrado para este trabajo en el día seleccionado.",
    JobDashboardTodayApproachingOvertimeTooltip:
        "Cualquier empleado que haya trabajado en este trabajo esta semana, \nque tenga de 32 a 40 horas semanales totales (incluidas las horas de trabajos distintos a este trabajo).",
    JobDashboardOldDayApproachingOvertimeTooltip:
        "Cualquier empleado que haya trabajado en este trabajo durante la semana seleccionada, \nque tenga de 32 a 40 horas semanales totales (incluidas las horas de trabajos distintos a este trabajo).",
    JobDashboardTodayOvertimeTooltip:
        "Cualquier empleado que haya trabajado en este trabajo esta semana, \nque tenga más de 40 horas semanales totales (incluidas las horas de trabajos distintos a este trabajo).",
    JobDashboardOldDayOvertimeTooltip:
        "Cualquier empleado que haya trabajado en este trabajo durante la semana seleccionada, \nque tenga más de 40 horas semanales totales (incluidas las horas de trabajos distintos a este trabajo).",
    No_working_worked_employee_found: "No se encontró ningún empleado que trabaje/haya trabajado",
    Show_All_Employees_With_Time_Today: "Mostrar todos los empleados con tiempo hoy",
    No_worked_employee_found: "No se encontró ningún empleado que haya trabajado",
    Worked_Employees: "Empleados que hayan trabajado",
    Currently_Working: "Que trabajan actualmente",
    No_Phase: "Sin etapa",
    Job_Phases: "Etapas del trabajo",
    Allow_Retro_Modifications: "Permitir modificaciones retroactivas",
    Change_Location: "Cambiar ubicación",
    Are_you_sure_you_want_to_change_location: "¿Está seguro de que desea cambiar la ubicación?",
    locked_pay_period_suspense_message_for_lock: `Esta marcación es para {0}, que es una fecha que ya está bloqueada por la nómina. Si se necesita agregar esta marcación a la tarjeta de control de tiempo, desbloquee primero la nómina. Seleccione "Eliminar" para eliminar esta marcación.`,
    locked_pay_period_suspense_message_for_unlock: `Esta marcación es para {0}, que es una fecha que ya está bloqueada por la nómina. El período de pago ahora está desbloqueado. "Acepte" para agregar esta marcación a la tarjeta de control de tiempo de {1} {2} o seleccione "Eliminar" para eliminar esta marcación.`,
    deleted_hierarchy_registered_device_suspense_message: `Esta marcación está en espera y no se agregó a la tarjeta de control de tiempo. La marcación se cargó desde un reloj que está registrado en un trabajo o jerarquía que se eliminó. Seleccione "Aceptar" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación. Después de aceptar, seleccione una nueva jerarquía o trabajo para la marcación.`,
    delete_device_suspense_message: `Esta marcación está en espera y no se agregó a la tarjeta de control de tiempo. El dispositivo del que provino esta marcación se eliminó antes de que se cargue la marcación desde el dispositivo. Seleccione "Aceptar" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación.`,
    delete_user_suspense_message: `El empleado {0} {1} es un usuario eliminado. No se puede agregar esta marcación a la tarjeta de control de tiempo de un empleado eliminado.`,
    inactive_user_suspense_message: `Esta marcación está en espera y no se agregó a la tarjeta de control de tiempo. En el momento de esta marcación, {0} {1} no era un empleado activo. Seleccione "Aceptar" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación.`,
    delete_punch_level_suspense_message: `Esta marcación está en espera y no se agregó a la tarjeta de control de tiempo. Se eliminó el nivel de marcación. Seleccione "Aceptar" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación. `,
    invalid_paytype_suspense_message: `Esta marcación está en espera y no se agregó a la tarjeta de control de tiempo. La forma de pago no es válida. Seleccione "Aceptar" para agregar esta marcación a la tarjeta de control de tiempo de {0} {1} o seleccione "Eliminar" para eliminar esta marcación. Después de aceptar, seleccione una forma de pago válida.`,
    invalid_punch_hierarchy_suspense_message: `Este golpe está en suspenso y no se ha agregado a la tarjeta de tiempo. No se permite la jerarquía de perforaciones. Seleccione "Aceptar" para agregar este registro a la tarjeta de tiempo de {0} {1} o seleccione "Eliminar" para eliminar este registro. Después de aceptar, seleccione la jerarquía correcta.`,
    assigned_job_suspense_message: `Este golpe está en suspenso y no se ha agregado a la tarjeta de tiempo. El perforado es incorrecto contra la asignación de trabajos. Seleccione "Aceptar" para agregar este registro a la tarjeta de tiempo de {0} {1} o seleccione "Eliminar" para eliminar este registro. Después de aceptar, seleccione un trabajo asignado.`,
    empty_phase_suspense_message: `Este golpe está en suspenso y no se ha agregado a la tarjeta de tiempo. Punch no tiene fase. Seleccione "Aceptar" para agregar este registro a la tarjeta de tiempo de {0} {1} o seleccione "Eliminar" para eliminar este registro. Después de aceptar, seleccione una fase.`,
    Punch_is_incorrect_against_assigning_jobs: "El perforado es incorrecto contra la asignación de trabajos.",
    This_punch_is_now_in_Suspense_and_can_be_found_in_the_Records_tab: "Esta marcación ahora está en espera y se puede encontrar en la pestaña de Registros.",
    Employee_is_not_an_active_employee_This_punch_is_now_in_Suspense_and_can_be_found_in_the_Records_tab:
        "El empleado no es un empleado activo. Esta marcación ahora está en espera y se puede encontrar en la pestaña de Registros.",
    Use_Punch_Rules: "Utilizar las reglas de marcación",
    Subscriptions_Selected: "{0} Suscripciones seleccionadas",
    Enable_Punch_Detail_Edit: "Habilitar la edición de los detalles de marcación",
    No_Time_Logged: "No hay tiempo registrado",
    Work_History: "Historial de trabajo",
    Show_All_Employees_In_Payroll: "Mostrar todos los empleados en la nómina",
    No_suspense_punch_found: "No se encontraron marcaciones en espera",
    Suspense: "En espera",
    Add_Missing_Punch: "Agregar la marcación faltante",
    Accept_Suspense_Punch: "Aceptar la marcación en espera",
    NotAccepted: "No aceptado",
    Accept_Suspense_Punches_Result: "Aceptar resultado de marcaciones en espera",
    Failed_to_accept: "Error al aceptar",
    Are_you_sure_you_want_to_accept_this_suspense_punch: "¿Está seguro de que desea aceptar esta marcación en espera?",
    Are_you_sure_you_want_to_accept_the_selected_suspense_punches: "¿Está seguro de que desea aceptar las marcaciones en espera?",
    Are_you_sure_you_want_to_delete_reject_the_selected_suspense_punches: "¿Está seguro de que desea eliminar/rechazar las marcaciones en espera seleccionadas?",
    Deleted: "Eliminada",
    Accepted: "Aceptada",
    Are_you_sure_you_want_to_delete_this_suspense_punch: "¿Está seguro de que desea eliminar esta marcación en espera?",
    Are_you_sure_you_want_to_reject_this_suspense_punch_time: "¿Está seguro de que desea rechazar el tiempo de esta marcación en espera?",
    Suspense_Punch: "Marcación en espera",
    Filter: "Filtro",
    Suspense_Punches: "Marcaciones en espera",
    Edit_Suspense_Punch: "Editar marcación en espera",
    Automatically_Add_Mobile_Suspense_Punch_to_Timecard: "Agregar automáticamente la marcación en espera del dispositivo móvil a la tarjeta de control de tiempo",
    WorkingEmployeeTooltip: "Empleados que actualmente marcan entrada. Si el empleado se olvida\nde marcar la salida, será eliminado de la lista después de 24 horas.",
    ApproachingOvertimeTooltip:
        'Cualquier empleado cuyas horas "regulares" semanales sean de 32 a 40 horas\n(incluidas las horas que se registran si el empleado está trabajando actualmente).\nEsto no considera las reglas de sobretiempo de California o el sobretiempo personalizado.',
    OvertimeTooltip:
        'Cualquier empleado cuyas horas "regulares" semanales sean de 40 horas o más\n(incluidas las horas que se registran si el empleado está trabajando actualmente).\nEsto no considera las reglas de sobretiempo de California o el sobretiempo personalizado.',
    Deleting_this_punch_will_delete_the_full_punch_set_Proceed: "Al eliminar esta marcación, se eliminará todo el conjunto de marcaciones. ¿Continuar?",
    Total_Employees: "Total empleado(s)",
    No_overtime_employee_found: "No se encontró ningún empleado con sobretiempo",
    Hours_Until_OT: "Horas hasta OT",
    Open_Active_Hours: "Horas abiertas/activas",
    No_approaching_overtime_employee_found: "No se encontró ningún empleado con sobretiempo",
    Approaching_Overtime: "Cerca al sobretiempo",
    No_working_employee_found: "No se encontró ningún empleado que esté trabajando",
    Scheduled_In: "Entrada programada",
    Scheduled_Out: "Salida programada",
    Current_Duration: "Duración actual",
    Working_Employees: "Empleados que están trabajando",
    Approaching_OT: "Cerca al OT",
    Working: "Trabajando",
    Require_Phase: "Requerir etapa",
    Device_Connect_Status: "Estado de conexión del dispositivo",
    Hours_To_Trigger_Device_Connection_Exception: "Horas para activar la excepción de conexión de los dispositivos",
    Are_you_sure_you_want_to_delete_this_question: "¿Está seguro de que desea eliminar esta pregunta?",
    Add_Question: "Agregar pregunta",
    Edit_Question: "Editar pregunta",
    View_Question: "Ver pregunta",
    No_Question: "Ninguna pregunta",
    No_unapproved_timeoff_request_found: "No se encontró ninguna solicitud de tiempo libre no aprobada",
    Unapproved: "No aprobada",
    Timeoff_Request: "Solicitud de tiempo libre",
    Custom_Rounded: "Redondeo personalizado",
    TwentyThreeMinute_Custom_Break_Rounding_Rule: "Regla de redondeo de descanso personalizada (<23 minutos)",
    Fifteen_Minute_Rounding_Rule: "Regla de redondeo de 15 minutos",
    Enable_Custom_Break_Rounding_Rule: "Activar regla de redondeo de descanso personalizada",
    Enable_Rate_Totals: "Habilitar totales de tasas de la tarjeta de control de tiempo",
    Enable_Timecard_Expenses: "Habilitar gastos en la tarjeta de control de tiempo",
    Enable_Prior_Period_Adjustment: "Habilitar ajuste del período anterior",
    Prior_Period_Adjustments: "Permitir ajuste del período anterior",
    Allow_Prior_Period_Adjustment_Exports: "Permitir ediciones a la exportación de ajustes del período anterior",
    Enable_Timecard_Time_Expenses: "Habilitar gastos y tiempo en la tarjeta de control de tiempo",
    Show_Payroll_Rates: "Habilitar mostrar las tasas de la nómina",
    AutoSplitOnDayBoundry: "División automática en el límite diario",
    ExportFailed: "Error de exportación",
    SkipExport: "Omitir exportación",
    TimecardSequenceError: "Error de secuencia de tarjeta de control de tiempo",
    MobileLog: "Registro móvil",
    Hide_Billing_Menu: "Ocultar menú de facturación",
    Errors: "Errores",
    Are_you_sure_you_want_to_remove_assigned_supervisor: "¿Está seguro de que desea eliminar al supervisor asignado?",
    Cannot_Recalculate_Timecard: "No se puede volver a calcular la tarjeta de control de tiempo",
    Punch_was_deleted_already: "Ya se eliminó la marcación",
    Network_Error: "Error de red",
    Please_check_your_internet_status: "Compruebe su estado de conexión a internet.",
    ExportToThirdParty_locked_warning: "Los empleados que aparecen a continuación no se pueden exportar ahora. Vuelva a intentarlo más tarde.",
    Punches_are_set_export_on_next_connector_cycle: "Las marcaciones están preparadas para exportarse en el próximo ciclo del conector",
    By_closing_this_window_without_selecting_the_VIEW_TIMECARD_button_you_will_lose_your_changes:
        "Al cerrar esta ventana sin seleccionar el botón VER TARJETA DE CONTROL DE TIEMPO, perderá sus cambios. ¿Está seguro de que desea cerrar sin guardar?",
    Exception_was_reviewed_already: "La excepción ya se revisó.",
    Punchset_is_not_exist: "La marcación no existe. Vuelva a intentar después de actualizar.",
    Cannot_approve_opened_punchset: "No se puede aprobar la marcación abierta.",
    TimecardSequence_locked_warning: "Empleado bloqueado por otras acciones. Vuelva a intentar más tarde.",
    Cannot_Review_Location_Exception: "No se puede revisar la excepción de ubicación",
    Cannot_Review_Biometric_Exception: "No se puede revisar la excepción biométrica",
    Cannot_UnApprove_Timecard: "No se puede anular la aprobación de la tarjeta de control de tiempo",
    Cannot_Approve_Timecard: "No se puede aprobar la tarjeta de control de tiempo",
    x_TimecardSequence_locked_warning: "{0} empleado(s) bloqueado(s) actualmente por otras acciones. Vuelva a intentar más tarde.",
    Timecard_sequence_locked_please_try_again_later: "Secuencia de tarjeta de control de tiempo bloqueada. Vuelva a intentar más tarde.",
    Cannot_approve_own_punchset_as_supervisor: "No puede aprobar su propia marcación como supervisor",
    Timecard_Report_Unlock_Warning:
        "Si se modifican las tarjetas de control de tiempo cuando se recupera el informe, es posible que estos datos se incluyan en el informe. Bloquee la nómina para garantizar la precisión de los datos.",
    Cannot_export_payroll_for_unlocked_employee: "No se puede exportar la nómina de un empleado desbloqueado",
    Retry: "Vuelva a intentar",
    Cannot_Lock_Payroll: "No se puede bloquear la nómina",
    Change_In_Progress: "Cambio en curso",
    Timecard_Dates: "Fechas de la tarjeta de control de tiempo",
    Timecard_Details: "Mostrar Detalles",
    Payroll_Time_Get_Warning:
        "Este período de pago contiene {0} tarjetas de control de tiempo que se están modificando actualmente, lo que puede excluir esas horas. Nota: Mientras el período de pago está desbloqueado, los datos de tiempo pueden estar cambiando a medida que se recuperan los datos de la nómina.",
    Payroll_Time_Lock_Warning:
        "Esta jerarquía contiene {0} tarjetas de control de tiempo que se están modificando actualmente, lo que puede excluir esas horas. La nómina no se puede bloquear mientras se cambian a estos empleados.",
    Generate: "Generar",
    Calculation_Date: "Fecha de cálculo",
    View_Timecard: "Ver tarjeta de control de tiempo",
    Timecard_Punch_Drawer_Alert:
        "Filtre las marcaciones que necesitan ser editadas seleccionando las fechas y horas para el filtro. Haga clic en el botón VER TARJETA DE CONTROL DE TIEMPO para generar la tarjeta de control de tiempo.",
    Generating_timecard_please_wait: "Generando tarjeta de control de tiempo, espere...",
    There_has_been_changes_made_to_the_punches_in_this_timecard_that_require_it_to_be_regenerated: "Se realizaron cambios en las marcaciones de esta tarjeta por lo que se debe volver a generar.",
    Click_the_Generate_timecard_above_to_view_the_timecard: "Haga clic en Generar tarjeta de control de tiempo para ver la tarjeta.",
    Timecard_Change_Already_In_Process: "Cambio de la tarjeta de control de tiempo ya en proceso",
    Cannot_generate_timecard: "No se puede generar la tarjeta de control de tiempo. Otro usuario o proceso está generando esta tarjeta de control de tiempo. Vuelva a intentar más tarde.",
    Generate_Timecard: "Generar tarjeta de control de tiempo",
    Add_Edit_Punches: "Agregar/Editar marcaciones",
    Loading_Timecards: "Cargar tarjetas de control de tiempo",
    Authenticating: "Autenticar",
    Force_Employee_Account_Position: "Forzar puesto de la cuenta de empleado",
    If_a_punch_is_edited_with_a_new_item_the_associated_punch_in_the_punchset_will_be_adjusted_as_well:
        "Si se edita una marcación con un nuevo elemento, la marcación asociada en el conjunto de marcaciones también se ajustará.",
    No_changes_were_made: "No se realizaron cambios.",
    You_are_editing_x_punches_to_have_the_following_properties: "Está editando {0} marcaciones para tener las siguientes propiedades:",
    Edit_Punches: "Editar marcaciones",
    Final_Review: "Revisión final",
    Note_If_field_is_left_blank_that_property_will_not_be_updated: "Nota: Si el campo se deja en blanco, esa propiedad no se actualizará.",
    Group: "Grupo",
    Edit_x_Punches: "Editar {0} marcaciones",
    Edit_Selected_Punches: "Editar marcaciones seleccionadas",
    Punch_Time: "Hora de marcación",
    No_punch_found: "No se encontró ninguna marcación",
    Apply_Filter: "Aplicar filtro",
    Invalid_time_range: "Rango de tiempo no válido",
    Global_Punch_Edit_Drawer_Alert:
        'Filtre las marcaciones que necesitan ser editadas seleccionando las fechas y horas para el filtro. A continuación, desmarque las marcaciones que no desee editar con sus cambios y haga clic en "Editar las marcaciones seleccionadas". El siguiente paso será especificar qué se cambiará.',
    Filter_Punches: "Filtrar marcaciones",
    Global_Add_Confirmation: "Confirmar adición general",
    Success: "Correctamente",
    Punch_Data_Validation_Issues: "Problemas de validación de datos en las marcaciones",
    Execution_Results: "Resultados de la ejecución",
    Global_Punch_Results: "Resultados generales de las marcaciones",
    This_action_will_add_the_specified_punch_criteria_for_the_Selected_Employees_Are_you_sure_that_you_want_to_continue:
        "Esta acción agregará los criterios de marcación especificados para los empleados seleccionados. ¿Está seguro de que desea continuar?",
    Selected_Employees: "Empleados seleccionados",
    One_or_more_of_the_selected_employees_do_not_have_permission_to_punch_to_this_hierarchy: "Uno o más de los empleados seleccionados no tienen permiso para marcar en esta jerarquía.",
    Global_Punch_Add: "Agregar marcación general",
    Global_Punch_Edit: "Editar marcación global",
    Successfully_synced: "Sincronizado correctamente",
    Are_you_sure_you_want_to_force_mobile_sync_this_employee: "¿Está seguro de que desea forzar la sincronización móvil de este empleado?",
    Force_Mobile_Sync: "Forzar la sincronización móvil",
    x_import_is_limited_to_x_rows: "La importación de {0} está limitada a {1} filas. Este archivo tiene {2} filas. Cargue un archivo con menos de {1} filas y vuelva a intentarlo.",
    Expense: "Gastos",
    View_Employee_Expense: "Ver gastos del empleado",
    Edit_Employee_Expense: "Editar gastos del empleado",
    Add_Employee_Expense: "Agregar gastos del empleado",
    Delete_Employee_Expense: "Eliminar gastos del empleado",
    Approve_Employee_Expense: "Aprobar gasto del empleado",
    View_Payroll_Expense: "Ver gasto de nómina",
    Lock_Payroll_Expense: "Bloquear gasto de nómina",
    Close_Payroll_Expense: "Cerrar gasto de nómina",
    Export_Payroll_Expense: "Exportar gastos de nómina",
    Allowed_only_x_digit_decimal_point: "Solo se permiten decimales de {0} dígitos",
    Taxable_column_should_be_Yes_or_empty: 'La columna imponible debe ser "Sí" o estar vacía',
    Required_Columns: "Columnas requeridas",
    Expected_CSV_File_Format: "Formato de archivo CSV esperado",
    Failed_to_import: "Error al importar",
    Import_Validation_Issues: "Problemas de validación de la importación",
    Successfully_imported: "Se importó correctamente",
    Are_you_sure_you_want_to_import_punches_This_cannot_be_undone: "¿Está seguro de que desea importar {0} marcaciones? Esta acción es irreversible.",
    Are_you_sure_you_want_to_import_expense_time_This_cannot_be_undone: "¿Está seguro de que desea importar {0} tiempos y gastos? Esta acción es irreversible.",
    Are_you_sure_you_want_to_import_expense_amount_This_cannot_be_undone: "¿Está seguro de que desea importar {0} montos de gastos? Esta acción es irreversible.",
    Import_Type: "Tipo de importación",
    Expense_Time_Data: "Datos de tiempos y gastos",
    Expense_Amount_Data: "Datos de montos de gastos",
    Punch_Data: "Datos de marcación",
    ImportCSV: "Importar archivo CSV",
    Are_you_sure_you_want_to_change_this_account_setting: "¿Está seguro de que desea cambiar esta configuración de cuenta?",
    Are_you_sure_you_want_to_change_this_setting_of_hierarchy: "¿Está seguro de que desea cambiar esta configuración de jerarquía?",
    Are_you_sure_you_want_to_delete_this_custom_report: "¿Está seguro de que desea eliminar este informe personalizado?",
    Compile: "Compilar",
    Default_File_Name: "Nombre de archivo predeterminado",
    File_Extension: "Extensión del archivo",
    PayrollTimeExport: "Exportar tiempo de nómina",
    PayrollExpenseExport: "Exportar gastos de nómina",
    TimecardPunchDetailReport: "Informe de detalles de marcación de la tarjeta de control de tiempo",
    TimecardEstimatedTimeReport: "Informe de tiempo estimado de la tarjeta de control de tiempo",
    TimecardInOutReport: "Informe de entrada/salida de la tarjeta de control de tiempo",
    There_is_no_Custom_Report: "No hay un informe personalizado",
    Add_Custom_Report: "Agregar informe personalizado",
    Edit_Custom_Report: "Editar informe personalizado",
    Custom_Report_Type: "Tipo de informe personalizado",
    Custom_Report: "Informe personalizado",
    Are_you_sure_you_want_to_calculate_punch_rules: "¿Está seguro de que desea calcular las reglas de marcación?",
    Calculate: "Calcular",
    Pending_Punch_Rules_Calculation: "Cálculo de las reglas de marcación pendientes",
    Enable_Punch_Rule: "Habilitar reglas de marcación",
    Single_Day: "Un día",
    Multi_Day: "Varios días",
    Punch_Day_Grouping: "Agrupación de días de marcación",
    Punch_Rule_Type: "Tipo de reglas de marcación",
    Auto_Approve_Punchsets: "Aprobación automática de punzones",
    Submit: "Enviar",
    Account_User_Settings: "Configuración del usuario de la cuenta",
    Is_Account_User: "Es usuario de la cuenta",
    not_allowed_to_recalculate_for_locked_period: "no se permite volver a calcular para el período bloqueado",
    Hide_On_Mobile: "Ocultar en el dispositivo móvil",
    Use_Date_Filter: "Usar filtro de fecha",
    Job_ID: "Identificación del trabajo",
    Client_ID: "Identificación del cliente",
    Duplicated_Job_exist: "Existe trabajo duplicado",
    Allowed_Jobs: "Trabajos permitidos",
    Limit_Device_Jobs: "Limitar trabajos del dispositivo",
    after_x_mins: "después de {0} minutos",
    Time_Window: "Ventana de tiempo",
    Time_Duration: "Duración",
    Mobile_Breaks: "Descansos por dispositivo móvil",
    There_is_no_Mobile_Break_item: "No hay ningún elemento de descansos por dispositivo móvil",
    Are_you_sure_you_want_to_delete_the_selected_mobile_break: "¿Está seguro de que desea eliminar el descanso por dispositivo móvil seleccionado?",
    failed_to_set_export: "Error al configurar la exportación",
    Edit_Phase: "Editar etapa",
    Choose_Date_Range: "Elegir intervalo de fechas",
    Exports_any_third_party_punches_that_were_not_successfully_uploaded: "Exporta la marcación de terceros que no se cargaron correctamente.",
    Download_Expenses_Report: "Descargar informe de gastos",
    Invalid_Payroll: "Nómina inválida",
    The_employee_payroll_level_is_not_valid_please_update_payroll_level: "El nivel de la nómina del empleado no es válido. Actualice el nivel de la nómina",
    Add_Phase: "Agregar etapa",
    max_x_chars: "máx. {0} caracteres",
    Phase_Selected: "Se seleccionó la etapa",
    x_Phases_Selected: "Se seleccionaron {0} etapas",
    Are_you_sure_you_want_to_delete_the_selected_phase: "¿Está seguro de que desea eliminar la(s) etapas(s) seleccionada(s)?",
    Filter_By_Default_Hierarchy: "Filtrar por jerarquía predeterminada",
    Filter_By_Timecard_Validation_Messages: "Filtrar por mensajes de validación de tarjeta de tiempo",
    Exception_Confirm_Screen_is_not_valid: "La pantalla de confirmación de excepción no es válida",
    Exception_Confirm_Screen: "Pantalla de confirmación de excepción",
    Paytypes_that_contribute_to_overtime_cannot_be_used: "No se pueden utilizar las formas de pago asociadas al sobretiempo.",
    Enter_Hours: "Ingresar horas",
    Time_Entry: "Hora de entrada",
    Private_Note: "Nota privada",
    Enable_Policy_For_Account: "Habilitar la política para la cuenta",
    Button_Label: "Etiqueta del botón",
    Button_Label_langX: "Etiqueta del botón ({0})",
    X_Questions: "{0} preguntas",
    Some_questions_are_missing_information_for_the_selected_languages: "En algunas preguntas falta información para los idiomas seleccionados.",
    PunchOut_introduction_is_not_valid: "El registro de la marcación de salida no es válida",
    PunchIn_introduction_is_not_valid: "El registro de la marcación de entrada no es válida",
    Empty_question: "Pregunta vacía",
    Use_Punch_Question: "Utilizar pregunta sobre marcación",
    Are_you_sure_you_want_to_post_punch_question: "¿Está seguro de que desea publicar esta pregunta sobre marcación?",
    Order: "Pedido",
    Exception_Response: "Respuesta de excepción",
    Prevent_Punch_Exception: "Evitar la marcación con excepción",
    Modified_Date: "Fecha de modificación",
    Prevent_punch_and_notify_user_if_response_creates_an_exception: "Evitar la marcación y notificar al usuario si la respuesta crea una excepción",
    Create_an_Exception_when_response_is: "Crear una excepción cuando la respuesta es",
    Button2: "Botón Nro. 2",
    Button1: "Botón Nro. 1",
    Button_Labels: "Etiquetas de los botones",
    Question: "Pregunta",
    Title_langX: "Título ({0})",
    New_Punch_IN_Question: "Nueva pregunta sobre marcación de entrada",
    Edit_Punch_IN_Question: "Editar pregunta sobre marcación de entrada",
    New_Punch_OUT_Question: "Nueva pregunta sobre marcación de salida",
    Edit_Punch_OUT_Question: "Editar pregunta sobre marcación de salida",
    No_Punch_IN_Questions: "No hay preguntas sobre marcación de entrada",
    No_Punch_OUT_Questions: "No hay preguntas sobre marcación de salida",
    Punch_In_Questions: "Preguntas sobre marcación de entrada",
    Punch_Out_Questions: "Preguntas sobre marcación de salida",
    Are_you_sure_you_want_to_remove_x_language: "¿Está seguro de que desea eliminar {0}?",
    Cannot_remove_default_language_Eng: "No se puede eliminar el idioma inglés, es el idioma predeterminado",
    Introduction_message: "Mensaje de introducción",
    Introduction_message_Language_x: "Mensaje de introducción ({0})",
    Include_introduction_page_message_Punch_In: "Incluir mensaje en página de introducción (Marcación de entrada)",
    Include_introduction_page_message_Punch_Out: "Incluir mensaje en página de introducción (Marcación de salida)",
    Select_Language: "Seleccionar idioma",
    Languages: "Idiomas",
    Punch_Questions: "Preguntas sobre marcación",
    Enable_Punch_Questions: "Habilitar preguntas sobre marcación",
    Hours_Per_Day_cannot_greather_than_x: "Las horas por día no pueden ser mayores que {0}",
    This_punch_is_not_valid: "Esta marcación no es válida",
    Are_you_sure_you_want_to_recalculate_this_employee_timecard: "¿Está seguro de que desea volver a calcular la tarjeta de control de tiempo de este empleado?",
    successfully_recalculated: "se recalculó correctamente",
    Recalculate: "Recalcular",
    CompileErrors: "Compilar errores",
    Enable_Payroll_Lambda: "Habilitar nómina Lambda",
    Disable_Accrual_Calculation_For_Payroll: "Deshabilitar el cálculo de acumulación",
    Are_you_sure_you_want_to_calculate_payroll: "¿Está seguro de que desea calcular la nómina?",
    Calculate_Payroll: "Calcular nómina",
    Cannot_make_for_existing_date: "No se puede hacer para la fecha existente",
    Work_Day: "Día de trabajo",
    Enable_Expenses: "Habilitar gastos",
    Time_Data: "Datos de tiempo",
    Expenses_Data: "Datos de gastos",
    Total_Paid: "Total pagado",
    Total_Deducted: "Total deducido",
    Time_Summary: "Resumen de tiempo",
    Expenses_Summary: "Resumen de gastos",
    All_IP_Address_approved: "Se aprobaron todas las direcciones IP",
    Approved_IP_Addresses: "Se aprobaron las direcciones IP",
    PayType_Removed: "Se eliminó la forma de pago",
    Calculation_Day_cannot_fall_in_locked_period: "El día del cálculo no puede ser en un período bloqueado",
    Cannot_change_the_calculation_day_grouping_for_special_punch_set: "No se puede cambiar la agrupación de días de cálculo para una marcación especial",
    Failed_to_update_punch_time_for_max_length: "No se puede actualizar el tiempo de marcación para la longitud máxima del conjunto de marcaciones",
    Enable_Calculation_Day_Group: "Habilitar grupo de días del cálculo",
    PUNCH_IN_DATE: "FECHA DE MARCACIÓN DE ENTRADA",
    Select_a_date: "Seleccionar una fecha",
    Shift_Note: "Nota del turno",
    loading: "cargando",
    No_scheduled: "Sin horario que genere conflicto",
    Are_you_sure_you_want_to_turn_on_HR: "¿Está seguro de que desea activar RR. HH.? Esto migrará la cuenta y puede tardar unos minutos.",
    Are_you_sure_you_want_to_delete_employee: "¿Está seguro de que desea eliminar empleados?",
    Are_you_sure_you_want_to_unassign_employee: "¿Está seguro de que desea anular la asignación de los empleados seleccionados?",
    Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday: "Eliminar o desactivar un empleado eliminará todas las vacaciones futuras. ¿Continuar?",
    Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday_leave: "Al borrar o desactivar a un empleado se eliminarán todas las vacaciones y licencias futuras. ¿Continuar?",
    Job_is_not_allowed_for_this_hierarchy: "El trabajo no está permitido para esta jerarquía.",
    Yes: "Sí",
    Are_you_sure_you_want_to_delete_the_selected_punch_rule: "¿Está seguro de que desea eliminar la regla de marcación seleccionada?",
    Type_script_code: "Escriba el código del script...",
    Scheduled_job: "Trabajo programado",
    CronExpression: "Cron",
    System: "Sistema",
    No_scheduled_jobs: "No hay trabajos programados",
    There_is_no_Punch_Rule_item: "No hay ningún elemento de la regla de marcación",
    Punch_Rules: "Reglas de marcación",
    HR_was_successfully_created: "Se creó RR. HH. correctamente",
    Enable_HR: "Habilitar RR. HH.",
    Client_Id_is_duplicated: "La identificación del cliente está duplicada",
    Include_Plan_Shifts: "Incluir los turnos del plan",
    Custom_Pay_Class: "Clase de pago personalizada",
    Pay_Class: "Clase de pago",
    Job_Position: "Puesto de trabajo",
    Client_Position: "Puesto del cliente",
    Account_Position_Definition: "Definición del puesto de la cuenta",
    Create_new: "Crear nuevos",
    Usable_Positions: "Puestos utilizables",
    Singular_Position_Label: "Etiqueta de posición singular",
    Singular_Job_Label: "Etiqueta de trabajo singular",
    Plural_Job_Label: "Etiqueta de trabajo plural",
    Plural_Position_Label: "Etiqueta de posición plural",
    Singular_Phase_Label: "Etiqueta de fase singular",
    Plural_Phase_Label: "Etiqueta de fase plural",
    Are_you_sure_you_want_to_delete_scheduled_job: "¿Está seguro de que desea eliminar el trabajo programado '{0}'?",
    Are_you_sure_you_want_to_delete_selected_PayClasses: "¿Está seguro de que desea eliminar las clases de pago seleccionadas?",
    Are_you_sure_you_want_to_run_scheduled_job: "¿Está seguro de que desea ejecutar el trabajo programado '{0}'? Esto no se puede detener una vez iniciado.",
    Default_PayClass: "Clase de pago predeterminada",
    No_PayClass_found: "No se encontró la Clase de pago",
    Burden: "Carga",
    Add_Pay_Class: "Agregar clase de pago",
    Edit_Pay_Class: "Editar clase de pago",
    Use_Pay_Classes: "Utilizar clases de pago",
    Tasks: "Tareas",
    Enable_PayClass: "Habilitar clase de pago",
    Enable_Use_Base_Pay_Rate_In_PayClass: "Habilitar el uso de la tarifa de pago base en la clase de pago",
    Punched_In: "Marcación de entrada",
    Punched_Out: "Marcación de salida",
    Home_Job: "Trabajo en casa",
    Select_Client: "Seleccionar cliente",
    Last_Modified: "Última modificación",
    successfully_approved: "se aprobó correctamente",
    successfully_unapproved: "no se aprobó correctamente",
    Cannot_approve_unapprove_the_approved_expense_by_supervisor: "No puede aprobar/desaprobar los gastos aprobados por el supervisor",
    Cannot_approve_the_approved_expense: "No se pueden aprobar los gastos aprobados",
    Cannot_unapprove_the_unapproved_expense: "No se pueden anular los gastos no aprobados",
    Are_you_sure_you_want_to_approve_the_selected_expense: "¿Está seguro de que desea aprobar los gastos seleccionados?",
    Are_you_sure_you_want_to_unapprove_the_selected_expense: "¿Está seguro de que desea anular la aprobación de los gastos seleccionados?",
    No_timecard_found: "No se encontró ninguna tarjeta de control de tiempo.",
    Employee_default_poisition_is_not_valid: "El puesto predeterminado del empleado no es válido. Compruébelo antes de agregar la marcación",
    Employee_default_position_is_not_valid_Are_you_want_punch: "El puesto predeterminado del empleado no es válido. ¿Está seguro de que desea marcar sin un puesto?",
    Are_you_sure_you_want_to_delete_the_selected_job: "¿Está seguro de que desea eliminar los trabajos seleccionados?",
    Job_Selected: "1 trabajo seleccionado",
    x_Job_Selected: "{0} trabajos seleccionados",
    Are_you_sure_you_want_to_delete_selected_expense: "¿Está seguro de que desea eliminar los gastos seleccionados?",
    Are_you_sure_you_want_to_delete_this_expense: "¿Está seguro de que desea eliminar este gasto?",
    Delete_Expense: "Eliminar gasto",
    Are_you_sure_you_want_to_remove_logo: "¿Está seguro de que desea eliminar el logotipo?",
    Non_Taxable: "No sujeto a impuestos",
    No_expense_found: "No se encontró ningún gasto",
    Expense_Selected: "1 gasto seleccionado",
    x_Expenses_Selected: "{0} gastos seleccionados",
    Receipt: "Recibo",
    New_Expense: "Nuevo gasto",
    Edit_Expense: "Editar gasto",
    Amount: "Monto ($)",
    Expense_Date: "Fecha del gasto",
    Taxable: "Sujeto a impuestos",
    Employee_Approved: "Empleado aprobado",
    Supervisor_Approved: "Supervisor aprobado",
    Drag_and_Drop_or_click_to_choose_a_file: "Arrastre y suelte o haga clic para elegir un archivo",
    Are_you_sure_want_to_remove_the_uploaded_file: "¿Está seguro de que desea eliminar el archivo cargado?",
    You_cant_choose_yourself_as_your_supervisor: "No puede elegirse a si mismo como su supervisor",
    No_Supervisor: "Sin supervisor",
    Will_this_user_need_to_track_time: "¿Será necesario realizar un seguimiento del tiempo para este usuario?",
    Add_Account_User: "Agregar usuario de cuenta",
    Edit_Account_User: "Editar usuario de cuenta",
    Group_By_Supervisor: "Agrupar por supervisor",
    Show_Direct_Reports_Only: "Mostrar solo subordinados directos",
    No_employee_found: "No se encontró ningún empleado",
    Select_Supervisor: "Seleccionar supervisor",
    Non_Direct_Report: "Subordinados no directos",
    View_All_Employees: "Ver todos los empleados",
    Enable_Supervisor_Direct_Report: "Habilitar subordinado directo del supervisor",
    Allow_Self_Emp_Edit: "Permitir edición por parte del empleado",
    Self_Service: "Autoservicio",
    System_Approved: "Sistema aprobado",
    No_Records: "Sin registros",
    Yes_I_am_sure_this_is_name: "Sí, estoy seguro de que es {0}",
    Score: "Puntuación",
    Secondary_Score: "Puntuación secundaria",
    NO_or_UNSURE: "NO o NO ESTOY SEGURO",
    Is_this_firstName_lastName: "¿Es {0} {1}?",
    Enable_PunchSet_Exception_Filter: "Habilitar filtro de excepción de marcación",
    Cannot_approve_the_locked_punchset: "No se puede aprobar la marcación bloqueada",
    PunchSet_approved_successfully: "La marcación se aprobó correctamente",
    PunchSet_unapproved_successfully: "La marcación no se aprobó correctamente",
    Failed_to_approve_PunchSet: "Error al aprobar la marcación",
    Failed_to_unapprove_PunchSet: "Error al anular la aprobación de la marcación",
    Approve_PunchSet: "Aprobar la marcación",
    Are_you_sure_you_want_to_approve_the_punchset: "¿Está seguro de que desea aprobar la marcación?",
    In_Img: "Imagen de entrada",
    In_Map: "Mapa de entrada",
    Out_Img: "Imagen de salida",
    Out_Map: "Mapa de salida",
    In_Bio: "Marcación biométrica de entrada",
    Out_Bio: "Marcación biométrica de salida",
    Miss: "Omitir",
    Bio: "Marcación biométrica",
    Loc: "Lugar",
    E_App: "E.App",
    S_App: "S.App",
    Punch_In_Time: "Hora de marcación de entrada",
    Punch_Out_Time: "Hora de marcación de salida",
    Sup_Approved: "S. Aprobado",
    Exceptions: "Excepciones",
    No_Exception_found: "No se encontraron excepciones.",
    Show_Reviewed: "Mostrar revisadas",
    Boundary: "Límite",
    Low_Score: "Puntuación baja",
    Supervisor: "Supervisor",
    Validation_msgs: "Mensaje de validación",
    Reviewed_by: "Revisado por",
    Mark_As_Read: "Marcar como leído",
    Approval: "Aprobación",
    Punches: "Marcaciones",
    Hierarchy_name_is_duplicated: "El nombre de la jerarquía está duplicado",
    This_field_requires_a_number_between_min_and_max: "Este campo requiere un número entre {0} y {1}",
    Applied_Hours: "Horas aplicadas",
    Applied: "Aplicado",
    This_hierarchy_is_not_registered_for_your_IP: "Esta jerarquía no está registrada para su dirección IP.",
    Your_password_has_been_updated: "Se actualizó su contraseña.",
    Please_enter_your_new_password: "Ingrese su nueva contraseña",
    Set_New_Password: "Establecer nueva contraseña",
    If_theres_Findd_account_linked_to_this_email_address: "Si hay una cuenta vinculada a esta dirección de correo electrónico, le enviaremos instrucciones para restablecer su contraseña.",
    Back_to_sign_in: "Volver al inicio de sesión",
    Request_Reset_Link: "Solicitar enlace de restablecimiento",
    Enter_your_email_address: "Escriba su dirección de correo electrónico a continuación y le ayudaremos a ingresar a su cuenta.",
    Forgot_your_password: "¿Olvidó su contraseña?",
    Forgot_password: "¿Olvidó la contraseña?",
    Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock:
        "¿Está seguro de que desea cerrar {0} jerarquías de la nómina? Al cerrar la nómina se bloquearán las jerarquías de nómina desbloqueadas para este período de pago.",
    Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock:
        "¿Está seguro de que desea cerrar la jerarquía de la nómina? El cierre de la nómina bloqueará la jerarquía de la nómina desbloqueada para este período de pago.",
    Are_you_sure_you_want_to_close_payroll_hierarchies: "¿Está seguro de que desea cerrar {0} jerarquías de la nómina?",
    Are_you_sure_you_want_to_close_payroll_hierarchy: "¿Está seguro de que desea cerrar la jerarquía de la nómina?",
    Cannot_delete_leave_request_applied_in_payroll: "No se pueden eliminar las solicitudes de licencia aplicadas en la nómina",
    Applied_Payroll: "Nómina aplicada",
    Are_you_sure_you_want_to_change_this_value_as_Global_Admin: "¿Está seguro de que desea cambiar este valor como administrador global?",
    Cannot_update_Leave_Request_for_locked_pay_period: "No se puede actualizar la solicitud de licencia para un período de pago bloqueado",
    Cannot_make_Leave_Request_for_locked_pay_period: "No se puede realizar una solicitud de licencia para un período de pago bloqueado",
    Cannot_add_Leave_Request_for_Inactive_Employee: "No se puede enviar una solicitud de permiso para un empleado inactivo.",
    Cannot_update_Locked_Leave_Request: "No se puede actualizar la solicitud de licencia bloqueada",
    Cannot_make_Locked_Leave_Request: "No se puede realizar una solicitud de licencia bloqueada",
    Cannot_delete_Accrual_used_for_Employee_Accrual: "No se puede eliminar la provisión utilizada para la provisión del empleado.",
    Cannot_delete_Accrual_which_is_referred_in_Leave_Request: "No se puede eliminar la provisión a la que se hace referencia en la solicitud de licencia.",
    Name_requires_maximum_chars: "El nombre requiere un máximo de {0} caracteres",
    ACCEPT: "ACEPTAR",
    Account: "Cuenta",
    Account_Admin: "Administrador de cuenta",
    Account_Billing_Details: "Detalles de facturación de la cuenta",
    Account_Default_Timezone: "Zona horaria predeterminada de la cuenta",
    Account_Hierarchy_Level_Definitions: "Definiciones del nivel jerárquico de la cuenta",
    Account_Position: "Posición de la cuenta",
    Account_Positions: "{0} Posiciones de la cuenta",
    Account_Positions_Table_Header: "Posiciones de la cuenta",
    Account_Settings: "Configuración de la cuenta",
    Account_User: "Usuario de la cuenta",
    Account_User_removed_successfully: "El usuario de la cuenta se eliminó correctamente",
    Account_Users: "Usuarios de la cuenta",
    Account_Users_removed_successfully: "Los usuarios de la cuenta se eliminaron correctamente",
    Accruals: "Provisiones",
    Action: "Acción",
    Contract: "Contrato",
    Activation_Date: "Fecha de activación",
    Activation_Time: "Hora de activación",
    Active: "Activo",
    ACTIVE_EMPLOYEES: "EMPLEADOS ACTIVOS",
    ActiveUsers: "Usuarios activos",
    Activity: "Actividad",
    Add: "Agregar",
    Add_Account_Role_Type: "Agregar tipo de función de cuenta",
    Add_All_Devices: "Agregar todos los dispositivos",
    Add_Another: "Agregar otro",
    Add_Auto_Break: "Agregar descanso automático",
    Add_Device: "Agregar dispositivo",
    ADD_EMPLOYEE: "Agregar empleado",
    Add_Employees: "Agregar empleados",
    Add_Equipment: "Agregar equipo",
    ADD_EQUIPMENT: "AGREGAR EQUIPO",
    Add_Hierarchy_Definition: "No hay ninguna definición del nivel jerárquico. Agregue una definición del nivel jerárquico.",
    Add_Hierarchy_Devices: "Agregar dispositivos jerárquicos",
    ADD_LOCATION: "AGREGAR UBICACIÓN",
    ADD_MICRO_LOCATION: "AGREGAR MICROLOCALIZACIÓN",
    Add_Punch: "Agregar marcación",
    Add_Employee_Devices: "Agregar dispositivos de empleados",
    AddHierarchyDefinition: "Agregar nivel jerárquico",
    AddHierarchyItemHintText: "Agregar nuevo nivel jerárquico",
    AddHierarchyItemMessage: "Agregar nuevo {0} a {1}",
    AddItem: "AGREGAR ELEMENTO",
    AddNewPosition: "Agregar puesto nuevo",
    AddNewPositionDefinition: "Agregar definición del puesto nuevo",
    AddPosition: "Agregar puesto",
    Address: "Dirección",
    Admin_Approvals: "Aprobaciones del administrador",
    All: "Todos",
    All_employees_will_have_the_account_as_payroll_hierarchy: "Todos los empleados tendrán la cuenta como jerarquía de la nómina. ¿Lo desea?",
    All_Exceptions: "Todas las excepciones",
    All_Permissions: "Todos los permisos",
    All_Records: "Todos los registros",
    Self_Service_Login: "Inicio de sesión de autoservicio",
    AllowAccessToLevels: "Permitir el acceso a otros niveles (Ver jerarquía completa)",
    AllTimecards: "Todas las tarjetas de control de tiempo",
    Apartment_suite: "Apartamento, suite, unidad, piso, etc.",
    Approve: "Aprobar",
    Approve_All: "Aprobar todo",
    Approve_all_timecards: "Aprobar todas las tarjetas de control de tiempo (conteo {0})",
    Approve_Timecard: "Aprobar la tarjeta de control de tiempo",
    Approve_Timecards: "Aprobar las tarjetas de control de tiempo",
    Approve_timecards_on_this_page: "Aprobar las tarjetas de control de tiempo en esta página (conteo {0})",
    Approve_Week: "Aprobar la semana",
    Approved: "Aprobada",
    Approved_Week: "Semana aprobada",
    ApproveSelectedTimecards: "¿Aprobar las tarjetas de control de tiempo seleccionadas?",
    Are_you_sure_delete_device: "¿Está seguro de que desea eliminar este 'dispositivo'?",
    Are_you_sure_delete_devices: "¿Está seguro de que desea eliminar los 'dispositivos' seleccionados?",
    Are_you_sure_delete_face_spaces: "¿Está seguro de que desea eliminar los 'espacios faciales' seleccionados?",
    Are_you_sure_delete_Hierarchies: "¿Está seguro de que desea eliminar las jerarquías seleccionadas?",
    Are_you_sure_delete_Hierarchy: "¿Está seguro de que desea eliminar esta jerarquía?",
    Are_you_sure_delete_Micro_Location: "¿Está seguro de que desea eliminar esta 'microlocalización'?",
    Are_you_sure_delete_Micro_Locations: "¿Está seguro de que desea eliminar las 'microlocalizaciones' seleccionadas?",
    Are_you_sure_delete_pay_group: "¿Está seguro de que desea eliminar este grupo de pago?",
    Are_you_sure_delete_pay_type: "¿Está seguro de que desea eliminar esta forma de pago?",
    Are_you_sure_delete_Punch: "¿Está seguro de que desea eliminar esta marcación?",
    Are_you_sure_replace_profile_image: "¿Está seguro de que desea eliminar la imagen del perfil de usuario actual y utilizar esta en su lugar?",
    Are_you_sure_want_to_remove_hierarchy: "¿Está seguro de que desea eliminar la jerarquía seleccionada? También se eliminarán todos los derivados de este elemento.",
    Are_you_sure_you_want_to_delete_selected_Role: "¿Está seguro de que desea eliminar la función seleccionada?",
    Are_you_sure_you_want_to_delete_selected_User: "¿Está seguro de que desea eliminar al usuario seleccionado?",
    Are_you_sure_you_want_to_delete_selected_Users: "¿Está seguro de que desea eliminar a los usuarios seleccionados?",
    Are_you_sure_you_want_to_export_payroll_for_the_selected_employee: "¿Está seguro de que desea exportar la nómina del empleado seleccionado?",
    Are_you_sure_you_want_to_export_payroll_for_the_selected_employees: "¿Está seguro de que desea exportar la nómina de los {0} empleados seleccionados?",
    Are_you_sure_you_want_to_export_payroll_for_the_X_selected_employees_as_shown_below:
        "¿Está seguro de que desea exportar la nómina de los {0} empleados seleccionados como se muestra a continuación?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies: "¿Está seguro de que desea bloquear {0} jerarquías de la nómina?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard: "¿Está seguro de que desea bloquear {0} jerarquías de la nómina que tienen tarjetas de control de tiempo no aprobadas?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard_with_expense:
        "¿Está seguro de que desea bloquear {0} jerarquías de la nómina que tienen tarjetas de control de tiempo no aprobadas? También bloqueará los gastos.",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses: "¿Está seguro de que desea bloquear {0} jerarquías de las nóminas que tienen gastos no aprobados?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses_with_timecard:
        "¿Está seguro de que desea bloquear {0} jerarquías de las nóminas que tienen gastos no aprobados? También bloqueará la tarjeta de control de tiempo.",
    Are_you_sure_you_want_to_lock_payroll_hierarchy: "¿Está seguro de que desea bloquear la jerarquía de la nómina?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard: "¿Está seguro de que desea bloquear una jerarquía de la nómina que tiene tarjetas de control de tiempo no aprobadas?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard_with_expense:
        "¿Está seguro de que desea bloquear una jerarquía de la nómina que tiene tarjetas de control de tiempo no aprobadas? También bloqueará los gastos.",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses: "¿Está seguro de que desea bloquear una jerarquía de la nómina que tiene gastos no aprobados?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses_with_timecard:
        "¿Está seguro de que desea bloquear una jerarquía de la nómina que tiene gastos no aprobados? También bloqueará la tarjeta de control de tiempo.",
    Are_you_sure_you_want_to_unapprove_timecard: "¿Está seguro de que desea desautorizar la tarjeta de control de tiempo?",
    Are_you_sure_you_want_to_unlock_payroll_hierarchies: "¿Está seguro de que desea desbloquear {0} jerarquías de la nómina?",
    Are_you_sure_you_want_to_unlock_payroll_hierarchy: "¿Está seguro de que desea desbloquear la jerarquía de la nómina?",
    Audit: "Auditoría",
    Audits: "Auditorías",
    Auto_Break: "Descanso automático",
    AutoBreaks: "Descansos automáticos",
    AutoTransfer: "Transferencia automática",
    Beacon_Registration_Code: "Código de registro de contador",
    Bi_Weekly: "Quincenal",
    Bill_Rate: "Tasa de facturación",
    Billing: "Facturación",
    Biometric: "Biométrica",
    Biometric_Exception: "Excepción biométrica",
    Biometric_Punch_Exception_Face_not_found: "Excepción de marcación biométrica. No se encontró la cara.",
    Biometric_Punch_Exception_Match_below_threshold: "Excepción de marcación biométrica. Coincidencia por debajo del umbral.",
    Biometric_Score: "Puntuación biométrica",
    Biometric_Threshold: "Umbral biométrico",
    Break_Duration: "Duración del descanso",
    By_changing_the_payroll_hierarchy_definition:
        "Al cambiar la definición de jerarquía de la nómina a '{0}', requerirá que la jerarquía de la nómina de todos los empleados se asigne automáticamente. Confirme esta acción.",
    California_Overtime: "Sobretiempo en California",
    Cancel: "Cancelar",
    CANCEL: "CANCELAR",
    Cannot_add_device_to_account_level: "No se puede agregar el dispositivo al nivel de la cuenta. Seleccione la jerarquía secundaria",
    Cannot_add_missing_punch_for_removed_hierarchy: "No se puede agregar la marcación faltante. Se eliminó el elemento de jerarquía.",
    Cannot_add_missing_punch_for_removed_position: "No se puede agregar la marcación faltante. Se eliminó el puesto.",
    The_position_has_been_removed_Are_you_want_punch: "Se eliminó el puesto. ¿Está seguro de que desea marcar sin un puesto?",
    Cannot_approve_the_locked_timecard: "No se puede aprobar la tarjeta de control de tiempo bloqueada",
    Cannot_Change_Pay_Calendar: "No se puede cambiar el calendario de pagos",
    Cannot_Change_Pay_Calendar_Contact_Findd:
        "No se puede cambiar el calendario de pagos porque este grupo de pago ya se adjuntó al menos a la marcación de un empleado. Comuníquese con el servicio de asistencia para obtener ayuda.",
    Cannot_Change_Pay_Calendar_Setting: "No se puede cambiar la configuración del calendario de pagos",
    Cannot_Change_Pay_Calendar_Setting_Contact_Findd:
        "No se puede cambiar la configuración del calendario de pagos porque este grupo de pago ya se adjuntó al menos a la marcación de un empleado. Comuníquese con el servicio de asistencia para obtener ayuda.",
    Cannot_Change_Pay_Period_Start_Day: "No se puede cambiar el día de inicio del calendario de pagos",
    Cannot_Change_Pay_Period_Start_Day_Contact_Findd:
        "No se puede cambiar el día de inicio del calendario de pagos porque este grupo de pago ya se adjuntó al menos a la marcación de un empleado. Comuníquese con el servicio de asistencia para obtener ayuda.",
    Cannot_delete_Account_Admin_user: "No se puede eliminar el usuario Administrador de cuenta",
    Cannot_Delete_Hierarchy: "No se puede eliminar la jerarquía",
    Cannot_Delete_Hierarchy_because_it_is_already_use: "No se puede eliminar la jerarquía ni sus derivados porque ya hay al menos una jerarquía en uso.",
    Cannot_delete_positions_title: "No se puede(n) eliminar el(los) puesto(s)",
    Cannot_Delete_User: "No se puede eliminar al usuario",
    Cannot_Export_Payroll_For_Selected_Employee: "No se puede exportar la nómina del empleado seleccionado",
    Cannot_export_payroll_for_selected_employee_Add_missing_punches: "No se puede exportar la nómina del empleado seleccionado. Agregue las marcaciones faltantes antes de exportar.",
    Cannot_Export_Payroll_For_Selected_Employees: "No se puede exportar la nómina de los empleados seleccionados",
    Cannot_export_payroll_for_selected_employees_Add_missing_punches: "No se puede exportar la nómina de los empleados seleccionados. Agregue las marcaciones faltantes antes de exportar.",
    Cannot_find_a_valid_address: "No se puede encontrar una dirección válida.",
    Cannot_Lock_Payroll_Hierarchy: "No se puede bloquear la jerarquía de la nómina",
    Cannot_lock_selected_Payroll_Hierarchy_because_Missing_punch_exist: "No se puede bloquear la jerarquía de la nómina seleccionada, porque la marcación faltante existe.",
    Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_punchset_exist:
        "No se puede bloquear la jerarquía de la nómina seleccionada, porque existen marcaciones no aprobadas por el supervisor.",
    Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_punchset_exist:
        "No se puede bloquear la jerarquía de la nómina seleccionada, porque existen marcaciones no aprobadas por el empleado.",
    Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_expenses_exist:
        "No se puede bloquear la jerarquía de la nómina seleccionada, porque existen gastos no aprobados por el supervisor.",
    Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_expenses_exist:
        "No se puede bloquear la jerarquía de la nómina seleccionada, porque existen gastos no aprobados por el empleado.",
    Cannot_this_UserRole: "No se puede eliminar esta función de usuario porque está asignada a la cuenta del usuario.",
    Cannot_unapprove_the_locked_timecard: "No se puede anular la aprobación de la  tarjeta de control de tiempo bloqueada",
    Cannot_approve_the_timecard_which_has_opened_punchset: "No se puede(n) aprobar la(s) tarjeta(s) de control de tiempo que tiene(n) abierta la marcación",
    CannotApproveTimecardsTitle: "No se puede(n) aprobar la(s) tarjeta(s) de control de tiempo",
    CannotExportTimecardsBody: "No se puede exportar el archivo de la nómina. Una o más tarjetas de control de tiempo requieren aprobación antes de que se puedan exportar a la nómina.",
    CannotExportTimecardsTitle: "No se puede exportar a la nómina",
    CannotFindActivationCode: "No se encontró el código de activación",
    Cant_create_employee_with_root_level: "No puede crear un empleado con el nivel raíz como predeterminado.",
    Cant_delete_positions: "La(s) siguiente(s) posición(es) no se puede(n) eliminar. Posición(es) asignada(s) a un elemento jerárquico, empleado o horario: {0}",
    Change_Date: "Cambiar fecha",
    Change_Employee_Payroll: "Cambiar la nómina de empleados",
    Change_Pay_Calendar: "Cambiar el calendario de pagos",
    Change_Pay_Calendar_as_GlobalAdmin: "Este grupo de pago ya se asignó a las marcaciones de los empleados. ¿Está seguro de que desea cambiar el calendario de pagos como administrador global?",
    Change_Pay_Calendar_Setting: "Cambiar la configuración del calendario de pagos",
    Change_Pay_Calendar_Setting_as_GlobalAdmin:
        "Este grupo de pago ya se asignó a las marcaciones de los empleados. ¿Está seguro de que desea cambiar la configuración del calendario de pagos como administrador global?",
    Change_Pay_Period_Start_Day: "Cambiar el día de inicio del calendario de pagos",
    Change_Pay_Period_Start_Day_as_GlobalAdmin:
        "Este grupo de pago ya se asignó a las marcaciones de los empleados. ¿Está seguro de que desea cambiar el día de inicio del calendario de pagos como administrador global?",
    Change_payroll_definition_as_GlobalAdmin: "¿Está seguro de que desea cambiar la definición de la nómina jerárquica como administrador global?",
    Change_payroll_as_GlobalAdmin: "La nueva configuración de pago de nómina es diferente o existe un problema con el tipo de pago. ¿Está seguro de que desea cambiarlo como administrador global?",
    Children: "Derivados(as)",
    Choose_Approve_All_Timecard_Option: "Elija la opción Aprobar todas las tarjetas de control de tiempo",
    Choose_Employee: "Seleccione empleado",
    Choose_Equipment: "Seleccione equipo",
    CHOOSE_HIERARCHY_ITEM: "SELECCIONE ELEMENTO DE JERARQUÍA",
    Choose_Unapprove_All_Timecard_Option: "Seleccione la opción Desaprobar todas las tarjetas de control de tiempo",
    ChooseLocationHierarchy: "Nivel de ubicación",
    ChoosePunchHierarchy: "Nivel de marcación",
    City: "Ciudad",
    click_to_view_x_records: "Haga clic para ver {0} registros.",
    Clock_Mode: "Modo de reloj",
    Clock_PIN: "PIN del reloj",
    Clock_PIN_must_be_unique: "El PIN del reloj debe ser único",
    Close: "Cerrar",
    confirm_approve_all_biometric_exceptions: "¿Está seguro de que desea aprobar todas las excepciones biométricas en esta página?",
    confirm_approve_all_location_exceptions: "¿Está seguro de que desea aprobar todas las excepciones de ubicación en esta página?",
    Confirm_delete_equipment: "¿Está seguro de que desea eliminar el 'equipo' seleccionado?",
    Confirm_delete_client: "¿Está seguro de que desea eliminar el (los) cliente(s) seleccionado(s)?",
    Confirm_Dialog: "Confirmar cuadro de diálogo",
    confirm_reject_all_biometric_exceptions: "¿Está seguro de que desea rechazar todas las excepciones biométricas en esta página?",
    confirm_reject_all_location_exceptions: "¿Está seguro de que desea rechazar todas las excepciones de ubicación en esta página?",
    Are_you_sure_you_want_to_approve_the_timecard: "¿Está seguro de que desea aprobar la tarjeta de control de tiempo?",
    CONFIRMED_IMAGES_OF_x: "Imágenes confirmadas de {0}",
    Compose_New_message: "Compose New Message",
    ConfirmUnlockTimecard:
        "Está seguro de que desea desbloquear esta tarjeta de control de tiempo? Esta acción requerirá una nueva aprobación antes de que la tarjeta de control de tiempo pueda exportarse a la nómina.",
    COPY: "Copiar",
    COPY_OF: "Copia de",
    Cost_Center_cannot_be_longer_than: "El centro de costos no puede tener más de 10 caracteres.",
    Cost_Center_should_not_consist_of_white_spaces: "El centro de costos no debe tener espacios en blanco",
    CostCenter: "Centro de costos",
    CostCenterCode: "Código del centro de costos",
    Country: "País",
    Credit_Accrual: "Contribución a la provisión",
    Currency: "Currency",
    Current_Hierarchy: "Jerarquía actual",
    Punch_Detail_Report: "Informe de detalles de la marcación",
    Dashboard: "Panel de control",
    DASHBOARD: "PANEL DE CONTROL",
    Date: "Fecha",
    Date_Format: "Formato de fecha",
    Date_Time: "Fecha/hora",
    Default_Geofence_Perimeter: "Perímetro de la geo-valla predeterminado",
    Default_Hierarchy: "Jerarquía predeterminada",
    Default_hierarchy_changed: 'La jerarquía predeterminada cambió a "{0}" ¿También desea cambiar la jerarquía de la nómina a "{1}"?',
    Default_Microlocation_Perimeter: "Perímetro de microubicación predeterminadar",
    Default_Pay_Type: "Forma de pago predeterminada",
    DefaultPosition: "Puesto predeterminado",
    Delete: "Eliminar",
    DELETE: "ELIMINAR",
    Delete_All_Devices: "Eliminar todos los dispositivos",
    Delete_Auto_Break: "Eliminar el descanso automático",
    Delete_Device: "Eliminar el dispositivo",
    DELETE_EMPLOYEE: "ELIMINAR EMPLEADO",
    Delete_Employees: "Eliminar empleados",
    DELETE_EMPLOYEES: "ELIMINAR EMPLEADOS",
    Delete_Equipment: "Eliminar equipo",
    DELETE_EQUIPMENT: "ELIMINAR EQUIPO",
    Delete_Client: "Eliminar cliente",
    DELETE_HIERARCHIES: "ELIMINAR JERARQUÍAS",
    DELETE_HIERARCHY: "ELIMINAR JERARQUÍA",
    Delete_Hierarchy_Devices: "Eliminar dispositivos jerárquicos",
    DELETE_MICRO_LOCATION: "ELIMINAR MICROLOCALIZACIÓN",
    DELETE_MICRO_LOCATIONS: "ELIMINAR MICROLOCALIZACIONES SELECCIONADAS",
    Delete_Pay_Group: "Eliminar grupo de pago",
    Delete_Pay_Type: "Eliminar forma de pago",
    Delete_Punch: "Eliminar marcación",
    Delete_Selected_Devices: "Eliminar dispositivos seleccionados",
    DELETE_SELECTED_FACE_SPACES: "ELIMINAR ESPACIOS FACIALES SELECCIONADOS",
    DELETE_SELECTED_USER: "ELIMINAR USUARIO SELECCIONADO",
    DELETE_SELECTED_USERS: "ELIMINAR USUARIOS SELECCIONADOS",
    Delete_Employee_Devices: "Eliminar dispositivos de empleados",
    Description: "Descripción",
    DeSelectAll: "Desmarcar todo",
    Details: "Detalles",
    DETAILS: "DETALLES",
    Device: "Dispositivo",
    Device_deleted_successfully: "El dispositivo se eliminó correctamente",
    Device_Location_not_found: "No se encontró la ubicación del dispositivo",
    Device_Logs: "Registros del dispositivo",
    Device_Name: "Nombre del dispositivo",
    Device_Selected: "1 Dispositivo seleccionado",
    Devices: "Dispositivos",
    DEVICES: "DISPOSITIVOS",
    DisableLocationExceptions: "Desactivar las excepciones de ubicación",
    DiffWithPrevious: "Diferencia",
    Do_Not_Require_Photo_On_Punch: "No se requiere foto en la marcación",
    Do_Not_Require_Photo_On_Transfer: "No requiere foto en la transferencia",
    Do_you_want_to_change_payroll: "¿Quieres cambiar la nómina?",
    DoubleOvertimeHours: "OT2",
    Download: "Descargar",
    DownloadPayrollFile: "Descargar archivo de la nómina",
    Download_Payroll_Expenses_File: "Descargar archivo de gastos de la nómina",
    DownloadPayrollReport: "Descargar informe de la nómina",
    Duration_to_Trigger_Break: "Duración para activar el descanso",
    Edit: "Editar",
    Edit_Account_Role_Type: "Editar el tipo de función de la cuenta",
    Edit_All_Devices: "Editar todos los dispositivos",
    Edit_Auto_Break: "Editar el descanso automático",
    Edit_Device: "Editar el dispositivo",
    Edit_Employees: "Editar los empleados",
    Edit_Equipment: "Editar el equipo",
    Edit_Exceptions: "Editar las excepciones",
    Edit_Hierarchy: "Editar la jerarquía",
    Edit_Hierarchy_Devices: "Editar los dispositivos jerárquicos",
    Edit_Pay_Group: "Editar el grupo de pago",
    Edit_Pay_Type: "Editar la forma de pago",
    Pay_Type_Code: "Código de la forma de pago",
    Edit_Timecard: "Editar la tarjeta de control de tiempo",
    Edit_Timecards: "Editar las tarjetas de control de tiempo",
    Edit_Employee_Devices: "Editar los dispositivos de los empleados",
    EditPosition: "Editar puesto",
    Email_already_in_use: "El correo electrónico ya está en uso.",
    Email_cannot_be_empty: "El correo electrónico no puede estar vacío",
    Employee: "Empleado",
    Employee_created_successfully: "El empleado se creó correctamente",
    Employee_Devices: "Dispositivos de los empleados",
    Employee_Edit: "Editar empleado",
    Employee_Hierarchy: "Jerarquía de empleados",
    Employee_ID: "Identificación del empleado",
    Employee_ID_cannot_be_empty: "La identificación del empleado no puede estar vacía.",
    Employee_ID_must_be_unique: "La identificación del empleado debe ser única",
    Employee_is_required: "Se requiere el empleado.",
    Employee_Selected: "1 Empleado seleccionado",
    Employees: "Empleados",
    EMPLOYEES: "EMPLEADOS",
    Enable_Auto_Transfer: "Habilitar transferencia automática",
    Enable_Equipment: "Habilitar equipo",
    Enable_Hierarchy: "Habilitar jerarquía",
    Enable_I9_Workflow: "Habilitar el flujo de trabajo I9",
    Enable_Location_Exception_on_Transfer: "Habilitar la excepción de ubicación en la transferencia",
    Enable_Mobile_Time_Fraud_Prevention: "Habilitar la prevención de fraude de tiempo por dispositivo móvil",
    Enable_Payroll: "Habilitar la nómina",
    Enable_Date_Time_Edit: "Habilitar la edición de fecha/hora",
    Enable_Timecards: "Habilitar las tarjetas de control de tiempo",
    EnableLocationException: "Habilitar la excepción de ubicación",
    Ensure_following_on_mobile_device: "Asegúrese de lo siguiente en el dispositivo móvil:",
    Equipment: "Equipo",
    Equipment_created_successfully: "El equipo se creó correctamente",
    Equipment_deleted_successfully: "El equipo se eliminó correctamente",
    Equipment_Distribution: "Distribución del equipo",
    Equipment_Selected: "1 Equipo seleccionado",
    Client_Selected: "1 Cliente seleccionado",
    Error: "Error",
    Exception: "Excepción",
    EXCEPTION: "EXCEPCIÓN",
    EXCEPTIONS: "EXCEPCIONES",
    Explain_account_hierarchy_settings:
        "De forma predeterminada, las asignaciones jerárquicas tanto a los empleados como a los usuarios de la cuenta permiten que estos usuarios accedan a su elemento jerárquico predeterminado y a cualquier elemento jerárquico secundario por debajo de su nivel predeterminado. Al hacer explícita la asignación jerárquica, se requerirá que el empleado o el usuario de la cuenta se asigne a cada elemento jerárquico para acceder a dicho elemento. Esto permite asignaciones que no siguen fácilmente las relaciones entre principales y secundarias.",
    Export_Payroll: "Exportar la nómina",
    Export_X_employees_with_unapproved_time: "Exportar {0} empleado(s) con tiempo no aprobado",
    ExportAllTimecardsBody: "¿Está seguro de que desea crear y descargar el archivo de la nómina y marcar todas las tarjetas de control de tiempo en este período de pago como exportadas?",
    ExportAllTimecardsTitle: "Exportar el archivo de la nómina",
    Exported: "Exportado",
    ExportPayrollFile: "Exportar el archivo de la nómina",
    External_ID: "Identificación externa",
    External_ID2: "Identificación externa 2",
    External_ID3: "Identificación externa 3",
    External_ID_cannot_be_empty: "La identificación externa no puede estar vacía.",
    External_ID_must_be_unique: "La identificación externa debe ser única",
    face_spaces: "espacios faciales",
    FACE_SPACES: "ESPACIOS FACIALES",
    Failed_to_add_punch: "Error al agregar la marcación",
    Failed_to_add_UserRole: "Error al agregar la función de usuario",
    Failed_to_approve_Timecard: "Error al aprobar la tarjeta de control de tiempo",
    Failed_to_delete_punch: "Error al eliminar la marcación",
    Failed_to_export_payroll_Please_try_again_later: "Error al exportar la nómina. Vuelva a intentarlo más tarde",
    Failed_to_get_payroll_Please_try_again_later: "Error al obtener la nómina. Vuelva a intentarlo más tarde",
    Failed_to_lock_payroll_Please_try_again_later: "Error al bloquear la nómina. Vuelva a intentarlo más tarde",
    Failed_to_remove_Account_User: "Error al eliminar el usuario de la cuenta",
    Failed_to_remove_Account_Users: "Error al eliminar a los usuarios de la cuenta",
    Failed_to_remove_UserRole: "Error al eliminar la función de usuario",
    Failed_to_unapprove_Timecard: "Error al desaprobar la tarjeta de control de tiempo",
    Failed_to_unlock_payroll_Please_try_again_later: "Error al desbloquear la nómina. Vuelva a intentarlo más tarde",
    Failed_to_update_punch_for_lock_period: "Error al actualizar la marcación para el período de bloqueo",
    Failed_to_update_UserRole: "Error al actualizar la función de usuario",
    Features: "Características",
    First_Name: "Nombre",
    LongRunning: "Ejecución larga",
    First_Name_cannot_be_empty: "El nombre no puede estar vacío.",
    Finished: "Finalizada",
    it_cannot_be_longer_than_x_chars: "No puede tener más de {0} caracteres",
    first_week: "1ª semana",
    For_root: "en el nivel jerárquico raíz",
    General: "General",
    Geofence_Perimeter: "Perímetro de la geo-valla (metros)",
    Geofence_Violation: "Violación de la geo-valla",
    GPS: "GPS",
    GPS_is_enabled: "El GPS está activado",
    Hierarchies: "Jerarquías",
    Hierarchies_Selected: "Jerarquías seleccionadas",
    Hierarchy: "Jerarquía",
    HIERARCHY: "JERARQUÍA",
    Hierarchy_added_successfully: "La jerarquía se agregó correctamente",
    Hierarchy_already_added: "La jerarquía ya se agregó. Elija un nombre de jerarquía diferente.",
    Hierarchy_Children: "Jerarquías secundarias",
    Hierarchy_deleted_successfully: "Se eliminaron correctamente",
    Hierarchy_Details: "Detalles de la jerarquía",
    Hierarchy_Devices: "Dispositivos jerárquicos",
    Hierarchy_Distribution: "Distribución jerárquica",
    Hierarchy_Employees: "Empleados jerárquicos",
    Hierarchy_Item_Selected: "Elemento jerárquico seleccionado",
    Hierarchy_Location: "Ubicación de la jerarquía",
    Hierarchy_Name: "Nombre de la jerarquía",
    Hierarchy_Position: "Puesto jerárquico",
    Hierarchy_Positions: "{0} Puestos jerárquicos",
    Hierarchy_Positions_Table_Title: "Puestos jerárquicos",
    Hierarchy_Punch_Report: "Informe de marcación según jerarquía",
    Hierarchy_Records: "Registros de jerarquía",
    Hierarchy_Selected: "Jerarquía seleccionada",
    Hierarchy_Settings: "Configuración de jerarquía",
    Hierarchy_Users: "Usuarios de jerarquía",
    HierarchyDefinitions: "Definiciones de jerarquía",
    HierarchyItemLabel: "Etiqueta del elemento",
    HierarchyLevel: "Nivel de jerarquía",
    History: "Historial",
    Home_Hierarchy: "Inicio de jerarquía",
    Hours_Worked: "Horas trabajadas",
    Id: "Identificación",
    Image: "Imagen",
    In: "Entrada",
    InactiveUsers: "Usuarios inactivos",
    Include_employees_that_have_already_been_exported: "Incluir los empleados que ya se exportaron",
    Individual_Mode: "Modo individual",
    Input_a_valid_value: "Ingrese un valor válido.",
    Input_valid_integer: "Ingrese un número entero válido.",
    Invalid_email_format: "Formato de correo electrónico no válido.",
    invalid_email_password_combo: "¡Vaya! Esta combinación de correo electrónico/contraseña no es válida.",
    Invalid_External_Id: "Identificación externa no válida",
    Invalid_ID_format: "Formato de identificación no válido.",
    iOS_warning_body:
        "Esta aplicación web no está diseñada para ser vista en iOS. Es posible que este dispositivo no procese la aplicación correctamente. Se recomienda que utilice un navegador completo para disfrutar de la mejor experiencia",
    iOS_warning_title: "ADVERTENCIA: El dispositivo iOS no es compatible",
    Is_this_x: "¿Es {0} {1}?",
    IsAdmin: "Es administrador de la cuenta",
    Item: "Artículo",
    Job_Costing_Summary: "Resumen del costo del trabajo",
    Language_Id: "Identificación del idioma",
    LastRunTime: "Tiempo de la última ejecución",
    Last_employee_has_not_image: "El último empleado no tiene imagen.",
    Last_Month: "Último mes",
    Last_Name: "Apellido",
    Last_Name_cannot_be_empty: "El apellido no puede estar vacío.",
    Last_Pay_Period: "Período de pago anterior",
    Last_Time: "Última vez",
    Last_Week: "Última semana",
    LAT_LNG: "Latitud/Longitud",
    Latitude: "Latitud",
    Level: "Nivel",
    Level_is_disabled_for_employees: "El nivel {0} está desactivado para los empleados",
    Linked_Account_Position: "Puesto de la cuenta vinculada",
    List: "Lista",
    Liveness_Score: "Liveness Score",
    Localization: "Localización",
    Location: "Ubicación",
    Location_enabled_Findd_app: "Los servicios de ubicación están habilitados para esta aplicación",
    Location_Exception: "Excepción de ubicación",
    Location_Name: "Nombre de la ubicación",
    Location_not_available: "La ubicación no está disponible",
    Location_Selected: "1 ubicación seleccionada",
    Locations: "Ubicaciones",
    LOCATIONS: "UBICACIONES",
    Lock: "Bloqueo",
    Lock_Payroll: "Bloquear la nómina",
    Lock_Payroll_Hierarchy: "Bloquear la jerarquía de la nómina",
    Locked: "Bloqueada",
    Login: "Iniciar sesión",
    Login_Email: "Correo electrónico de inicio de sesión",
    Longitude: "Longitud",
    Manual_Punch: "Marcación manual",
    Map: "Mapa",
    Max_PunchSet_Length_hours: "Longitud máxima del conjunto de marcación (horas)",
    meters: "metro(s)",
    Message_Center: "Message Center",
    Message: "Message",
    No_Messages: "No Messages",
    kilometers: "kilómetro(s)",
    Micro_Location_Selected: "1 micro ubicación seleccionada",
    Micro_Locations: "Micro ubicaciones",
    minutes: "minutos",
    Missing: "Faltante",
    Open_Punches: "Marcación abierta",
    Mobile: "Dispositivo móvil",
    MobileClockMode: "Modo de reloj móvil",
    Monthly: "Mensualmente",
    Multiple_Locations: "Ubicaciones múltiples",
    Name: "Nombre",
    Name_cannot_be_empty: "El nombre no puede estar vacío.",
    NameRequired: "Nombre requerido",
    New_Pay_Group: "Nuevo grupo de pago",
    New_Pay_Type: "Nueva forma de pago",
    NextRunTime: "Tiempo de ejecución siguiente",
    Next_Week: "Semana siguiente",
    No: "No",
    No_device_found: "No se encontró ningún dispositivo",
    NoCompileError: "Sin errores de compilación",
    No_Device_Location: "Sin ubicación del dispositivo",
    No_Equipment: "Sin equipo",
    No_equipment_found: "No se encontró ningún equipo",
    No_GPS_Location: "Sin ubicación GPS",
    No_GPSBeacon: "Sin GPS/Contador",
    No_Hierarchy: "Sin jerarquía",
    No_hierarchy_found: "No se encontró ninguna jerarquía",
    No_hierarchy_level: "Sin nivel jerárquico",
    No_image: "Sin imagen.",
    No_Job_Costing_Summary_Data: "Sin datos de resumen de costos de trabajo",
    No_known_metadata_for_this_equipment: "No se conocen los metadatos para este equipo",
    No_Level: "Sin {0}",
    No_Location: "Sin ubicación",
    No_Location_Data: "Sin datos de ubicación",
    No_Microlocation_In_Range: "Sin microubicación en el rango",
    No_Pay_Type: "Sin forma de pago",
    No_Payroll_Time_by_Hierarchy_Data: "Sin datos de tiempo de la nómina por jerarquía",
    No_Payroll_Expenses_by_Hierarchy_Data: "Sin datos de gastos de la nómina por jerarquía",
    No_Position: "Sin puesto",
    No_Positions_found: "No se encontraron puestos",
    No_User_Role: "Sin función de usuario",
    not_inherited: "no heredado",
    Not_Reviewed: "No revisado",
    NotApproved: "No aprobado",
    Note: "Nota",
    NoteSubscriberList: "Lista de correos electrónicos de suscriptores (separados por comas)",
    NoteSubscriberListError: "Formato incorrecto de la lista de correos electrónicos. Separe cada correo electrónico válido con una coma.",
    NoteSubscribers: "Suscriptores",
    NoteType: "Tipo de nota",
    NoteTypes: "Tipos de nota",
    NoNoteTypes: "Sin tipos de notas",
    FrontEndFormScript: "Formulario personalizado",
    AreYouSureYouWantToDeleteNoteType: "¿Está seguro de que desea eliminar el tipo de nota?",
    NotFindPage: "ERROR 404",
    NoUnlockTimecard: "No se puede desbloquear la tarjeta de control de tiempo",
    NoUnlockTimecardBody: "Esta tarjeta de control de tiempo ya se exportó. No se puede desbloquear una tarjeta de control de tiempo que ya se exportó a la nómina.",
    OK: "De acuerdo",
    Only_account_admin_can_have_root_level: "Solo el administrador de la cuenta puede tener el nivel raíz.",
    OptionalTasks: "Tareas opcionales",
    Original_Timecard: "Tarjeta de control de tiempo original",
    Modified_Timecard: "Tarjeta de control de tiempo modificada",
    Pending_Difference_Timecard: "Tarjeta de control de tiempo de diferencia pendiente",
    Exported_Difference_Timecard: "Tarjeta de control de tiempo de diferencia exportada",
    OT_Hours: "Horas de OT",
    OT2_Hours: "Horas de OT2",
    Other: "Otro",
    Out: "Salida",
    Override: "Anular",
    Override_Rate: "Tipo de anulación",
    Overtime: "Sobretiempo",
    OvertimeHours: "OT",
    Paid_Time: "Permiso retribuido",
    Password: "Contraseña",
    Password_Confirm_Required: "Se requiere confirmación de la contraseña.",
    Password_Confirmation: "Confirmación de la contraseña",
    Password_required: "Contraseña obligatoria.",
    Passwords_must_match: "Las contraseñas deben coincidir.",
    Pay: "Pagar",
    Pay_Calendar: "Calendario de pagos",
    Pay_Calendar_Day1: "Día 1 del calendario de pagos (1-15)",
    Pay_Calendar_Day2: "Día 2 del calendario de pagos (16-28)",
    Pay_Calendar_Property: "Propiedad del calendario de pagos",
    Pay_Calendar_Start_Date: "Fecha de inicio del calendario de pagos",
    Pay_Calendar_Start_Date_and_Pay_Period_Start_Day_match: "La fecha de inicio del calendario de pagos y el día de inicio del período de pagos deben ser el mismo día de la semana.",
    Pay_Calendar_Start_Day: "Día de inicio del calendario de pagos (1-28)",
    Pay_Calendar_Type: "Tipo de calendario de pagos",
    Pay_Configuration: "Configuración de pagos",
    Pay_Group: "Grupo de pago",
    Pay_Group_Name: "Nombre del grupo de pago",
    Pay_Group_Selected: "Grupo de pago seleccionado",
    Pay_Groups: "Grupos de pago",
    Pay_Period: "Período de pagos",
    Pay_Period_Length: "Duración del período de pagos",
    Pay_Period_Start_Day: "Día de inicio del período de pagos",
    Pay_Rate: "Tasa de pagos",
    Pay_Type: "Forma de pago",
    Pay_Type_Name: "Nombre de la forma de pago",
    Pay_Type_Selected: "Forma de pago seleccionada",
    Pay_Type_Required: "Forma de pago requerida",
    Pay_Types: "Formas de pago",
    Require_at_least_one_PayType: "Se requiere al menos una forma de pago",
    Payroll: "Nómina",
    Payroll_by_Hierarchy: "Nómina por jerarquía",
    Payroll_exported_successfully: "La nómina se exportó correctamente",
    Payroll_Hierarchy: "Jerarquía de la nómina",
    Payroll_Hierarchy_Level: "Nivel de jerarquía de la nómina",
    Payroll_Hours_Summary: "Resumen de horas de la nómina",
    Payroll_locked_successfully: "La nómina se bloqueó correctamente",
    Payroll_unlocked_successfully: "La nómina se desbloqueó correctamente",
    PayrollExportName: "Nombre de exportación de la nómina",
    PayType_created_successfully: "La forma de pago se creó correctamente",
    PayType_removed_successfully: "La forma pago se eliminó correctamente",
    PayType_updated_successfully: "La forma de pago se actualizó correctamente",
    Permissions: "Permisos",
    Please_choose_an_employee: "Elija un empleado.",
    Please_choose_employee: "Elija un empleado",
    Please_choose_payroll_hierarchy: "Elija la jerarquía de la nómina",
    Please_try_again_to_update_hierarchy: "Vuelva a intentarlo para actualizar la jerarquía",
    Position: "Puesto",
    Position_added_successfully: "El puesto se agregó correctamente",
    Position_deleted_successfully: "Se eliminó o desvinculó correctamente",
    Position_Distribution: "Distribución del puesto",
    Position_updated_successfully: "El puesto se actualizó correctamente",
    Positions: "Puestos",
    Positions_selected: "{0} Puestos",
    Provide_Clock_PIN: "Ingrese el PIN del reloj",
    Running: "En ejecución",
    Provide_External_ID: "Ingrese la identificación externa",
    Punch_added_manually: "Se agregó la marcación manualmente",
    Punch_added_successfully: "La marcación se agregó correctamente",
    Punch_added_without_image: "La marcación se agregó sin imagen",
    Punch_Records: "Registros de marcación",
    Punch_set_calculation_date: "Fecha de cálculo del conjunto de marcación:",
    Record_Selected: "1 registro seleccionado",
    Records: "Registros",
    RECORDS: "REGISTROS",
    Reg_Hours: "Horas del registro",
    Registration_Code: "Código del registro",
    Registration_code_cannot_be_empty: "El código del registro no puede estar vacío.",
    Registration_code_could_not_be_found: "No se pudo encontrar el código de registro",
    Mode: "Modo",
    RegularHours: "Registro",
    REJECT: "RECHAZAR",
    Reject_All: "Rechazar todo",
    Reject_Unsure: "Rechazar/En duda",
    Rejected: "Rechazado",
    REMOVE: "RETIRAR",
    ReportDate: "Fecha del informe",
    Reports: "Informes",
    Require_Explicit_Account_User_Hierarchy_Assignment: "Requerir asignación explícita de la jerarquía del usuario de la cuenta",
    Require_Explicit_Employee_Hierarchy_Assignment: "Requerir asignación explícita de la jerarquía del empleado",
    RequiredTasks: "Tareas necesarias",
    Role: "Función",
    Role_Selected: "Función seleccionada",
    Role_Type: "Tipo de función",
    Roles: "Funciones",
    Rounded: "Redondeado",
    RoundedFrom: "Redondeado desde",
    RoundingRules: "Reglas de redondeo",
    Rows_per_page: "Filas por página:",
    Save: "Guardar",
    SAVE: "GUARDAR",
    search: "buscar",
    Search: "Buscar",
    Refresh: "Actualizar",
    second_week: "2ª semana",
    third_week: "3ª semana",
    Select_Pay_Type: "Seleccionar la forma de pago",
    SelectAll: "Seleccionar todo",
    Selected_employee_unapproved_Are_you_sure_you_want_to_export_employee: "El tiempo del empleado seleccionado aún no se aprobó. ¿Está seguro de que desea exportar la nómina de este empleado?",
    Selected_employee_unapproved_Are_you_sure_you_want_to_export_employees: "{0} empleado tiene tiempo que aún no se aprobó. ¿Está seguro de que desea exportar la nómina de {1} empleados?",
    Selected_employees_unapproved_Are_you_sure_you_want_to_export_employees: "{0} empleados tienen tiempo que aún no se aprobó. ¿Está seguro de que desea exportar la nómina de {1} empleados?",
    SelectPosition: "Seleccionar puesto",
    SelectPositionTitle: "Seleccionar puesto",
    Semi_Monthly: "Quincenal",
    Sensor_ID: "Identificación del sensor",
    Set_Password: "Establecer contraseña",
    Settings: "Configuración",
    ShowComponentTimecards: "Mostrar tarjetas de control de tiempo de componentes",
    something_went_wrong: "¡Vaya! Algo salió mal.",
    Something_went_wrong: "Lo sentimos algo salió mal :(",
    State_Province_Region: "Estado/Provincia/Región",
    Street_Address: "Dirección postal, apartado postal, nombre de la empresa, a/c",
    Successfully_deleted: "Se eliminó correctamente",
    Successfully_updated: "Se actualizó correctamente",
    Successfully_unassigned: "Se desasignó correctamente",
    ShowSystemJobs: "Mostrar trabajos del sistema",
    ShowAllAccountSystemJobs: "Mostrar todos los trabajos del sistema de cuentas",
    Tags: "Etiquetas",
    Task: "1 tarea",
    x_Tasks: "{0} tareas",
    The_last_punch_was_added_manually: "La última marcación se agregó manualmente.",
    The_name_cannot_be_longer_than: "El nombre no puede tener más de 30 caracteres.",
    The_name_must_be_unique: "El nombre debe ser único.",
    The_pay_type_code_must_be_unique: "el código de tipo de pago debe ser único",
    The_number_is_too_high: "El número es demasiado grande.",
    The_number_is_too_low: "El número es demasiado pequeño.",
    There_is_no_Auto_Break_item: "No hay ningún elemento de descanso automático.",
    There_is_no_pay_group: "No hay ningún grupo de pago.",
    There_is_no_pay_type: "No hay forma de pago.",
    There_is_no_work_history: "No hay historial de trabajo",
    This_employee_has_been_deleted: "Este empleado se eliminó",
    This_Employee_has_No_Hierarchies: "Este empleado no tiene jerarquía.",
    This_employee_has_not_image: "Este empleado no tiene imagen.",
    This_equipment_has_not_history: "El equipo no tiene historial.",
    This_field_is_required: "Este campo es obligatorio.",
    This_field_requires_a_number_between_0_and_100: "Este campo requiere un número entre 0 y 100.",
    This_field_requires_a_number_between_0_and_1000: "Este campo requiere un número entre 0 y 1000.",
    This_field_requires_a_number_between_1_and_24: "Este campo requiere un número entre 1 y 24.",
    This_field_requires_a_number_between_1_and_5: "Este campo requiere un número entre 1 y 5.",
    This_field_requires_an_integer_between_1_and_28: "Este campo requiere un número entero entre 1 y 28.",
    This_field_requires_an_integer_between_2_and_10: "Este campo requiere un número entero entre 2 y 10.",
    This_field_requires_a_number_greater_than_0: "Este campo requiere un número mayor que 0",
    This_field_requires_minimum_10_chars: "Este campo requiere un mínimo de 10 caracteres.",
    This_hierarchy_item_cant_be_assigned: "No se puede asignar este elemento de jerarquía",
    This_is_a_required_field: "Este campo es obligatorio.",
    This_is_x: "Este es {0}",
    Invalid_for_employee: "No válido para el empleado",
    This_Month: "Este mes",
    This_Pay_Period: "Período de pago actual",
    This_Pay_Type_is_used_as_a_default_Pay_Type_Cannot_remove_it: "Esta forma de pago se utiliza como forma de pago predeterminada. No se puede eliminar.",
    This_Pay_Type_is_used_Cannot_remove_it: "Se utiliza esta forma de pago. No se puede eliminar.",
    This_Week: "Esta semana",
    ThisIsALocation: "Esta es una ubicación (GPS)",
    ThisIsAMicroLocation: "Esta es una microubicación (contador)",
    Time: "Hora",
    Timecard: "Tarjeta de control de tiempo",
    Timecard_approved_successfully: "La tarjeta de control de tiempo se aprobó correctamente",
    Timecard_unapproved_successfully: "La tarjeta de control de tiempo no se aprobó correctamente",
    TimecardApprovedMessage: "Tarjeta de control de tiempo aprobada y bloqueada. Las tarjetas de control de tiempo no se pueden cambiar una vez aprobadas.",
    TimecardAuditReport: "Informe de auditoría de la tarjeta de control de tiempo",
    Timecards: "Tarjetas de control de tiempo",
    TIMECARDS: "TARJETAS DE CONTROL DE TIEMPO",
    TimecardSummaryReport: "Informe de resumen de la tarjeta de control de tiempo",
    Today: "Hoy",
    Top: "Tope",
    Total_Hours_By_Day: "Total de horas por día",
    TOTAL_RECORDS: "TOTAL REGISTROS",
    WorkingTotalHours: "Horas totales de trabajo",
    TotalHours: "Horas totales",
    Total: "Total",
    Trained_Date: "Fecha de capacitación",
    Training_Face_Spaces: "Nro. de espacios faciales de capacitación",
    TransferDataTo: "Transferir datos a:",
    Unapprove: "Desaprobar",
    Unapprove_all_timecards: "Desaprobar todas las tarjetas de control de tiempo (conteo {0})",
    Unapprove_Timecard: "Desaprobar la tarjeta de control de tiempo",
    Unapprove_timecards_on_this_page: "Desaprobar las tarjetas de control de tiempo en esta página (conteo {0})",
    Unlock: "Desbloquear",
    Unlock_Payroll_Hierarchy: "Desbloquear la jerarquía de la nómina",
    UnlockTimecard: "¿Desbloquear la tarjeta de control de tiempo?",
    Unutilized: "No utilizada",
    Update: "Actualizar",
    UPDATE_PROFILE_IMAGE: "ACTUALIZAR IMAGEN DE PERFIL",
    Use_Towards_Overtime: "Utilizar para sobretiempo",
    user_email: "Correo electrónico de usuario",
    user_password: "Contraseña de usuario",
    user_password_confirm: "Confirmar contraseña de usuario",
    User_Role: "Función del usuario",
    User_role_name_is_duplicated: "El nombre de la función del usuario está duplicado.",
    User_Roles: "Funciones de usuario",
    User_save_failed: "Error al guardar el usuario",
    User_saved_successfully: "El usuario se guardó correctamente",
    User_Selected: "1 usuario seleccionado",
    UserRole_added_successfully: "La función de usuario se agregó correctamente",
    UserRole_removed_successfully: "La función de usuario se eliminó correctamente",
    UserRole_updated_successfully: "La función de usuario se actualizó correctamente",
    Users: "Usuarios",
    Utilization: "Utilización",
    Utilized: "Utilizado",
    Valid_email_required: "Se requiere una dirección de correo electrónico válida.",
    Valid_value_required: "Se requiere un valor válido",
    ValidLocationRequired: "Se requiere una ubicación válida",
    View_All_Devices: "Ver todos los dispositivos",
    View: "Ver",
    View_Employees: "Ver empleados",
    View_Equipment: "Ver equipos",
    View_Full_Hierarchy: "Ver jerarquía completa",
    View_Hierarchy_Devices: "Ver jerarquía de dispositivos",
    View_next_timecard: "Ver la siguiente tarjeta de control de tiempo",
    View_Payroll: "Ver nómina",
    View_previous_timecard: "Ver la tarjeta de control de tiempo anterior",
    View_Records: "Ver registros",
    View_Timecards: "Ver tarjetas de control de tiempo",
    View_Employee_Devices: "Ver dispositivos de los empleados",
    Warn_No_Signature_Text: "Advertir texto sin firma",
    Weekly: "Semanalmente",
    WIFI_is_on: "El wifi está activado",
    X_Account_Users: "{0} usuarios de la cuenta",
    x_Devices_Selected: "{0} dispositivos seleccionados",
    X_employee_have_time_that_has_not_yet_been_approved: "{0} empleado(s) tienen tiempo que aún no se aprobó.",
    X_employee_payroll_have_already_been_exported: "La nómina de {0} empleados ya se exportó.",
    x_Employees_Selected: "{0} empleados seleccionados",
    x_Equipment_Selected: "{0} equipo seleccionado",
    x_Client_Selected: "{0} cliente seleccionado",
    x_Hierarchy_Items_Selected: "{0} elementos de jerarquía seleccionados",
    x_Locations_Selected: "{0} ubicaciones seleccionadas",
    x_Micro_Locations_Selected: "{0} microubicaciones seleccionadas",
    x_Records: "{0} registros",
    x_Records_Selected: "{0} registros seleccionados",
    x_Roles_Selected: "{0} funciones seleccionadas",
    x_Selected: "{0} seleccionado",
    x_Users_Selected: "{0} usuarios seleccionados",
    x_week: "{0} semana",
    xxx_hierarchy_definition_has_not_any_hierarchy_items: 'No puede elegir el nivel "{0}", porque no tiene ningún elemento jerárquico.',
    You_cannot_delete_yourself: "No puede eliminarse a sí mismo.",
    You_cannot_remove_your_AccountAdmin_permission: "No puede eliminar su permiso como Administrador de cuenta",
    You_cant_access_this_hierarchy_item: "No puede acceder a este elemento jerárquico.",
    You_cant_choose_this_hierarchy_item: "No puede elegir este elemento jerárquico.",
    You_cant_delete_pay_group: "No se puede eliminar el grupo de pago mientras está vinculado al elemento jerárquico.",
    You_cant_delete_pay_type: "No se puede eliminar la forma de pago mientras esté establecida como predeterminada en el grupo de pago.",
    Zip_Postal_code: "Código postal",
    Accrual_Name: "Nombre de la provisión",
    Accrual_Code: "Código de acumulación",
    Rate_Per_Hour: "Tasa por hora",
    Use_for_Leave_Tracking: "Uso para el seguimiento de licencias",
    Leave_Tracking_Pay_Type: "Forma de pago de seguimiento de licencias",
    No_Accrual: "Sin provisión",
    Add_Accrual: "Agregar provisión",
    Edit_Accrual: "Editar provisión",
    Accrual_Rate_Per_Hour: "Tasa de provisión por hora",
    Pay_Types_Contributing_To_Accrual: "Formas de pago que contribuyen a la provisión",
    Allow_Accrual_For_Leave_Tracking: "Permitir provisión para el seguimiento de licencias",
    Require_Note_On_Time_Off_Approval: "Requerir nota sobre la aprobación del tiempo libre",
    Pay_Type_Used_for_Leave_Punch_Set: "Forma de pago utilizada para el conjunto de marcación por licencia",
    Deduction_Rate_Per_Hour_for_Leave: "Tasa de deducción por hora para licencias (debe ser negativa)",
    Invalid_format: "Formato no válido",
    This_field_must_be_greater_than_or_equal_to_zero: "Este campo debe ser mayor o igual a 0",
    This_field_must_be_less_than_x: "Este campo debe ser menor que {0}",
    This_field_must_be_less_than_or_equal_to_x: "Este campo debe ser menor o igual a {0}",
    This_field_must_be_greater_than_x: "Este campo debe ser mayor que {0}",
    This_field_must_be_greater_than_or_equal_to_x: "Este campo debe ser mayor o igual a {0}",
    Accrual_created_successfully: "La provisión se creó correctamente",
    Accrual_updated_successfully: "La provisión se actualizó correctamente",
    Delete_Accrual: "Eliminar la provisión",
    Are_you_sure_delete_accrual: "¿Está seguro de que desea eliminar esta provisión?",
    Accrual_removed_successfully: "La provisión se eliminó correctamente",
    Add_Accrual_to_Employee: "Agregar provisión para el empleado",
    Edit_Accrual_to_Employee: "Editar provisión para el empleado",
    Balance: "Saldo",
    Accrual_Start_Date: "Fecha de inicio de la provisión",
    Accrual_Probation_End_Date: "Fecha de finalización del período de prueba de la provisión",
    Probation_End_Date: "Fecha de finalización del período de prueba",
    Accrual_Type: "Tipo de provisión",
    Invalid_date_range: "Intervalo de fechas no válido",
    Are_you_sure_you_want_to_change_balance: "¿Está seguro de que realmente desea modificar el saldo?",
    Starting_Balance: "Saldo inicial",
    Current_Balance: "Saldo actual",
    Pending_Balance: "Balance pendiente",
    Accrual_Selected: "Provisión seleccionada",
    Employee_Accrual_Changing_Information: "Auditoría de provisión del empleado",
    Employee_accrual_added_successfully: "La provisión del empleado se agregó correctamente.",
    Employee_accrual_updated_successfully: "La provisión del empleado se actualizó correctamente.",
    Employee_accrual_removed_successfully: "La provisión se eliminó correctamente.",
    Enable_Accruals_Timeoff: "Habilitar provisiones/tiempo libre",
    Leave_Tracking: "Seguimiento de licencia",
    New_Leave_Request: "Nueva solicitud de licencia",
    Edit_Leave_Request: "Editar solicitud de licencia",
    Allow_Time_Off_PayRate_Edit: "Permitir tiempo libre Tasa de pago Editar",
    Accrual: "Provisión",
    Hours: "Horas",
    HoursAbbreviation: "h",
    Hours_Per_Day: "Horas al día",
    Type: "Tipo",
    Vacation: "Vacaciones",
    Sick_leave: "Licencia por enfermedad",
    Leave_Start_Date: "Fecha de inicio de licencia",
    Leave_End_Date: "Fecha de finalización de licencia",
    Comments: "Comentarios",
    Leave_request_saved_successfully: "La solicitud de licencia se guardó correctamente.",
    Leave_Request_Selected: "Se seleccionó 1 solicitud de licencia",
    x_Leave_Requests_Selected: "Se seleccionaron {0} solicitudes de licencia",
    Are_you_sure_you_want_to_delete_selected_leave_request: "¿Está seguro de que desea eliminar las solicitudesde licencia seleccionadas?",
    Pending: "Pendiente",
    Denied: "Rechazada",
    Start_Date: "Fecha de inicio",
    End_Date: "Fecha de finalización",
    End_Date_cannot_be_before_Start_Date: "La fecha de finalización no puede ser anterior a la fecha de inicio",
    No_leave_tracking_found: "No se encontró ningún seguimiento de licencia",
    Status: "Estado",
    Dates: "Fechas",
    Notes: "Notas",
    Cannot_update_none_pending_leave_request: "No se pueden actualizar las solicitudes de licencia previamente aprobadas o rechazadas.",
    Cannot_update_leave_request_for_locked_period_or_denied_leave_request: "No se puede actualizar la solicitud de licencia para un período bloqueado o una solicitud de licencia rechazada",
    Leave_request_updated_successfully: "La solicitud de licencia se actualizó correctamente.",
    Choose_leave_requests_to_approve: "Seleccione las solicitudes de licencia para aprobar.",
    Choose_leave_requests_to_deny: "Seleccione las solicitudes de licencia que desea rechazar.",
    One_or_more_leave_request_comments_are_required: "Se requieren uno o más comentarios de la Solicitud de licencia",
    Pay_Rate_cannot_entered_for_this_request_as_this_is_not_paid_leave: "No se puede ingresar la tasa de pago para esta solicitud ya que no se trata de una licencia remunerada",
    Cannot_approve_the_approved_or_denied_leave_request: "No puede aprobar la(s) solicitud(es) de licencia aprobada(s) o rechazada(s)",
    Cannot_deny_the_denied_leave_request: "No se pueden denegar las solicitudes de permiso denegadas",
    Leave_request_approved_successfully: "La(s) solicitud(es) de licencia se aprobaron correctamente.",
    Leave_request_denied_successfully: "La(s) solicitud(es) de licencia se rechazaron correctamente.",
    Are_you_sure_you_want_to_approve_selected_leave_request: "¿Está seguro de que desea aprobar la(s) solicitud(es) de licencia seleccionada(s)?",
    Are_you_sure_you_want_to_deny_selected_leave_request: "¿Está seguro de que desea rechazar la(s) solicitud(es) de licencia seleccionada(s)?",
    Timezone: "Zona horaria",
    Hierarchy_Timezone: "Zona horaria de la jerarquía",
    No_Overtime: "Sin sobretiempo",
    Unpaid: "Sin pago",
    Leave_Tracking_Note_History: "Historial de notas de seguimiento de las licencias",
    Edit_Note: "Editar nota",
    Remove_Note: "Eliminar nota",
    Are_you_sure_remove_note: "¿Está seguro que desea eliminar esta nota?",
    Closed: "Cerrado",
    Close_Payroll: "Cerrar nómina",
    Close_Payroll_Hierarchy: "Cerrar jerarquía de la nómina",
    Are_you_sure_you_want_to_close_payroll_hierarchy_with_leave:
        "¿Está seguro de que desea cerrar la jerarquía de la nómina? El cierre de la nómina activará los cálculos de provisiones para el período de pago cerrado y agregará todas las solicitudes de tiempo libre aprobadas a las tarjetas de control de tiempo para este período de pago. Todas las solicitudes de tiempo libre no aprobadas se rechazarán automáticamente. El cálculo de provisiones no se puede deshacer.",
    Are_you_sure_you_want_to_close_payroll_hierarchies_with_leave:
        "¿Está seguro de que desea cerrar {0} jerarquías de la nómina? El cierre de la nómina activará los cálculos de provisiones para el período de pago cerrado y agregará todas las solicitudes de tiempo libre aprobadas a las tarjetas de control de tiempo para este período de pago. Todas las solicitudes de tiempo libre no aprobadas se rechazarán automáticamente. El cálculo de provisiones no se puede deshacer.",
    Payroll_closed_successfully: "La nómina se cerró correctamente.",
    Failed_to_close_payroll_Please_try_again_later: "No se pudo cerrar la nómina. Vuelva a intentarlo más tarde",
    Enable_Schedule: "Habilitar horario",
    Schedules: "Horarios",
    Shift_Templates: "Plantillas de turnos",
    Pattern_Templates: "Plantillas de patrones",
    Schedule_Templates: "Plantillas de horario",
    Schedule_Planners: "Planificadores de horario",
    Posted_Schedules: "Horarios publicados",
    Position_Color: "Color de puesto",
    No_shift_template_found: "No se encontró ninguna plantilla de turno",
    Show_All_Child_Hierarchy_Data: "Mostrar todos los datos de jerarquía secundaria",
    Start_Time: "Hora de inicio",
    End_Time: "Hora de finalización",
    Breaks: "Descansos",
    Early_In_Restriction: "Restricción de entrada temprano",
    Early_In_Restriction_ShortTerm: "Restricción de entrada temprano",
    Differential_Pay: "Pago diferencial",
    Differential_Pay_ShortTerm: "Pago diferencial",
    New_Shift_Template: "Nueva plantilla de turno",
    Edit_Shift_Template: "Editar plantilla de turno",
    Early_Punch_In_Restriction: "Restricción de marcación de entrada temprano",
    Early_Punch_In_Restriction_Value: "Valor de restricción para marcación de entrada temprano",
    Edit_Break: "Editar descanso",
    New_Break: "Nuevo descanso",
    Break_Start_Time_Window: "Ventana de tiempo de inicio de descanso",
    Break_End_Time_Window: "Ventana de tiempo de finalización de descanso",
    Minimum_Break_Duration: "Duración mínima del descanso",
    Maximum_Break_Duration: "Duración máxima del descanso",
    Recommended_Break_Duration: "Duración recomendada del descanso",
    Require_Punch_Biometrics: "Requerir marcación biométrica",
    Break_name_is_duplicated: "El nombre del descanso está duplicado.",
    Are_you_sure_you_want_to_delete_this_break: "¿Está seguro de que desea eliminar este descanso?",
    Shift_template_added_successfully: "La plantilla de turno se agregó correctamente.",
    Shift_template_updated_successfully: "La plantilla de turno se actualizó correctamente.",
    Shift_template_deleted_successfully: "Las plantillas de turno se eliminaron correctamente.",
    Are_you_sure_you_want_to_delete_the_selected_shift_template: "¿Está seguro de que desea eliminar las plantillas de turno seleccionadas?",
    Shift_Template_Selected: "Plantilla de turno seleccionada",
    x_Shift_Templates_Selected: "{0} Plantillas de turno seleccionadas",
    Pattern_Template_Selected: "Plantilla de patrón seleccionada",
    x_Pattern_Template_Selected: "{0} Plantillas de patrones seleccionadas",
    Are_you_sure_you_want_to_delete_the_selected_pattern_template: "¿Está seguro de que desea eliminar las plantillas de patrón seleccionadas?",
    No_pattern_template_found: "No se encontró ninguna plantilla de patrón.",
    Pattern_template_added_successfully: "La plantilla de patrón se agregó correctamente.",
    Pattern_template_updated_successfully: "La plantilla de patrón se actualizó correctamente.",
    Pattern_template_deleted_successfully: "Se eliminaron las plantillas de patrón.",
    New_Pattern_Template: "Nueva plantilla de patrón",
    Edit_Pattern_Template: "Editar plantilla de patrón",
    Add_Shift_Template: "Agregar plantilla del turno",
    Shift_Template: "Plantilla del turno",
    Shift_template_time_is_overlapped: "El tiempo de la plantilla del turno se superpone",
    Cannot_overlap_shift_template_times: "No se pueden superponer los tiempos de la plantilla del turno",
    Shift_template_time_updated_successfully: "Los tiempos de la plantilla del turno se actualizó correctamente.",
    Remove: "Eliminar",
    Are_you_sure_you_want_to_remove_this_shift_template: "¿Está seguro de que desea eliminar esta plantilla del turno?",
    Shift_template_time_removed_successfully: "El tiempo de la plantilla del turno se eliminó correctamente.",
    Edit_Shift_Time: "Editar tiempo del turno",
    Schedule_template_added_successfully: "La plantilla de horario se agregó correctamente",
    Schedule_template_deleted_successfully: "La plantilla de horario se eliminó correctamente",
    Schedule_template_updated_successfully: "La plantilla de horario se actualizó correctamente",
    Are_you_sure_you_want_to_delete_the_selected_schedule_template: "¿Está seguro de que desea eliminar las plantillas del horario seleccionadas?",
    Schedule_Template_Selected: "Se seleccionó la plantilla del horario",
    x_Schedule_Templates_Selected: "Se seleccionaron {0} plantillas del horario",
    No_schedule_template_found: "No se encontró ninguna plantilla del horario",
    New_Schedule_Template: "Nueva plantilla del horario",
    Edit_Schedule_Template: "Editar plantilla del horario",
    Schedule_Template: "Plantilla del horario",
    Shifts: "Turnos",
    Week_View: "Vista semanal",
    Day_View: "Vista diaria",
    Shifts_must_be_added_to_week_view: "Los turnos deben agregarse a la vista semanal",
    Qty: "Cantidad",
    Add_Shift: "Agregar turno",
    Pattern_Template: "Plantilla de patrón",
    Shift_added_successfully: "El turno se agregó correctamente",
    Shift_deleted_successfully: "El turno se eliminó correctamente",
    Shift_Selected: "Turno seleccionado",
    x_Shifts_Selected: "{0} turnos seleccionados",
    Are_you_sure_you_want_to_delete_the_selected_shift: "¿Está seguro de que desea eliminar los turnos seleccionados?",
    No_shift_found: "No se encontró ningún turno",
    Sunday: "Domingo",
    Monday: "Lunes",
    Tuesday: "Martes",
    Wednesday: "Miércoles",
    Thursday: "Jueves",
    Friday: "Viernes",
    Saturday: "Sábado",
    Multiple_Positions: "Puestos múltiples",
    First_Shift_Start_Time: "Hora de inicio del primer turno",
    Last_Shift_End_Time: "Hora de finalización del último turno",
    Add_New_Schedule_Planner: "Agregar nuevo planificador de horario",
    Pay_Group_added_successfully: "El grupo de pago se agregó correctamente.",
    Pay_Group_updated_successfully: "El grupo de pago se actualizó correctamente.",
    Pay_Group_removed_successfully: "El grupo de pago se eliminó correctamente.",
    Cannot_add_before_probation_end_date: "No se puede agregar antes de la fecha de finalización del período de prueba '{0}'",
    Accrual_name_is_duplicated: "El nombre de la provisión está duplicado.",
    Pay_Type_name_requires_maximum_15_chars: "El nombre de la forma de pago requiere un máximo de 15 caracteres",
    Leave_request_saved_and_approved_successfully: "La solicitud de licencia se guardó y aprobó correctamente.",
    Leave_request_updated_and_approved_successfully: "La solicitud de licencia se actualizó y aprobó correctamente.",
    Next_Month: "Siguiente mes",
    Day: "Día",
    View_Accrual: "Ver provisión",
    View_Employee_Accrual: "Ver provisión del empleado",
    Edit_Employee_Accrual: "Editar provisión del empleado",
    Add_Employee_Accrual: "Agregar provisión del empleado",
    Delete_Employee_Accrual: "Eliminar provisión del empleado",
    View_Leave_Tracking: "Ver el seguimiento de la licencia",
    Edit_Leave_Tracking: "Editar el seguimiento de la licencia",
    Add_Leave_Tracking: "Agregar el seguimiento de la licencia",
    Delete_Leave_Tracking: "Eliminar el seguimiento de la licencia",
    View_Employee_Leave_Tracking: "Ver el seguimiento de la licencia del empleado",
    Edit_Employee_Leave_Tracking: "Editar el seguimiento de la licencia del empleado",
    Add_Employee_Leave_Tracking: "Agregar el seguimiento de la licencia del empleado",
    Delete_Employee_Leave_Tracking: "Eliminar el seguimiento de la licencia del empleado",
    Schedule_added_successfully: "Horario añadido con éxito.",
    Total_Shifts: "Total de turnos",
    Unfilled_Shifts: "Turnos no llenados",
    Filled_Status: "Estado de llenado",
    Posted: "Publicado",
    Filled: "Completado",
    Post: "Publicado",
    Schedule_Planner: "Planificador de horario",
    Unfilled: "No llenado",
    Assign_Employee_to_Shift: "Asignar empleado al turno",
    Assign_Candidate_to_Shift: "Asignar candidato al turno",
    Shift_information: "Información del turno",
    Shift_assigned_successfully: "El turno se asignó correctamente.",
    Post_Schedule: "Publicación de horario",
    Schedule_Planner_posted_successfully: "El planificador de horario se publicó correctamente.",
    You_arent_filled: "No está llenado al 100 %.",
    Are_you_sure_you_want_to_post_this_schedule: "¿Está seguro de que desea publicar este horario?",
    Are_you_sure_you_want_to_post_this_schedule_anyway: "¿Está seguro de que desea publicar este horario de todos modos?",
    employee_will_be_alerted_once_the_schedule_is_posted: "Se alertará a {0} empleados cuando se publique el horario",
    employees_will_be_alerted_once_the_schedule_is_posted: "Se alertará a {0} empleados una vez que se publique el horario",
    No_schedule_found: "¡No se ha encontrado ningún horario!",
    Schedule_Selected: "Programa seleccionado",
    x_Schedules_Selected: "{0} horarios seleccionados",
    Are_you_sure_you_want_to_delete_the_selected_schedule: "¿Está seguro de que desea eliminar los horarios seleccionados?",
    Schedule: "Horario",
    View_Schedule: "Ver el  horario",
    Edit_Schedule: "Editar el horario",
    Add_Schedule: "Agregar el horario",
    Delete_Schedule: "Eliminar el horario",
    View_Employee_Schedule: "Ver el horario del empleado",
    Edit_Employee_Schedule: "Editar el horario del empleado",
    Add_Employee_Schedule: "Agregar el horario del empleado",
    Delete_Employee_Schedule: "Eliminar el horario del empleado",
    View_Account_Schedule: "Ver datos de los horarios de la cuenta",
    Edit_Account_Schedule: "Editar datos de los horarios de la cuenta",
    Add_Account_Schedule: "Agregar datos del horario de la cuenta",
    Delete_Account_Schedule: "Eliminar datos del horario de la cuenta",
    Posted_Schedule: "Horario publicado",
    Account_Details: "Detalles de la cuenta",
    Week_Month: "Semana/Mes",
    Month_View: "Vista del mes",
    Shift_or_Pattern_Template: "Plantilla del turno o del patrón",
    Create_multiple_position_shift: "Crear turno de posiciones múltiples",
    Create_simple_position_shift: "Crear turno de posición simple",
    Shift: "Turno",
    New_Shift: "Nuevo turno",
    Edit_Shift: "Editar turno",
    Shift_times_are_overlapped: "Los tiempos del turno se superponen",
    Shift_time_is_overlapped: "El tiempo del turno se superpone",
    Create_new_shift: "Crear nuevo turno",
    Shift_time_updated_successfully: "El tiempo del turno se actualizó correctamente",
    Cannot_overlap_shift_times: "No se pueden superponer los tiempos del turno",
    Shift_updated_successfully: "El tiempo del turno se actualizó correctamente.",
    Edit_Shift_Quantity: "Editar cantidad de turnos",
    Shift_quantity_updated_successfully: "La cantidad de turnos se actualizó correctamente",
    Pattern: "Patrón",
    Pattern_name_is_duplicated: "El nombre del patrón está duplicado",
    Invalid_shift_time: "Tiempo de turno no válido",
    Cannot_make_a_break_because_shift_time_is_not_valid: "No se puede hacer un descanso, porque el tiempo del turno no es válido",
    Cannot_make_a_break_because_shift_time_is_less_than_5min: "No se puede hacer un descanso, porque el tiempo del turno es inferior a 5 minutos",
    Break_Time_Window_should_be_fall_in_shift_time: "La ventana del tiempo de descanso debe ser durante el tiempo del turno",
    Duration_Time_Window_cannot_less_than_5min: "La duración de la ventana del tiempo no puede ser inferior a 5 min",
    This_filed_should_be_less_than_Break_Time_Window_Duration: "Este campo debe ser menor que la duración de la ventana del tiempo de descanso",
    Max_Break_Duration_should_be_greater_than_Min_Break_Duration: "La duración máxima del descanso debe ser mayor que la duración mínima del descanso",
    Recommended_Break_Duration_should_be_greater_than_Min_Break_Duration: "La duración recomendada del descanso debe ser mayor que la duración mínima del descanso",
    Recommended_Break_Duration_should_be_less_than_Max_Break_Duration: "La duración recomendada del descanso debe ser menor que la duración máxima del descanso",
    Shift_name_is_duplicated: "El nombre del turno está duplicado",
    IP_Address: "Dirección IP",
    New_IP_Address: "Nueva dirección IP",
    Edit_IP_Address: "Editar dirección IP",
    IP_Address_is_required: "La dirección es obligatoria",
    IP_Address_is_not_valid: "La dirección IP no es válida",
    Are_you_sure_you_want_to_delete_this_IP: "¿Está seguro de que desea eliminar esta IP?",
    Web_Punch: "Marcación por la web",
    IP: "IP",
    Do_you_want_to_add_this_punch_at_xtime: "¿Desea agregar esta marcación en {0}?",
    Leave_Information: "Información de licencia",
    Submit_Leave: "Enviar licencia",
    Available: "Disponible",
    Leave_Requests: "Solicitud de licencia",
    Enable_Employee_Approve_Timecard: "Tarjeta de control de tiempo aprobada del empleado",
    Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock_with_leave:
        "¿Está seguro de que desea cerrar la jerarquía de la nómina? El cierre de la nómina bloqueará la jerarquía de la nómina desbloqueada para este período de pago y activará el cálculo de provisiones para el período de pago cerrado. Además, agregará todas las solicitudes de tiempo libre aprobadas a las tarjetas de control de tiempo para este período de pago. Todas las solicitudes de tiempo libre no aprobadas se rechazarán automáticamente. El cálculo de provisiones no se puede deshacer.",
    Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock_with_leave:
        "¿Está seguro de que desea cerrar {0} jerarquías de la nómina? El cierre de la nómina bloqueará las jerarquías de nómina desbloqueadas para este período de pago y activará el cálculo de provisiones para el período de pago cerrado. Además, agregará todas las solicitudes de tiempo libre aprobadas a las tarjetas de control de tiempo para este período de pago. Todas las solicitudes de tiempo libre no aprobadas se rechazarán automáticamente. El cálculo de provisiones no se puede deshacer.",
    EMP_Approved: "E.Aprobada",
    Hierarchy_not_found_for_IP: "No se encontró la jerarquía para la IP: {0}",
    IP_Address_is_duplicated: "La dirección IP está duplicada",
    SSO_LOGIN_IN_PROGRESS: "Inicio de sesión unificado en progreso",
    Clone_x_Shifts: "Clonar {0} turnos",
    Shifts_cloned_successfully: "Los turnos se clonaron correctamente",
    DefferedImageUploadTitle: "Imagen no cargada",
    DefferedImageUploadBody: "Carga en curso desde un dispositivo móvil",
    List_View: "Vista de la lista",
    Calendar_View: "Vista del calendario",
    Deny: "Rechazar",
    Holiday_Templates: "Plantillas de vacaciones",
    Add_Holiday_Template: "Agregar plantilla de vacaciones",
    Edit_Holiday_Template: "Editar plantilla de vacaciones",
    Delete_Holiday_Template: "Eliminar plantilla de vacaciones",
    Holiday_Template_created_successfully: "La plantilla de vacaciones se creó correctamente",
    Holiday_Template_updated_successfully: "La plantilla de vacaciones se actualizó correctamente",
    Are_you_sure_delete_holiday_template: "¿Está seguro de que desea eliminar esta plantilla de vacaciones?",
    Holiday_Template_name_is_duplicated: "El nombre de la plantilla de vacaciones está duplicado",
    Holiday_Template_removed_successfully: "La plantilla de vacaciones se eliminó correctamente",
    Holiday_Template_Selected: "Se seleccionó la plantilla de vacaciones",
    No_Holiday_Template: "No hay plantilla de vacaciones",
    This_date_exists_already: "Esta fecha ya existe",
    Add_Holiday: "Agregar vacaciones",
    Holidays: "Vacaciones",
    Holiday_Template: "Plantilla de vacaciones",
    Holiday_Template_Select_Note: "Nota: Todos los cambios de fecha en la plantilla de {0} vacaciones se reflejarán automáticamente en esta instancia de vacaciones del grupo de pago.",
    Holiday_Pay_Type: "Forma de pago de vacaciones",
    The_HoursPerDay_of_holiday_is_more_than_the_MaximumPunchSetLength: "Las horas por día de {0} vacaciones son superiores a la duración máxima de la marcación.",
    Are_you_sure_you_want_to_approve_leave_request_of_employee: "¿Está seguro de que desea aprobar una solicitud de licencia del empleado '{0}' para {1}?",
    Are_you_sure_you_want_to_deny_leave_request_of_employee: "¿Está seguro de que desea rechazar una solicitud de licencia del empleado '{0}' para {1}?",
    Are_you_sure_you_want_to_delete_leave_request_of_employee: "¿Está seguro de que desea eliminar una solicitud de licencia del empleado '{0}' para {1}?",
    Also_remove_employee_self_service: "Eliminar también el autoservicio del empleado",
    Are_you_sure_you_want_to_delete_the_selected_account_user_with_below_option: "¿Está seguro de que desea eliminar los usuarios de la cuenta seleccionada con la siguiente opción?",
    Schedule_Validation_Issues: "Problemas de validación de horario",
    Employee_Already_Scheduled: "El empleado ya se programó",
    Shift_Confilicts_with_Time_Off: "Conflictos del turno con el tiempo libre",
    Auto_Assign_Employees_to_Schedule: "Asignación automática de empleados al horario",
    Auto_Assign: "Autoasignar",
    Auto_Assign_Confirm_Dialog_Body: "¿Confirma que desea autoasignar empleados al horario en función de la disponibilidad y la jerarquía de los empleados y las asignaciones de puestos?",
    Schedule_auto_assign_has_completed: "La autoasignación de horario se completó. Se hicieron todas las asignaciones posibles.",
    Exception_Setting: "Configuración de las excepciones",
    Minutes_To_Trigger_Missing_PunchIn_Exception: "Minutos para activar la excepción por marcación faltante",
    Minutes_To_Trigger_Early_PunchIn_Exception: "Minutos para activar la excepción de marcación por entrada temprano",
    Minutes_To_Trigger_Late_PunchIn_Exception: "Minutos para activar la excepción de marcación por entrada tarde",
    Minutes_To_Trigger_Early_PunchOut_Exception: "Minutos para activar la excepción de marcación por salida temprano",
    Minutes_To_Trigger_Late_PunchOut_Exception: "Minutos para activar la excepción de marcación por salida tarde",
    Enable_Missing_Break_Exception: "Habilitar excepción por descanso perdido",
    Minutes_To_Trigger_Long_Break_Exception: "Minutos para activar la excepción por descanso largo",
    Enable_No_Shift_Exception: "Habilitar la excepción de Sin turno",
    Missed: "Perdido",
    Early: "Temprano",
    Late: "Tarde",
    Long: "Largo",
    Break: "Descanso",
    Exception_Filters: "Filtros de excepción",
    Missing_Punches: "Marcaciones faltantes",
    Emp_Approval: "Aprobación del empleado",
    Sup_Approval: "Aprobación del supervisor",
    Missing_In_Punch: "Marcación de entrada faltante",
    Early_In: "Entrada temprano",
    Late_In: "Entrada tarde",
    Early_Out: "Salida temprano",
    Late_Out: "Salida tarde",
    Long_Break: "Descanso largo",
    Missed_Break: "Descanso perdido",
    No_Shift: "Sin turno",
    From: "Desde",
    To: "hasta",
    Sunday_ShortTerm: "Dom",
    Monday_ShortTerm: "Lun",
    Tuesday_ShortTerm: "Mar",
    Wednesday_ShortTerm: "Miérc.",
    Thursday_ShortTerm: "Jue",
    Friday_ShortTerm: "Vier",
    Saturday_ShortTerm: "Sáb",
    The_Qty_must_be_less_than_or_equal_to_x: "La cantidad debe ser menor o igual a {0}",
    Shift_unassigned_successfully: "Se desasignó el turno correctamente",
    Schedule_name_is_duplicated_for_this_week: "El nombre del horario está duplicado para esta semana",
    Copy_Schedule: "Copiar horario",
    Schedule_copied_successfully: "El horario se copió correctamente.",
    Notification_Settings: "Configuración de la notificación",
    Personal_Notification_Preferences: "Preferencias de notificación personal",
    Subscription_Notifications: "Notificaciones de suscripción",
    Personal_Notifications: "Notificaciones personales",
    Email_Notifications: "Notificaciones por correo electrónico",
    Inapp_Push_Notifications: "Notificaciones directas en la aplicación",
    Are_you_sure_you_want_to_delete_the_selected_notification: "¿Está seguro de que desea eliminar la notificación seleccionada?",
    No_Notification: "No hay notificación",
    Notification: "Notificación",
    Notify_Method: "Método de notificación",
    Schedule_Reminder: "Recordatorio de horario",
    Missing_Out_Punch: "Falta marcación de salida",
    Push: "Directo",
    Email: "Correo electrónico",
    SMS: "SMS",
    Voice: "Voz",
    Add_Notification: "Agregar notificación",
    Edit_Notification: "Editar notificación",
    Notification_Type: "Tipo de notificación",
    Notification_Selected: "Notificación seleccionada",
    Subscription_Selected: "Suscripción seleccionada",
    Are_you_sure_you_want_to_delete_the_selected_subscriptions: "¿Está seguro de que desea eliminar la suscripción seleccionada?",
    No_Subscription: "Sin suscripción",
    Add_Subscription: "Agregar suscripción",
    Edit_Subscription: "Editar suscripción",
    Missing_Punch: "Falta marcación",
    Missing_Employee_Approval: "Falta la aprobación del empleado",
    Missing_Supervisor_Approval: "Falta la aprobación del supervisor",
    Early_In_Punch: "Marcación de entrada temprano",
    Early_Out_Punch: "Marcación de salida temprano",
    Late_In_Punch: "Marcación de entrada tarde",
    Late_Out_Punch: "Marcación de salida tarde",
    Missing_Break: "Descanso perdido",
    Exception_Type: "Tipo de excepción",
    Direct_Reports_Only: "Solo subordinado directo",
    Subscriptions: "Suscripciones",
    Include_Child_Hierarchies: "Incluir jerarquías inferiores",
    Requested: "Solicitado",
    Cannot_delete_leave_request_punch: "No se puede eliminar la marcación. Esto está vinculado a una solicitud de licencia y todos los cambios deben hacerse a la solicitud de tiempo libre",
    Cannot_update_leave_request_punch: "No se puede actualizar la marcación. Esto está vinculado a una solicitud de licencia y todos los cambios deben hacerse a la solicitud de tiempo libre",
    Not_enough_hours_available_to_make_this_leave_request: "No hay suficientes horas disponibles para realizar esta solicitud de licencia.",
    Min_Balance: "Saldo mínimo",
    Max_Balance: "Saldo máximo",
    Time_off: "Tiempo libre",
    App: "Aplicación",
    Add_Notify_Method: "Agregar método de notificación",
    Leave_Request_exist_for_selected_period: "Existe una solicitud de licencia para el período seleccionado.",
    This_Notification_is_duplicated: "Esta notificación está duplicada.",
    This_Subscription_is_duplicated: "Esta suscripción está duplicada.",
    Request: "Solicitar",
    Allow_Punch_From_Personal_Device: "Permitir marcar desde un dispositivo personal",
    Min_Hours_Per_Day: "Horas mínimas por día",
    Max_Hours_Per_Day: "Horas máximas por día",
    Max_Hours_Per_Day_should_be_greater_than_Min_Hours_Per_Day: "Las horas máximas por día deben ser mayores que las horas mínimas por día",
    Invalid_supervisor: "Supervisor no válido",
    Inactive: "Inactivo",
    Active_Status: "Estado activo",
    Cannot_delete_shifts_already_in_use: "No se pueden eliminar los turnos que ya están en uso.",
    Sched_In: "Horario de entrada",
    Sched_Out: "Horario de salida",
    Work_Preferences: "Preferencias de trabajo",
    Preferred: "Preferidos",
    Unavailable: "No disponible",
    No_preference_found: "No se encontraron preferencias",
    Preference_Selected: "Se seleccionó 1 preferencia",
    x_Preference_Selected: "Se seleccionaron {0} preferencias",
    Are_you_sure_you_want_to_delete_selected_preference: "¿Está seguro de que desea eliminar las preferencias seleccionadas?",
    Edit_Work_Preference: "Editar preferencia de trabajo",
    New_Work_Preference: "Nueva preferencia de trabajo",
    Work_Preference_is_not_allowed_for_past_and_current_date: "La preferencia de trabajo no está permitida para la fecha pasada y actual.",
    Confirm_Assigned_Employee_Constraints: "Confirmar las restricciones de los empleados asignados",
    Abbreviation_Work: "Trabajo",
    Abbreviation_Preference: "Preferencia",
    Employee_does_not_have_access_to_the_punch_level_of_shift: "El empleado no tiene acceso a la jerarquía de turnos",
    Shift_conflicts_with_employee_work_preferences: "El turno entra en conflicto con las preferencias de trabajo del empleado",
    Leave_request_should_not_be_created_with_a_date_that_is_before_the_prohibition_end_date:
        "La solicitud de licencia no debe crearse con una fecha anterior a la fecha de finalización de la prohibición",
    Employee_pay_group_does_not_contain_the_shift_paytype: "El grupo de pago del empleado no contiene la forma de pago del turno",
    Employee_pay_group_does_not_contain_the_break_paytype: "El grupo de pago del empleado no contiene la forma de pago del descanso",
    Abbreviation_EMP_Approved: "E.Appro",
    Abbreviation_Supervisor_Approved: "S.Appro",
    Search_Location: "Buscar ubicación",
    Punch_added_GPS_off: "Se agregó la marcación con GPS desactivado",
    Schedule_Period_Days: "Programar días del período",
    Period_Days: "Días del período",
    Seven_Day_List: "7 días/Lista",
    Seven_Day_View: "Vista de 7 días",
    Day_X: "Día {0}",
    Schedule_Start_Date: "Programar fecha de inicio",
    Week: "Semana",
    Days: "Días",
    View_Type: "Tipo de vista",
    Assigned_Employee: "Empleado asignado",
    No_Note: "Sin nota",
    Device_Admin_Pin: "PIN del administrador del dispositivo",
    Changing_the_employee_hierarchy_may_impact_assigned_shifts_Would_you_like_to_proceed: "Cambiar la jerarquía del empleado puede afectar los turnos asignados. ¿Desea continuar?",
    This_PayType_is_invalid: "Esta forma de pago no es válida",
    Code: "Código",
    Input_Name: "Nombre de entrada",
    Input_Code: "Código de entrada",
    Invalid_for_used_hierarchy_or_employee_paygroup: "No es válido para la jerarquía utilizada o el grupo de pago del empleado",
    Its_not_valid_for_pay_group: "No es válido para el grupo de pago",
    Its_not_valid_for_pay_group_used_employee: "No es válido para el grupo de pago del empleado utilizado",
    Linked: "Vinculado",
    The_PayType_of_holiday_is_invalid: "La forma de pago de {0} días de vacaciones no es válida",
    Cannot_delete_holiday_template: "No se puede eliminar esta plantilla de vacaciones, porque se utiliza para el grupo de pago",
    Shift_Confilicts_with_holiday: "El turno entra en conflicto con las vacaciones",
    Enable_Mobile_Location_Fraud_Prevention: "Habilitar prevención de fraude de ubicación móvil",
    Days_To_Trigger_Missing_Employee_Approval: "Días para activar la falta de aprobación del empleado",
    Days_To_Trigger_Missing_Supervisor_Approval: "Días para activar la falta de aprobación del supervisor",
    Name_is_duplicated: "El nombre está duplicado",
    Holiday: "Vacaciones",
    Cannot_punch_for_locked_pay_period: "No se puede marcar para un período de pago bloqueado",
    Duplicated_date_exist_for_pay_group: "Existe una fecha duplicada para el grupo de pago",
    Cannot_delete_denied_leave_request: "No se pueden eliminar la(s) solicitud(es) de licencia rechazada(s)",
    Cannot_delete_approved_leave_request: "No se pueden eliminar la(s) solicitud(es) de licencia aprobada(s)",
    Cannot_delete_approved_leave_request_for_locked_period: "No se pueden eliminar la(s) solicitud(es) de licencia aprobada(s) para un período bloqueado",
    Leave_request_deleted_successfully: "Se eliminó la solicitud correctamente",
    Cannot_approve_leave_request_for_locked_period: "No se puede(n) aprobar la(s) solicitud(es) de licencia para un período bloqueado",
    Cannot_deny_leave_request_for_locked_period: "No se pueden denegar solicitudes de licencia durante el período bloqueado",
    Allow_Punches: "Permitir marcaciones",
    Disable_Message: "Desactivar mensajes",
    Punches_are_not_allowed_at_this_location: "No se permiten marcaciones en esta ubicación",
    Workday_Start_Time: "Hora de inicio de la jornada laboral",
    Enable_Clients: "Habilitar clientes",
    Enable_Jobs: "Habilitar trabajos",
    No_job_found: "No se encontró ningún trabajo",
    No_client_found: "No se encontró ningún cliente",
    Jobs: "Empleos",
    Clients: "Clientes",
    Parent_Hierarchy: "Jerarquía superior",
    Phases: "Etapas",
    Job_Details: "Detalles del empleo",
    Job_Name: "Nombre del empleo",
    Job_Id: "Identificación del empleo",
    Job_Start_End_Date: "Utilizar fechas de inicio/finalización",
    Occupations: "Ocupaciones",
    Specialties: "Especialidades",
    Badges: "Credenciales",
    Choose_Occupations: "Elegir ocupaciones",
    Choose_Specialties: "Elegir especialidades",
    Choose_Badges: "Elegir credenciales",
    Cost_Code: "Código de costo",
    No_phase_found: "No se encontró ninguna etapa",
    Choose_Job: "Elegir empleo",
    Choose_Phase: "Elegir etapa",
    Job: "Empleo",
    Phase: "Etapa",
    Client_Details: "Datos del cliente",
    Client_Name: "Nombre del cliente",
    logo: "Logotipo",
    Client_Id: "Identificación del cliente",
    Primary_Contact: "Contacto principal",
    No_Primary_Contact: "Sin contacto principal",
    Billing_Contact: "Contacto de facturación",
    No_Billing_Contact: "Sin contacto de facturación",
    Referral_Source: "Fuente de referencia",
    Referred_By: "Recomendado por",
    Created_By: "Creado por",
    Modified: "Modificado",
    Modified_By: "Modificado por",
    Last_Login: "Último acceso",
    Contacts: "Contactos",
    Primary: "Principal",
    Add_Contact: "Agregar contacto",
    Contact_Selected: "Se seleccionó 1 contacto",
    x_Contact_Selected: "Se seleccionó {0} contactos",
    My_Candidate_ShortList: "Mi preselección de candidatos",
    WorkPool_Employee_Selected: "Se seleccionó 1 empleado del grupo de trabajo",
    x_WorkPool_Employee_Selected: "Se seleccionó {0} empleados del grupo de trabajo",
    No_ShortList_Candidate_Found: "No se encontró ningún candidato de mi preselección",
    Add_To_Shortlist: "Agregar a la preselección",
    Submitted_Candidates: "Candidatos propuestos",
    No_Submitted_Candidate_Found: "No se encontró ningún candidato propuesto",
    Candidate_Requested: "Se solicitó un candidato",
    No_Requested_Candidate_Found: "No se encontró ningún candidato solicitado",
    Auto_Matched_Candidates: "Candidatos coincidentes de forma automática",
    No_Auto_Matched_Candidate_Found: "No se encontró ningún candidato coincidente de forma automática",
    Missing_Badges: "Credenciales faltantes",
    Miles: "Millas",
    Scheduled_Hours: "Horas programadas",
    Double_Shift: "Doble turno",
    Archive: "Archivo",
    Messages: "Mensajes",
    Submitted_By: "Enviado por",
    Show_Archived: "Mostrar archivados",
    None: "Ninguno",
    Delete_Contact: "Borrar contacto",
    Confirm_delete_contact: "¿Está seguro de que desea eliminar el(los) 'contacto(s)' seleccionado(s)?",
    No_contact_found: "No se encontró ningún contacto",
    Phone: "Teléfono",
    Title: "Cargo",
    Profile_Picture: "Foto de perfil",
    Preferred_Name: "Nombre preferido",
    Preferred_Contact_Method: "Método de contacto preferido",
    Home_Phone: "Teléfono de casa",
    Work_Phone: "Teléfono del trabajo",
    Cell_Phone: "Teléfono celular",
    Primary_Email: "Correo electrónico principal",
    Select_Profile_Picture: "Seleccionar foto de perfil",
    Unselect_Profile_Picture: "Deseleccionar foto de perfil",
    Upload_Logo: "Cargar logotipo",
    Remove_Logo: "Eliminar logotipo",
    Add_New_Note: "Agregar nueva nota",
    Enter_First_Note: "Haga clic en el botón Agregar para ingresar su primera nota.",
    No_Audits: "Sin auditorías",
    No_Match_Filter: "Ninguna nota coincide con el filtro.",
    No_Search_Result: "Ninguna nota coincide con los criterios de búsqueda.",
    See_More: "Ver más",
    Created: "Creado",
    Communications: "Comunicaciones",
    Street: "Calle",
    State: "Estado",
    Today_Hours: "Horas de hoy",
    This_Week_Hours: "Horas de esta semana",
    Job_Location: "Ubicación del trabajo",
    Default_Job: "Trabajo predeterminado",
    Default_Phase: "Etapa predeterminada",
    Active_Clocks: "Relojes activos",
    Clocks: "Relojes",
    Monthly_Bill: "Factura mensual",
    Billing_Detail: "Detalle de facturación",
    Hierarchy_is_Deleted: "Se elimina la jerarquía",
    Worker_Pool: "Grupo de trabajadores",
    Contact_Name: "Nombre del contacto",
    Contact_Email: "Correo electrónico de contacto",
    Active_Employee_Devices: "Dispositivos activos de los empleados",
    Active_Clock_Devices: "Dispositivos de reloj activos",
    Per_Employee_Month: "Por empleado/mes",
    Per_Clock_Month: "Por reloj/mes",
    Active_Employees: "Empleados activos",
    Require_Agreement_Before_Training_Punching: "Requerir acuerdo antes de la capacitación/marcación",
    Daily_Punch_Rule: "Regla de marcación diaria",
    Agreement_Text: "Texto del acuerdo",
    Create: "Crear",
    Are_you_sure_you_want_to_create_new_version_agreement: "¿Estás seguro de que deseas crear una nueva versión del acuerdo? Esto requerirá que todos los usuarios acepten el nuevo acuerdo.",
    Findd_biometric_agreement_accepted_on: "Acuerdo biométrico Findd aceptado en {0}",
    Findd_biometric_agreement_not_accepted: "Acuerdo biométrico Findd no aceptado",
    Client_employee_agreement_accepted_on: "Acuerdo de empleado del cliente aceptado el {0}",
    Client_employee_agreement_not_accepted: "Acuerdo de empleado del cliente no aceptado",
    Override_hierarchy: "Anular jerarquía",
    Schedule_Ranking: "Programar clasificación",
    os: "OS",
    App_Version: "Versión de la aplicación",
    Connected: "Conectado",
    Not_Connected: "No conectado",
    None_exist: "No existen",
    Allow_GPS_Locations: "Permitir ubicaciones GPS",
    Allow_MicroLocations: "Permitir microubicaciones",
    Allow_Positions: "Permitir puestos",
    Allow_Attached_Employees: "Permitir empleados adjuntos",
    Allow_Attached_Users: "Permitir usuarios adjuntos",
    Add_New_Hierarchy_Definition: "Agregar nueva definición de jerarquía",
    Level_Label: "Etiqueta de nivel",
    Label_length_cannot_exceed_50_characters: "La longitud de la etiqueta no puede exceder los 50 caracteres",
    Successfully_added: "Se agregó correctamente",
    Hour: "Hora",
    Rank: "Rango",
    Hierarchy_Removed: "Se eliminó la jerarquía",
    Supervisor_cannot_approve_his_own_timecard: "El supervisor no puede aprobar su propia tarjeta de control de tiempo",
    Supervisor_cannot_unapprove_his_own_timecard: "El supervisor no puede desaprobar su propia tarjeta de control de tiempo",
    Warning_your_timecard_will_not_approve: "Advertencia: Si se incluye su tarjeta de control de tiempo, no se aprobará",
    Warning_your_timecard_will_not_unapprove: "Advertencia: Si se incluye su tarjeta de control de tiempo, no se aprobará",
    Split_Punches_by_Day_Boundary: "Dividir las marcaciones por límite del día",
    Enable_Punch_Split_At_Day_Boundary: "Habilitar la división de la marcación por límite del día",
    Enable_Work_Availability: "Habilitar disponibilidad de trabajo",
    Scheduled: "Programado",
    Worked: "Trabajado",
    Worked_and_Scheduled: "Trabajado y programado",
    Copy_Schedule_Validation_Issues: "Problemas de validación de copia de horario",
    Cannot_copy_schedule_with_duplicated_name: "No se puede copiar un horario con nombre duplicado",
    Warning: "Advertencia",
    Are_you_sure_you_want_to_copy_schedule_once_unassign_shift_had_conflict: "¿Está seguro de que desea copiar el horario una vez que la desasignación de turno tuvo un conflicto?",
    Schedule_name_is_duplicated: "El nombre del horario está duplicado",
    Available_Days: "Días disponibles",
    All_Days: "Todos los días",
    Cannot_update_auto_created_split_punch: "No se puede actualizar la marcación dividida creada automáticamente",
    Cannot_delete_auto_created_split_punch: "No se puede eliminar la marcación dividida creada automáticamente",
    Custom_Overtime: "Sobretiempo personalizado",
    Overtime_Rules: "Reglas de sobretiempo",
    Add_Overtime_Rule: "Agregar regla de sobretiempo",
    Edit_Overtime_Rule: "Editar regla de sobretiempo",
    Daily: "Diario",
    ConsecutiveDay: "Día consecutivo",
    Overtime_Rule_Type: "Tipo de regla de sobretiempo",
    Overtime_Hour_Threshold: "Umbral de horas de sobretiempo",
    Overtime_PayType: "Forma de pago de sobretiempo",
    Overtime_PayType_Priority: "Forma de pago de sobretiempo",
    Enable_Double_Overtime: "Habilitar sobretiempo doble",
    Double_Overtime_Hour_Threshold: "Umbral de sobretiempo doble",
    Double_Overtime_PayType: "Forma de pago de sobretiempo doble",
    Days_Worked_To_Trigger_Overtime: "Días trabajados para activar sobretiempo",
    DoubleOvertimeHourThreshold_should_be_greater_than_OvertimeHourThreshold: "Debe ser mayor que OT",
    Filter_By_Punch_Hierarchy: "Filtrar por jerarquía de marcación",
    Enable_Create_Empty_Timecard: "Habilitar la creación de una tarjeta de control de tiempo vacía",
    Delete_Selected_Position: "Eliminar el(los) puesto(s) seleccionado(s)",
    Are_you_sure_you_want_to_delete_the_selected_position: "¿Está seguro de que desea eliminar el(los) puesto(s) seleccionado(s)?",
    Integration: "Integración",
    ScheduledJobs: "Trabajos programados",
    Export_To_Third_Party: "Exportar a terceros",
    Supported_file_types: "Tipos de archivo admitidos",
    This_file_format_is_not_supported: "Este formato de archivo no es compatible",
    Maximum_File_Size: "Tamaño máximo de archivo",
    This_file_size_is_too_large: "Este tamaño de archivo es demasiado grande",
    Punch_Details: "Detalles de la marcación",
    Require_Punch_Pre_Screen_Questions: "Requerir preguntas previas a la pantalla de marcación",
    PreQuestionNote1: 'Nota: Todas las preguntas deben ser del tipo "sí" o "no". Las preguntas requieren una respuesta "NO".',
    PreQuestionNote2: 'Cualquier respuesta "SÍ" evitará la marcación y creará una excepción de "Pregunta previa".',
    Introduction_Page_Message_Lang: "Mensaje de la página de introducción {0}",
    Question_Num: "Pregunta {0} {1}",
    Punch_Questions_for_x: "Preguntas sobre la marcación para {0}",
    Question_Exception: "Excepción de la pregunta",
    Quest_Fail: "Error en la pregunta",
    Punch: "Marcación",
    Screening: "Detección",
    Limit_To_Shift_Hierarchy: "Límite para la jerarquía de turnos",
    Invalid_registration_code_format: "Formato de código de registro no válido",
    Failed_to_update_device: "Error al actualizar dispositivo",
    Registration_code_used_already: "Código de registro ya utilizado",
    Device_registered_successfully: "El dispositivo se registró correctamente",
    Are_you_sure_you_want_to_export_to_third_party: "¿Está seguro de que desea exportar a terceros?",
    Estimated_Time_Report: "Informe del tiempo estimado",
    In_Out_Report: "Informe de entrada/salida",
    Are_you_sure_you_want_to_download_the_In_Out_Report: "¿Está seguro de que desea descargar el informe de entrada/salida?",
    Are_you_sure_you_want_to_download_the_Estimated_Time_Report_for_selected_option: "¿Está seguro de que desea descargar el informe de tiempo estimado para la opción seleccionada?",
    Estimated_Time_Report_Type: "Tipo de informe del tiempo estimado",
    Restrict_To_Dates: "Restringir a fechas",
    Download_PDF: "Descargar PDF",
    Add_Job: "Agregar trabajo",
    Add_Punch_Rule: "Agregar regla de marcación",
    Punch_Rule: "Regla de marcación",
    Add_Client: "Agregar cliente",
    Job_ID_is_duplicated: "La identificación del trabajo está duplicada",
    Cost_Code_is_duplicated: "El código de costo está duplicado",
    Cost_Center_is_duplicated: "El centro de costos está duplicado",
    Punch_hierarchy_is_invalid: "La jerarquía de marcación no es válida",
    Punches_are_not_allowed_at_Account_level: "No se permiten marcaciones a nivel de cuenta",
    Master_schedule: "Horario principal",
    Master_Schedules: "Horarios principales",
    Schedule_removed_successfully: "Horario(s) eliminado(s) con éxito",
    Next_Post_Date: "Fecha de la siguiente publicación",
    Add_New_Master_Schedule: "Agregar nuevo horario principal",
    Master_Schedule_Active: "Horario principal activo",
    Post_Schedules_In_Advance_Days: "Publicar horarios con anticipación (días)",
    Copy_Schedule_to: "Copiar horario a",
    Schedule_Report: "Informe de horario",
    Template: "Plantilla",
    Select_Template: "Seleccionar plantilla",
    Template_from: "Plantilla desde",
    Allow_Job: "Permitir trabajo",
    Warning_If_you_dont_input_an_Agreement_it_will_be_off: "Advertencia: Si no ingresa un acuerdo, será desactivado",
    Successfully_created: "Creado correctamente",
    Move: "Mover",
    old_data_saving_error: "Error, Algo salió mal. Es posible que tenga datos antiguos. Por favor, actualice y pruebe de nuevo.",
    the_endpoint_has_not_ticks: "Error, el punto final no tiene marcas de verificación. Comuníquese con el servicio de asistencia.",
    Default_Punch_Job: "Trabajo de marcación predeterminado",
    Default_Punch_Phase: "Etapa de marcación predeterminada",
    Default_cannot_be_outside_the_Punch_Permission_Hierarchy: "El valor predeterminado no puede estar fuera de la jerarquía de los permisos de marcación.",
    Organization_Hierarchy: "Jerarquía de la organización",
    Punch_Default_Settings: "Configuración predeterminada de marcación",
    Schedule_Payroll_Settings: "Configuración del horario y de la nómina",
    Field: "Campo",
    User_Policy: "Política de usuario",
    User_Information: "Información del usuario",
    Hire_Date: "Fecha de contratación",
    Exempt: "Exento",
    User_Agency: "Agencia",
    No_Hire_Date: "Sin fecha de contratación",
    Termination_Date: "Fecha de cese",
    No_Termination_Date: "Sin fecha de cese",
    Latest_rehire_Date: "Última fecha de recontratación",
    No_Rehire_Date: "Sin fecha de recontratación",
    Punch_Permission_Hierarchy: "Jerarquía de permisos de marcación",
    Punch_Audit_Records: "Registros de auditoría de marcación",
    Punch_Perm_Hierarchy: "Jerarquía de permisos de marcación",
    Punch_Hierarchy: "Jerarquía de marcación",
    Are_you_sure_you_want_to_remove_current_Hierarchy_Item_from_selected_Employee: "¿Está seguro de que desea eliminar el elemento de jerarquía actual de los empleados seleccionados?",
    Enable_Phases: "Habilitar etapas",
    Enable_CWM: "Habilitar administrador de ventanas (CWM)",
    Enabled: "Habilitado",
    Expenses: "Gastos",
    One_Time_Expense: "Plantilla de gastos por única vez",
    Recurring_Expense: "Plantilla de gastos recurrentes",
    No_Expense_Found: "No se encontró ningún gasto",
    Frequency: "Frecuencia",
    Frequency_Description: "El gasto se aplicará al primer turno de la frecuencia especificada. Por ejemplo, el gasto se aplicará al primer turno de la semana si se selecciona Semanal.",
    Pick_a_date: "Seleccione una fecha",
    User_Match_Filter: "Filtro de coincidencia de usuario",
    Require_Occupation: "Se requiere coincidencia de ocupación",
    Require_Speciality: "Se requiere coincidencia de especialidad",
    Require_Badge_Match: "Se requiere coincidencia de credencial",
    Require_Complete_Badge: "Se requiere credencial para completar",
    Allow_Partial_Badge: "Se permite credencial parcialmente completada",
    Match_User_Status: "Coincidencia por estado de usuario",
    Select_Status: "Seleccionar estado",
    Substatus: "Subestado",
    Filter_Name: "Nombre del filtro",
    No_Badge_Found: "No se encontró ninguna credencial",
    No_Specialty_Found: "No se encontró ninguna especialidad",
    No_Occupation_Found: "No se encontró ninguna ocupación",
    Requested_Jobs: "Empleos solicitados",
    No_Requested_Jobs_Found: "No se encontraron empleos solicitados",
    Show_Inactive: "Mostrar inactivos",
    Accrual_Adjustment_Rules: "Reglas de ajuste de provisiones",
    Require_Adjustment_Note: "Requerir nota de ajuste",
    Require_Adjustment_Reason: "Requerir motivo de ajuste",
    Adjustments: "Ajustes",
    Adjustment: "Ajuste",
    No_Adjustment_Found: "No se encontraron ajustes",
    Allow_Manual_Adjustment: "Permitir el ajuste manual",
    Adjustment_Value: "Valor del ajuste",
    Add_Accrual_Adjustment: "Aregar ajuste de provisión",
    Edit_Accrual_Adjustment: "Editar ajuste de provisión",
    Manual_Accrual_Adjustment: "Ajuste manual de provisión",
    Adjustment_Reason: "Motivo del ajuste",
    Current_Value: "Valor actual",
    Enable_Manual_Accrual_Adjustment: "Habilitar ajuste manual de provisión",
    Confirm_delete_adjustment: "¿Está seguro de que desea eliminar los 'ajustes' seleccionados?",
    Adjustment_Selected: "1 ajuste seleccionado",
    x_Adjustment_Selected: "{0} ajuste seleccionado",
    Current_selected_date_range_is_outside_of_the_Job_date_range: "Current selected date range is outside of the Job's date range",
    Current_selected_day_is_outside_of_the_Job_date_range: "El día seleccionado actualmente está fuera del rango de fechas del trabajo",
    One_job_can_be_assigned: "No se puede asignar más de un trabajo cuando se selecciona un empleado",
    Employee_can_not_be_selected: "No se puede seleccionar el empleado cuando se asigna más de un turno",
    Client_Type: "Tipo de cliente",
    Choose_client_type: "Elegir tipo de cliente",
    No_client_type_found: "No se encontró ningún tipo de cliente",
    Mass_Shift_Edit: "Editar turno masivo",
    Mass_Edit: "Edición masiva",
    x_Editing_Mass_Shifts: "Está editando {0} trabajos/turnos. Puede editar el estado activo, la hora de inicio, la hora de finalización, el estado del trabajo personalizado y las notas",
    x_Editing_Mass_Shifts_For_CRM_Disabled: "Está editando {0} trabajo(s). Puede editar el estado activo y las notas",
    Edit_Shift_Start_Time: "Editar la hora de inicio del turno",
    Edit_Shift_End_Time: "Editar la hora de finalización del turno",
    Add_Note: "Agregar nota",
    New_Start_Time: "Nueva hora de inicio",
    New_End_Time: "Nueva hora de finalización",
    Edit_Job_Status: "Editar estado de trabajo personalizado",
    Edit_Job_Active_Status: "Editar estado del trabajo activo",
    Review_Changes: "Revisar cambios",
    Confirm_Changes: "Confirmar cambios",
    Client_Jobs_Report: "Informe de los trabajos del cliente",
    Auto_Assign_Shift: "Autoasignar turno",
    Confirmed_Work: "Trabajo confirmado",
    Distance_To_Job: "Distancia al trabajo",
    Shift_Edit_Error_Message: "No se puede editar porque el(los) trabajo(s) seleccionado(s) tiene(n) varios turnos",
    HR: "RECURSOS HUMANOS",
    TLM: "TLM",
    Successfully_archived: "Se archivó correctamente",
    Successfully_shortlisted: "Se preseleccionó correctamente",
    Successfully_assigned: "Se asignó correctamente",
    Assign_Employee: "Asignar empleado",
    Oepn_Detail_In_New_Tab: "Abrir detalles en una pestaña nueva",
    Filter_Only_Worker_Pool: "Filtrar solo grupo de trabajadores",
    Guaranteed_Minimum: "Mínimo garantizado",
    Meal_Penalty_Waiver: "Exención de penalización por comida",
    Bonus_Pay: "Pago de bonificación",
    Full_Timecard_Punch_Rules: "Reglas completas de marcación de la tarjeta de control de tiempo",
    Incorrect_CSV_File: "Archivo CSV incorrecto Suba el correcto.",
    Expand_All_Timecards: "Expandir todas las tarjetas de control de tiempo",
    Collpase_All_Timecards: "Contraer todas las tarjetas de control de tiempo",
    CannotUpdateTimecardAllowModifications: "No se pueden actualizar las modificaciones de permisos de la tarjeta de control de tiempo",
    Time_Of_Punch: "Hora de marcación",
    Time_Of_Punch_Upload: "Hora de carga de marcación",
    Exported_Successfully: "Se exportó correctamente",
    Export: "Exportar",
    Filter_Template: "Plantilla de filtro",
    Filter_Saved: "Se guardó el filtro.",
    Filter_Updated: "Se actualizó el filtro.",
    Filter_Deleted: "Se eliminó el filtro.",
    Delete_Filter: "Eliminar el filtro",
    Employee_Details: "Detalles del empleado",
    Exmpet_Employee: "Empleado exento",
    Self_Service_Login_Enabled: "Se habilitó el inicio de sesión de autoservicio.",
    Employee_Default_Hierarchy: "Jerarquía predeterminada del empleado",
    Click_To_Select_Job: "Haga clic para seleccionar el trabajo",
    Supervisors: "Supervisores",
    This_name_is_not_allowed: "Este nombre no está permitido.",
    Save_Filter: "Guardar filtro",
    Edit_Employee_Filter: "Editar filtro de empleados",
    Create_New_Employee_Filter: "Crear nuevo filtro de empleado",
    Create_Filter_Template_Title_Intro:
        "¡Cree un filtro guardado para facilitar la búsqueda! Nombre este filtro, seleccione los parámetros y haz clic en Guardar. Siempre puede editar este filtro, incluso después de guardarlo.",
    Edit_Filter_Template_Title_Intro: 'Edite los detalles de este filtro personalizado y haga clic en "Guardar filtro" a continuación para que los cambios surtan efecto.',
    Filter_with_this_name_already_exist: "Ya existe un filtro con este nombre",
    Define_Retro_Pay_Code: "Definir forma de pago retroactivo",
    Retro_Pay_Type_Code: "Forma de pago retroactivo",
    Export_Diff_Timecard: "Exportar cambios de la tarjeta de control de tiempo",
    Export_Diff_Disclaimer:
        "Las diferencias en la tarjeta de control de tiempo se pueden exportar a períodos de pago futuros. Seleccione un período de pago futuro y los cambios se colocarán en la tarjeta de control de tiempo del usuario en el período de pago correspondiente.",
    Export_pay_period_should_be_future_from_timecard_pay_period: "El período de pago de exportación debe ser posterior al período de pago de la tarjeta de control de tiempo.",
    Failed_Export_Timecard_Diff: "Error al exportar las diferencias en la tarjeta de control de tiempo",
    The_timecard_export_is_only_allowed_in_future_unlocked_pay_periods:
        "Solo se permite exportar la tarjeta de control de tiempo en períodos de pagos futuros desbloqueados. \nCompruebe que el período de pagos de destino es futuro y que aún no se ha bloqueado.",
    Exporting_Diff_Timecard_Reason: "Motivo de cambio del período anterior",
    Exporting_Diff_Timecard_Reason_Required: "Se requiere el motivo",
    ReExport: "Volver a exportar",
    View_Custom_Employee_Fields: "Ver campos personalizados del empleado",
    Edit_Custom_Employee_Fields: "Editar campos personalizados del empleado",
    Edit_Custom_Job_Fields: "Editar campos personalizados del trabajo",
    Custom_Field: "Campo personalizado",
    Position_Field: "Campo de posición",

    Change_Made_By_GlobalAdmin: "Cambio realizado por el administrador global",
    Allow_Client_Selection_Edit: "Permitir edición de selección del cliente",
    View_Jobs: "Ver trabajos",
    Add_Jobs: "Agregar trabajos",
    Edit_Jobs: "Editar trabajos",
    Delete_Jobs: "Eliminar trabajos",
    View_Clients: "Ver clientes",
    Add_Clients: "Agregar clientes",
    Edit_Clients: "Editar clientes",
    Delete_Clients: "Eliminar clientes",
    Edit_Custom_Client_Fields: "Editar campos de cliente personalizados",
    Job_Field: "Campo laboral",
    Phase_Field: "Campo de fase",
    Employee_Field: "Campo de empleado",
    Client_Field: "Campo de cliente",
    Application_Of_Auto_Break: "Aplicación de descanso automático",
    Auto_Break_Tooltip_Heading_Info_Text: "Esta configuración determina cómo se aplicará el descanso automático.",
    Auto_Break_Tooltip_Based_On_Punch_Info_Text:
        "Si se configura en un elemento jerárquico, el empleado deberá marcar este elemento jerárquico o uno inferior, o en un trabajo adjunto a este elemento jerárquico para que se aplique el descanso automático.",
    Auto_Break_Tooltip_Employee_Default_Hierarchy_Info_Text:
        "Si se configura en un elemento jerárquico, los empleados con este elemento jerárquico como su jerarquía predeterminada siempre obtendrán este descanso automático, sin importar en que lugar de la jerarquía marquen (siempre y cuando se cumplan los requisitos de descanso automático).",
    Show_Consolidated_Timecard_View: "Mostrar vista consolidada de la tarjeta de control de tiempo",
    AveragePayRate: "Tasa promedio basada en el tiempo total registrado por la forma de pago",
    OvertimeFactor: "Factor de OT",
    DoubleOvertimeFactor: "Factor de OT2",
    Budget: "Presupuesto",
    No_weekly_job_budget_items_found: "No se encontraron partidas del presupuesto para el trabajo semanal",
    WeeklyHourlyBudget: "Presupuesto semanal por hora",
    WeeklyAmountBudget: "Presupuesto del monto semanal",
    NewJobBudgetItem: "Nueva partida del presupuesto de trabajo",
    EditJobBudgetItem: "Editar partida del presupuesto de trabajo",
    RegularTimeLabel: "Regular (REG)",
    OvertimeLabel: "OT",
    DoubleOvertimeLabel: "OT2",
    BudgetedHours: "Horas presupuestadas",
    VarianceHours: "Variación de horas",
    BudgetedAmount: "Suma presupuestada",
    VarianceAmount: "Monto de la variación",
    Are_you_sure_you_want_to_delete_selected_budgets: "¿Está seguro de que desea eliminar las partidas presupuestarias seleccionadas?",
    Budget_Selected: "Partida presupuestaria seleccionada",
    x_Budgets_Selected: "{0} Partidas presupuestarias seleccionadas",
    Account_PEPM: "Cuenta PEPM",
    Six_Minute_Rounding_Rule: "Regla de redondeo de 6 minutos",
    One_Minute_Rounding_Rule: "Regla de redondeo de 1 minuto",
    Add_New_Account: "Agregar nueva cuenta",
    Save_Account: "Guardar cuenta",
    Loading_Account_Details: "Cargando detalles de la cuenta",
    Open_Account: "Abrir cuenta",
    Next: "Siguiente",
    Previous: "Anterior",
    SendWelcomeEmail: "Enviar correo electrónico de bienvenida",
    AccountOwner: "Titular de la cuenta",
    AccountOwnerFirstName: "Nombre del titular de la cuenta",
    AccountOwnerLastName: "Apellido del titular de la cuenta",
    AccountOwnerEmail: "Correo electrónico del titular de la cuenta",
    AccountName: "Nombre de la cuenta",
    Finish: "Finalizar",
    AccountActivity: "Actividad de la cuenta",
    AccountSubscriptionOverview: "Descripción general de la suscripción",
    AccountBillingHistory: "Historial de facturación",
    RecentInvoices: "Facturas recientes",
    AccountBillingContact: "Contacto de facturación",
    AccountPaymentMethod: "Forma de pago",
    Are_You_Sure_You_Want_To_Remove_This_Payment_Method: "¿Está seguro de que desea eliminar esta forma de pago?",
    RemoveCard: "Retire la tarjeta",
    AddPaymentMethod: "+ Agregar método de pago",
    Future_payments_will_use_this_card: "Los pagos futuros utilizarán esta tarjeta.",
    DueDate: "Fecha de vencimiento",
    PaymentMethodMustBeSetup:
        "Se debe configurar un método de pago antes de poder actualizar el plan desde la versión gratuita. Haga clic en la pestaña 'Forma de pago' para agregar una tarjeta de crédito a su cuenta.",
    UpgradeToProfessionalPrompt: "¿Está seguro de que desea actualizar a Professional?",
    Upgrade: "Actualizar",
    TalkToSales: "Hablar con Ventas",
    SelectedPlan: "Plan seleccionado",
    PerEmployee: "Por empleado",
    Column_Selector_One_Column_Error_Message_Text: "No se pueden ocultar todas las columnas. Al menos una columna debe mostrarse en la tabla",
    Additional_Filter_Parameter: "Parámetro de filtro adicional",
    Add_Filter_Parameter: "Agregar parámetro del filtro",
    Edit_Filter_Parameter: "Editar parámetro del filtro",
    Add_Filter_Parameter_Text1: "Filtrar empleados que tienen el",
    Add_Filter_Parameter_Text2: "alternar lo establecido en",
    ON: "ENCENDIDO",
    OFF: "APAGADO",
    Add_To_Favorite: "Agregar a favoritos",
    Remove_From_Favorite: "Eliminar de favoritos",
    Add_To_Favorite_Message_Text: "se agregó a sus favoritos",
    Remove_From_Favorite_Message_Text: "se eliminó de sus favoritos",
    Job_Filter: "Filtro de trabajos",
    Favorites: "Favoritos",
    AccountSetup: "Configuración de la cuenta",
    TakeTour: "Hacer una visita",
    RetakeTour: "Volver a hacer una visita",
    EnableWorkflows: "Habilitar flujos de trabajo",
    Enable_ATS: "Habilitar ats",
    Enable_Message_Center:"Habilitar centro de mensajes",
    Hide_Parent_PunchSets_In_Payroll: "Ocultar conjuntos de registros principales en nómina",
    Enable_Simple_Work_Preferences: "Habilitar preferencias de trabajo simples",
    Enable_GeoFence_Tracking: "Habilitar el seguimiento de GeoFence",
    Plan: "Planificar",
    PLG: "PLG",
    Marketing: "Marketing",
    Total_PEPM: "PEPM total (excluida la base)",
    SignUp_Date: "Fecha de registro",
    Industry: "Sector",
    Self_Reported_Employee_Size: "Tamaño de empleados autodeclarado",
    ProxyNotValidTitle: "Error de invitado de cuenta",
    ProxyNotValidDetails:
        "El inicio de sesión del invitado de la cuenta ya no es válido. Esto puede ocurrir porque abrió otra cuenta de invitado desde el Administrador de cuenta. Cierre esta pestaña para continuar.",
    BuildingServicesAndMaintanence: "Servicios y mantenimiento de edificios",
    Construction: "Construction",
    HealthCare: "Cuidado de la salud",
    Janitorial: "Conserjería",
    Manufacturing: "Fabricación",
    Security: "Seguridad",
    TempStaffing: "Dotación de personal temporal",
    ZeroTo10: "0-10",
    TenTo50: "10-50",
    FiftyTo250: "50-250",
    TwoFiftyTo500: "250-500",
    FiveHundredTo1500: "500-1500",
    FifteenHundredPlus: "+1500",
    GreaterThan10000: "> 10,000",
    FinddTestAccount: "Encontrar cuenta de prueba",
    SalesDemoAccount: "Cuenta de demostración de ventas",
    EmployeePunchedLastMonth: "Empleado que marcó el mes pasado",
    EmployeePunchedCurrentMonth: "Empleado que marcó el mes actual",
    BaseFee: "Tasa base",
    YearlyIncrease: "Incremento anual",
    UTMSource: "Fuente UTM",
    UTMMedium: "Medio UTM",
    UTMCampaign: "Campaña UTM",
    UTMTerm: "Término UTM",
    UTMContent: "Contenido UTM",
    AdId: "Identificador de anuncios",
    AdsetId: "Identificador de un grupo de anuncios",
    CampaignId: "Identificador de campaña",
    AdName: "Nombre del anuncio",
    AdsetName: "Nombre del grupo de anuncios",
    CampaignName: "Nombre de la campaña",
    Placement: "Ubicación",
    SiteSourceName: "Nombre de la fuente del sitio web",
    LandingPage: "Página de destino",
    SendMobileAppSMS: "Enviar enlace de aplicación móvil",
    SendMessage: "Send Message",
    ReSendMobileAppSMS: "Reenviar enlace de aplicación móvil",
    MobileAppPhoneLabel: "Número de celular",
    Enter_Valid_Mobile_Number: "Introduzca un número de celular válido",
    App_Link_Sent: "Se envió el enlace de la aplicación móvil Revise su teléfono.",
    Client: "Cliente",
    Account_Manager_Admin: "Gestor de la cuenta de administración",
    PLG_Setup: "Configuración de PLG",
    PEPM: "PEPM",
    Date_Created: "Fecha de creación",
    Date_Updated: "Fecha de actualización",
    Training: "Capacitación",
    AccountActive: "Cuenta activa",
    AccountManager: "Gestor de la cuenta",
    Select_Account_For_Which_You_Want_To_Add_Scheduled_Job: "Seleccione la cuenta para la que desea agregar el trabajo programado",
    Select: "Seleccionar",
    Findd_Grandd_Central: "Findd Grandd Central",
    Findd_Account_Manager: "Gestor de cuentas Findd",
    Release_Updates: "Actualizaciones de la versión",
    Release_Update_Text: "Manténgase al día sobre las novedades de Findd a medida que lanzamos las nuevas características de Grandd Central y de la aplicación móvil.",
    Grandd_Central_Notification: "Notificación de Grandd Central",
    Marketing_Funnel: "Embudo de marketing",
    Potential_Clients_In_Funnel: "Clientes potenciales en el embudo",
    CAC: "CAC",
    LTV: "LTV",
    Cost_Per: "Costo por",
    Stage: "Etapa",
    Company_Type: "Tipo de empresa",
    Company_Size: "Tamaño de la empresa",
    Marketing_Info: "Información de marketing",
    Enter_Stage_Date: "Ingrese la fecha de la etapa",
    No_Of_Punching_Employees: "Nro. De empleados que marcan (la tarjeta de control de tiempo)",
    Total_Potential_Employees: "Total de empleados potenciales",
    Total_Expected_Employees: "Total de empleados esperados",
    Earnings_PEPM: "Ganancias PEPM (por empleado por mes)",
    Account_Manager_User_Selected: "1 usuario gestor de cuentas seleccionado",
    x_Account_Manager_User_Selected: "{0} usuario gestor de cuentas seleccionado",
    No_User_Found: "No se encontró ningún usuario",
    Account_Manager_Users: "Usuarios del gestor de cuentas",
    User_Permissions: "Permisos del usuario",
    View_Account_Manager_Users_Tab: "Ver pestaña de Usuarios del gestor de cuentas",
    View_System_Tab: "Ver pestaña del Sistema",
    View_Account_Manager_Clients: "Ver Clientes del gestor de cuentas",
    Edit_Account_Manager_Client_Details: "Editar detalles del Cliente del gestor de cuentas",
    Add_Account_Manager_Client_Account: "Agregar cuenta del Cliente del gestor de cuentas",
    Enter_Client_Account: "Ingresar la cuenta del cliente",
    Accrual_Balance_Report: "Informe de saldo de provisión",
    Are_you_sure_you_want_to_download_the_Accrual_Balance_Report: "¿Está seguro de que desea descargar el Informe del saldo de provisiones?",
    To_which_Account_Manager_you_want_to_Navigate: "¿A qué gestor de cuentas desea dirigirse?",
    Monthly_Minimum: "Mínimo mensual",
    Account_Type: "Tipo de cuenta",
    Test_Account: "Cuenta de prueba",
    Client_Account: "Cuenta de cliente",
    Demo_Account: "Cuenta de demostración",
    View_Scheduled_Jobs: "Ver trabajos programados",
    Allow_Client_Viewing: "Permitir la visualización del cliente",
    Client_Can_View: "El cliente puede ver",
    Job_Type: "Tipo de trabajo",
    All_Client_Scheduled_Jobs: "Todos los trabajos programados por el cliente",
    Client_Accessible_Scheduled_Jobs: "Trabajos programados accesibles al cliente",
    Non_Client_Accessible_Scheduled_Jobs: "Trabajos programados accesibles para no clientes",
    AllowPunchFromPersonalDevice: "Permitir marcar desde un dispositivo personal",
    SelfServiceLoginEnabled: "Se habilitó el inicio de sesión de autoservicio.",
    MobileAgreementAccepted: "Acuerdo Findd aceptado",
    AccountAgreementAccepted: "Acuerdo de cuenta aceptado",
    UserModified: "Usuario modificado",
    Agency: "Agencia",
    AssignPotentialClientRelationshipManager: "Asignar un posible gestor de relaciones con el cliente",
    RelationshipManager: "Gestor de relaciones",
    Filter_By_Account: "Filtrar por cuenta",
    Export_Failed_Punches: "Exportar marcaciones fallidas",
    View_Time_Reports: "Ver informes de tiempo",
    Employee_Import: "Importar empleados",
    Are_you_sure_you_want_to_import_employees_This_cannot_be_undone: "¿Está seguro de que desea importar {0} empleados? Esta acción es irreversible.",
    Note_For_Supervisor_Assignment_Column: "Nota para la columna 'Asignación de supervisor'",
    Multiple_Entries_Must_Be_Separated_By: "Las entradas múltiples deben estar separadas por un 'carácter'",
    Download_Sample_File: "Descargar archivo de muestra",
    Shortlist: "Lista de seleccionados",
    Import_Job_Data: "Importar datos de trabajo",
    Are_you_sure_you_want_to_import_jobs_This_cannot_be_undone: "¿Está seguro de que desea importar {0} trabajos? Esta acción es irreversible.",
    Decline: "Rechazar",
    Give_Reason_To_Decline: "Indique el motivo de su rechazo",
    Successfully_declined: "Se rechazó correctamente",
    Decline_Status: "Estado del rechazo",
    Not_Declined: "No rechazado",
    Declined: "Rechazado",
    Already_Declined_Employee: "¡Este empleado ya está rechazado!",
    You_Cant_Decline_Your_Own_Self: "No puede rechazarse a si mismo.",
    New_Job_Shift: "Nuevo turno de trabajo",
    Miles_To_Job: "Millas al trabajo",
    Enable_Note_Attributes: "Habilitar atributos de nota",
    DisableEmployeeApprovalException: "Deshabilitar excepciones de aprobación de empleados",
    DisableSupervisorApprovalException: "Deshabilitar las excepciones de aprobación del supervisor",
    DisableLocationExceptionWhenNoGPS: "Deshabilitar la excepción de ubicación cuando no se establece ninguna jerarquía/GPS de trabajo",
    FillRate: "Fill Rate",
    PotentialCostSavings: "Potential Cost Savings",
    FTERatio: "FTE Factor",
    Disable_Employee_Approval_Exceptions_Notify: "Desactivar notificaciones de excepciones de aprobación de empleados",
    Disable_Supervisor_Approval_Exception_Notify: "Deshabilitar la notificación de excepciones de aprobación del supervisor",
    Disable_Creating_Location_Exception_When_No_GPS: "Deshabilitar la creación de una excepción de ubicación cuando no se establece ninguna jerarquía/GPS de trabajo",
    MedicalAccount: "Is Medical Account",
    DefaultCountry: "Default Country",
    Edit_Job_Location: "Editar ubicación de trabajo",
    Dashboard_For_x: "Tablero del {0}",
    Data_as_of_x: "Datos al {0}",
    Workforce_Optimization: "Workforce Optimization",
    Cost_Savings: "Cost Savings",
    Message_Group_Name: "Message Group Name",
    SentBy: "Sent By",
    Message_Members: "Members",
    Sent: "Sent",
    Message_Context: "Context",
    AutoReplyChatGPT: "Auto Reply to SMS using Chat GPT",
    EnableBlendedRateOT: "Enable Blended Rate OT",
    VIEW_ACCOUNT_SETTINGS_PIPELINES: "View Pipeline Settings",
    ADD_ACCOUNT_SETTINGS_PIPELINES: "Add Pipeline Settings",
    DELETE_ACCOUNT_SETTINGS_PIPELINES: "Delete Pipeline Settings",
    EDIT_ACCOUNT_SETTINGS_PIPELINES: "Edit Pipeline Settings",
    VIEW_ACCOUNT_SETTINGS_BADGES: "View Badge Settings",
    ADD_ACCOUNT_SETTINGS_BADGES: "Add Badge Settings",
    DELETE_ACCOUNT_SETTINGS_BADGES: "Delete Badge Settings",
    EDIT_ACCOUNT_SETTINGS_BADGES: "Edit Badge Settings",
    VIEW_ACCOUNT_SETTINGS_CREDENTIALS: "View Credential Settings",
    ADD_ACCOUNT_SETTINGS_CREDENTIALS: "Add Credential Settings",
    DELETE_ACCOUNT_SETTINGS_CREDENTIALS: "Delete Credential Settings",
    EDIT_ACCOUNT_SETTINGS_CREDENTIALS: "Edit Credential Settings",
    VIEW_ACCOUNT_SETTINGS_FILES: "View File Settings",
    ADD_ACCOUNT_SETTINGS_FILES: "Add File Settings",
    DELETE_ACCOUNT_SETTINGS_FILES: "Delete File Settings",
    EDIT_ACCOUNT_SETTINGS_FILES: "Edit File Settings",
    VIEW_ACCOUNT_SETTINGS_USERS: "View User Settings",
    ADD_ACCOUNT_SETTINGS_USERS: "Add User Settings",
    DELETE_ACCOUNT_SETTINGS_USERS: "Delete User Settings",
    EDIT_ACCOUNT_SETTINGS_USERS: "Edit User Settings",
    VIEW_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "View Notes & Checklist Settings",
    ADD_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Add Notes & Checklist Settings",
    DELETE_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Delete Notes & Checklist Settings",
    EDIT_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Edit Notes & Checklist Settings",
    VIEW_ACCOUNT_SETTINGS_HR_JOBS: "View HR Job Settings",
    ADD_ACCOUNT_SETTINGS_HR_JOBS: "Add HR Job Settings",
    DELETE_ACCOUNT_SETTINGS_HR_JOBS: "Delete HR Job Settings",
    EDIT_ACCOUNT_SETTINGS_HR_JOBS: "Edit HR Job Settings",
    VIEW_ACCOUNT_SETTINGS_INTEGRATIONS: "View Integration Settings",
    ADD_ACCOUNT_SETTINGS_INTEGRATIONS: "Add Integration Settings",
    DELETE_ACCOUNT_SETTINGS_INTEGRATIONS: "Delete Integration Settings",
    EDIT_ACCOUNT_SETTINGS_INTEGRATIONS: "Edit Integration Settings",
    VIEW_PIPELINES: "View Pipelines",
    ADD_PIPELINES: "Add Pipelines",
    DELETE_PIPELINES: "Delete Pipelines",
    EDIT_PIPELINES: "Edit Pipelines",
    VIEW_BADGES: "View Badges",
    ADD_BADGES: "Add Badges",
    DELETE_BADGES: "Delete Badges",
    EDIT_BADGES: "Edit Badges",
    VIEW_HR_PEOPLE: "View HR People",
    ADD_HR_PEOPLE: "Add HR People",
    DELETE_HR_PEOPLE: "Delete HR People",
    EDIT_HR_PEOPLE: "Edit HR People",
    VIEW_CREDENTIALS: "View Credentials",
    ADD_CREDENTIALS: "Add Credentials",
    DELETE_CREDENTIALS: "Delete Credentials",
    EDIT_CREDENTIALS: "Edit Credentials",
    VIEW_DEMOGRAPHICS: "View Employee Demographics",
    EDIT_DEMOGRAPHICS: "Edit Employee Demographics",
    VIEW_GOVERNMENT_ID: "View Government Id",
    EDIT_GOVERNMENT_ID: "Edit Government Id",
    VIEW_CONTACT_INFO: "View Employee Contact Info",
    EDIT_CONTACT_INFO: "Edit Employee Contact Info",
    VIEW_LANGUAGE_ETHNICITY: "View Language & Ethnicity",
    EDIT_LANGUAGE_ETHNICITY: "Edit Language & Ethnicity",
    VIEW_EMPLOYEE_SPECIALTIES: "View Employee Specialities",
    ADD_EMPLOYEE_SPECIALTIES: "Add Employee Specialities",
    EDIT_EMPLOYEE_SPECIALTIES: "Edit Employee Specialities",
    DELETE_EMPLOYEE_SPECIALTIES: "Delete Employee Specialities",
    VIEW_EMPLOYEE_FILES: "View Employee Files",
    EDIT_EMPLOYEE_FILES: "Edit Employee Files",
    ADD_EMPLOYEE_FILES: "Add Employee Files",
    DELETE_EMPLOYEE_FILES: "Delete Employee Files",
    VIEW_EMPLOYEE_WORK_HISTORY: "View Employee Work History",
    ADD_EMPLOYEE_WORK_HISTORY: "Add Employee Work History",
    EDIT_EMPLOYEE_WORK_HISTORY: "Edit Employee Work History",
    DELETE_EMPLOYEE_WORK_HISTORY: "Delete Employee Work History",
    VIEW_EMPLOYEE_EDUCATION: "View Employee Education",
    ADD_EMPLOYEE_EDUCATION: "Add Employee Education",
    EDIT_EMPLOYEE_EDUCATION: "Edit Employee Education",
    DELETE_EMPLOYEE_EDUCATION: "Delete Employee Education",
    VIEW_EMPLOYEE_CREDENTIALS: "View Employee Credentials",
    ADD_EMPLOYEE_CREDENTIALS: "Add Employee Credentials",
    EDIT_EMPLOYEE_CREDENTIALS: "Edit Employee Credentials",
    DELETE_EMPLOYEE_CREDENTIALS: "Delete Employee Credentials",
    VIEW_EMPLOYEE_CHECKLISTS: "View Employee Checklists",
    ADD_EMPLOYEE_CHECKLISTS: "Add Employee Checklists",
    EDIT_EMPLOYEE_CHECKLISTS: "Edit Employee Checklists",
    DELETE_EMPLOYEE_CHECKLISTS: "Delete Employee Checklists",
    VIEW_EMPLOYEE_REFERENCES: "View Employee References",
    ADD_EMPLOYEE_REFERENCES: "Add Employee References",
    EDIT_EMPLOYEE_REFERENCES: "Edit Employee References",
    DELETE_EMPLOYEE_REFERENCES: "Delete Employee References",
    VIEW_EMPLOYEE_BADGES: "View Employee Badges",
    ADD_EMPLOYEE_BADGES: "Add Employee Badges",
    EDIT_EMPLOYEE_BADGES: "Edit Employee Badges",
    DELETE_EMPLOYEE_BADGES: "Delete Employee Badges",
    VIEW_EMPLOYEE_REWARDS: "View Employee Rewards",
    ADD_EMPLOYEE_REWARDS: "Add Employee Rewards",
    EDIT_EMPLOYEE_REWARDS: "Edit Employee Rewards",
    DELETE_EMPLOYEE_REWARDS: "Delete Employee Rewards",
    ALLOW_CHANGE_STATUS_VIA_PIPELINE: "Cambiar estado/subestado a través de canalización",
    ALLOW_CHANGE_STATUS_VIA_PROFILE_PAGE: "Cambiar estado/subestado a través de la página de perfil",
    ALLOW_CHANGE_EMAIL: "Change Email",
    ALLOW_CHANGE_MOBILE: "Change Number",
    HR_SETTINGS: "HR Settings",
    HR_USER_ACCESS: "HR User Access",
    HR_PEOPLE_ACCESS: "HR People Access",
    HR_MENU_ACCESS: "HR Access",
    HR_PEOPLE_DETAIL_ACCESS: "HR People Detail Access",
    AllowMobileTimecardView: "Show Mobile Timecards",
    AllowMobileWorkView: "Show Mobile Work",
    AllowMobileScheduleView: "Show Mobile Schedules",
    AllowMobileLeaveTrackingView: "Show Mobile Leave Tracking",
    AllowMobileExpensesView: "Show Mobile Expenses",
    AllowMobileAdHocFilesView: "Show Mobile Files",
    ShowJobToMobileUsers: "Advertise Job To Mobile Users",
    Badge_Qualification: "Calificación de la insignia",
    AdHoc_Communication: "Comunicación ad hoc",
    Seniority_Date: "Seniority Date",
    No_Seniority_Date: "No Seniority Date",
    No_Start_Date: "Sin fecha de inicio",
    Show_Thumbnail: "Mostrar miniatura",
    Allow_Minumum_Break_Override: "Permitir anulación de pausa mínima",
    greater_than_Minimum_Break_Duration: "mayor que la duración mínima de descanso",
    Alternate_PayType: "Tipo de pago alternativo",
    Alternate_PayType_if_break_is_less_than: "Tipo de pago alternativo si el descanso es menor que",
    Alternate_PayType_should_be_not_same_with_paytype: "Alternate PayType should be not same with paytype",
    Allow_Minimum_Break_Override: "Allow Minimum Break Override",
    Enable_Didi_Notifications: "Enable Didi Nudging",
    Phone_Number: "Número de teléfono",
    Punch_Rule_Override: "Punch Rule Override",
    Phone_Number_and_Code: "Número de teléfono / Código",
    Biometric_Location_Exceptions_Report: "Biometric Location Exceptions Report",
}

export default es_mx
